webpackJsonp([114276838955818,60335399758886],{

/***/ 166:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Catalog 2019 - 2020"}},"FootertMenu":{"id":"0955ebe3-ef5a-59c0-b872-5a8d760d23dd","slug":"footer-menu","items":[{"title":"Catalog Archives","url":"https://devinstruction.austincc.edu/catalog2019-20/catalog-archives/","wordpress_children":null},{"title":"Annual Disclosures","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/","wordpress_children":[{"title":"Annual Security Report/Clery Act","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/annual-security-reportclery-act/"},{"title":"Copyright Infringement","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/copyright-infringement/"},{"title":"Discrimination Prohibited","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/discrimination-prohibited/"},{"title":"Drug-Free Schools & Communities Act","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/campus-safety-security/drug-free-schools-communities-act/"},{"title":"Family Educational Rights & Privacy Act","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/family-educational-rights-privacy-act/"},{"title":"Financial Aid","url":"https://devinstruction.austincc.edu/catalog2019-20/college-entry/paying-for-college/financial-aid/"},{"title":"Gainful Employment","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/gainful-employment/"},{"title":"Graduation, Transfer & Retention Rates","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/graduation-transfer-retention-rates/"},{"title":"Net Price Calculator","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/net-price-calculator/"},{"title":"Prohibition of Sexual Misconduct","url":"https://devinstruction.austincc.edu/catalog2019-20/support-services-student-progress/students-rights-responsibilities-2/prohibition-of-sexual-misconduct/"},{"title":"Sexual Harassment/Sexual Assault Policies","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/sexual-harassmentsexual-assault-policies/"},{"title":"Student Records","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/student-records/"},{"title":"Students Rights & Responsibilities","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/students-rights-responsibilities/"},{"title":"Textbook Information","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/textbook-information/"},{"title":"Voter Registration","url":"https://devinstruction.austincc.edu/catalog2019-20/about-the-college/annual-disclosures/voter-registration/"}]}]},"about":{"edges":[{"node":{"id":"6717c4a3-2d93-5945-9c2d-7ae76d998ef9","slug":"about-the-catalog","title":"About The Catalog","content":"<p>This catalog is in effect for new students entering ACC in the 2019-2020 academic year and for any ACC student returning in the 2019-2020 academic year whose catalog has expired. It was prepared from existing policies and information obtained from the appropriate ACC officials. The catalog is informational in purpose and does not constitute a contract between ACC and any person or entity.</p>\n<p>You may follow the degree plan requirements described in the catalog in effect at the time you first enrolled at ACC. Or, you may choose to follow the degree plan requirements of a later catalog in effect during your enrollment, as long as the program of study is still offered, the catalog is not more than 5 years old, and you have officially declared the corresponding major.</p>\n<p>ACC reserves the right to make changes in the regulations and offerings announced in this catalog as circumstances require. Each semester the college posts an online schedule listing courses to be offered. Not all courses listed in this catalog are offered each semester. This information is made available to students as early as possible prior to the beginning of each semester.</p>\n<p>Please always check online at <span style=\"text-decoration: underline;\"><a href=\"https://catalog.austincc.edu\" target=\"_blank\" rel=\"noopener noreferrer\">catalog.austincc.edu</a></span> to ensure that you are reading the latest and most accurate information.</p>\n"}}]}},"layoutContext":{}}

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(224);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(166);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 Material Components for the Web
	 Copyright (c) 2018 Google Inc.
	 License: Apache-2.0
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["ripple"] = factory();
		else
			root["mdc"] = root["mdc"] || {}, root["mdc"]["ripple"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 4);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * @template A
	 */
	var MDCFoundation = function () {
	  _createClass(MDCFoundation, null, [{
	    key: "cssClasses",
	
	    /** @return enum{cssClasses} */
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports every
	      // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
	      return {};
	    }
	
	    /** @return enum{strings} */
	
	  }, {
	    key: "strings",
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports all
	      // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
	      return {};
	    }
	
	    /** @return enum{numbers} */
	
	  }, {
	    key: "numbers",
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports all
	      // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
	      return {};
	    }
	
	    /** @return {!Object} */
	
	  }, {
	    key: "defaultAdapter",
	    get: function get() {
	      // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
	      // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
	      // validation.
	      return {};
	    }
	
	    /**
	     * @param {A=} adapter
	     */
	
	  }]);
	
	  function MDCFoundation() {
	    var adapter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, MDCFoundation);
	
	    /** @protected {!A} */
	    this.adapter_ = adapter;
	  }
	
	  _createClass(MDCFoundation, [{
	    key: "init",
	    value: function init() {
	      // Subclasses should override this method to perform initialization routines (registering events, etc.)
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
	    }
	  }]);
	
	  return MDCFoundation;
	}();
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCFoundation);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__foundation__ = __webpack_require__(0);
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	/**
	 * @template F
	 */
	
	var MDCComponent = function () {
	  _createClass(MDCComponent, null, [{
	    key: 'attachTo',
	
	    /**
	     * @param {!Element} root
	     * @return {!MDCComponent}
	     */
	    value: function attachTo(root) {
	      // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
	      // returns an instantiated component with its root set to that element. Also note that in the cases of
	      // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
	      // from getDefaultFoundation().
	      return new MDCComponent(root, new __WEBPACK_IMPORTED_MODULE_0__foundation__["a" /* default */]());
	    }
	
	    /**
	     * @param {!Element} root
	     * @param {F=} foundation
	     * @param {...?} args
	     */
	
	  }]);
	
	  function MDCComponent(root) {
	    var foundation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	    _classCallCheck(this, MDCComponent);
	
	    /** @protected {!Element} */
	    this.root_ = root;
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    this.initialize.apply(this, args);
	    // Note that we initialize foundation here and not within the constructor's default param so that
	    // this.root_ is defined and can be used within the foundation class.
	    /** @protected {!F} */
	    this.foundation_ = foundation === undefined ? this.getDefaultFoundation() : foundation;
	    this.foundation_.init();
	    this.initialSyncWithDOM();
	  }
	
	  _createClass(MDCComponent, [{
	    key: 'initialize',
	    value: function initialize() /* ...args */{}
	    // Subclasses can override this to do any additional setup work that would be considered part of a
	    // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
	    // initialized. Any additional arguments besides root and foundation will be passed in here.
	
	
	    /**
	     * @return {!F} foundation
	     */
	
	  }, {
	    key: 'getDefaultFoundation',
	    value: function getDefaultFoundation() {
	      // Subclasses must override this method to return a properly configured foundation class for the
	      // component.
	      throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' + 'foundation class');
	    }
	  }, {
	    key: 'initialSyncWithDOM',
	    value: function initialSyncWithDOM() {
	      // Subclasses should override this method if they need to perform work to synchronize with a host DOM
	      // object. An example of this would be a form control wrapper that needs to synchronize its internal state
	      // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
	      // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      // Subclasses may implement this method to release any resources / deregister any listeners they have
	      // attached. An example of this might be deregistering a resize event from the window object.
	      this.foundation_.destroy();
	    }
	
	    /**
	     * Wrapper method to add an event listener to the component's root element. This is most useful when
	     * listening for custom events.
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: 'listen',
	    value: function listen(evtType, handler) {
	      this.root_.addEventListener(evtType, handler);
	    }
	
	    /**
	     * Wrapper method to remove an event listener to the component's root element. This is most useful when
	     * unlistening for custom events.
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: 'unlisten',
	    value: function unlisten(evtType, handler) {
	      this.root_.removeEventListener(evtType, handler);
	    }
	
	    /**
	     * Fires a cross-browser-compatible custom event from the component root of the given type,
	     * with the given data.
	     * @param {string} evtType
	     * @param {!Object} evtData
	     * @param {boolean=} shouldBubble
	     */
	
	  }, {
	    key: 'emit',
	    value: function emit(evtType, evtData) {
	      var shouldBubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var evt = void 0;
	      if (typeof CustomEvent === 'function') {
	        evt = new CustomEvent(evtType, {
	          detail: evtData,
	          bubbles: shouldBubble
	        });
	      } else {
	        evt = document.createEvent('CustomEvent');
	        evt.initCustomEvent(evtType, shouldBubble, false, evtData);
	      }
	
	      this.root_.dispatchEvent(evt);
	    }
	  }]);
	
	  return MDCComponent;
	}();
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCComponent);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "supportsCssVariables", function() { return supportsCssVariables; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyPassive", function() { return applyPassive; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatchesProperty", function() { return getMatchesProperty; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNormalizedEventCoords", function() { return getNormalizedEventCoords; });
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Stores result from supportsCssVariables to avoid redundant processing to detect CSS custom variable support.
	 * @private {boolean|undefined}
	 */
	var supportsCssVariables_ = void 0;
	
	/**
	 * Stores result from applyPassive to avoid redundant processing to detect passive event listener support.
	 * @private {boolean|undefined}
	 */
	var supportsPassive_ = void 0;
	
	/**
	 * @param {!Window} windowObj
	 * @return {boolean}
	 */
	function detectEdgePseudoVarBug(windowObj) {
	  // Detect versions of Edge with buggy var() support
	  // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11495448/
	  var document = windowObj.document;
	  var node = document.createElement('div');
	  node.className = 'mdc-ripple-surface--test-edge-var-bug';
	  document.body.appendChild(node);
	
	  // The bug exists if ::before style ends up propagating to the parent element.
	  // Additionally, getComputedStyle returns null in iframes with display: "none" in Firefox,
	  // but Firefox is known to support CSS custom properties correctly.
	  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = windowObj.getComputedStyle(node);
	  var hasPseudoVarBug = computedStyle !== null && computedStyle.borderTopStyle === 'solid';
	  node.remove();
	  return hasPseudoVarBug;
	}
	
	/**
	 * @param {!Window} windowObj
	 * @param {boolean=} forceRefresh
	 * @return {boolean|undefined}
	 */
	
	function supportsCssVariables(windowObj) {
	  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var supportsCssVariables = supportsCssVariables_;
	  if (typeof supportsCssVariables_ === 'boolean' && !forceRefresh) {
	    return supportsCssVariables;
	  }
	
	  var supportsFunctionPresent = windowObj.CSS && typeof windowObj.CSS.supports === 'function';
	  if (!supportsFunctionPresent) {
	    return;
	  }
	
	  var explicitlySupportsCssVars = windowObj.CSS.supports('--css-vars', 'yes');
	  // See: https://bugs.webkit.org/show_bug.cgi?id=154669
	  // See: README section on Safari
	  var weAreFeatureDetectingSafari10plus = windowObj.CSS.supports('(--css-vars: yes)') && windowObj.CSS.supports('color', '#00000000');
	
	  if (explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus) {
	    supportsCssVariables = !detectEdgePseudoVarBug(windowObj);
	  } else {
	    supportsCssVariables = false;
	  }
	
	  if (!forceRefresh) {
	    supportsCssVariables_ = supportsCssVariables;
	  }
	  return supportsCssVariables;
	}
	
	//
	/**
	 * Determine whether the current browser supports passive event listeners, and if so, use them.
	 * @param {!Window=} globalObj
	 * @param {boolean=} forceRefresh
	 * @return {boolean|{passive: boolean}}
	 */
	function applyPassive() {
	  var globalObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
	  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (supportsPassive_ === undefined || forceRefresh) {
	    var isSupported = false;
	    try {
	      globalObj.document.addEventListener('test', null, { get passive() {
	          isSupported = true;
	        } });
	    } catch (e) {}
	
	    supportsPassive_ = isSupported;
	  }
	
	  return supportsPassive_ ? { passive: true } : false;
	}
	
	/**
	 * @param {!Object} HTMLElementPrototype
	 * @return {!Array<string>}
	 */
	function getMatchesProperty(HTMLElementPrototype) {
	  return ['webkitMatchesSelector', 'msMatchesSelector', 'matches'].filter(function (p) {
	    return p in HTMLElementPrototype;
	  }).pop();
	}
	
	/**
	 * @param {!Event} ev
	 * @param {{x: number, y: number}} pageOffset
	 * @param {!ClientRect} clientRect
	 * @return {{x: number, y: number}}
	 */
	function getNormalizedEventCoords(ev, pageOffset, clientRect) {
	  var x = pageOffset.x,
	      y = pageOffset.y;
	
	  var documentX = x + clientRect.left;
	  var documentY = y + clientRect.top;
	
	  var normalizedX = void 0;
	  var normalizedY = void 0;
	  // Determine touch point relative to the ripple container.
	  if (ev.type === 'touchstart') {
	    normalizedX = ev.changedTouches[0].pageX - documentX;
	    normalizedY = ev.changedTouches[0].pageY - documentY;
	  } else {
	    normalizedX = ev.pageX - documentX;
	    normalizedY = ev.pageY - documentY;
	  }
	
	  return { x: normalizedX, y: normalizedY };
	}
	
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* eslint no-unused-vars: [2, {"args": "none"}] */
	
	/**
	 * Adapter for MDC Ripple. Provides an interface for managing
	 * - classes
	 * - dom
	 * - CSS variables
	 * - position
	 * - dimensions
	 * - scroll position
	 * - event handlers
	 * - unbounded, active and disabled states
	 *
	 * Additionally, provides type information for the adapter to the Closure
	 * compiler.
	 *
	 * Implement this adapter for your framework of choice to delegate updates to
	 * the component in your framework of choice. See architecture documentation
	 * for more details.
	 * https://github.com/material-components/material-components-web/blob/master/docs/code/architecture.md
	 *
	 * @record
	 */
	var MDCRippleAdapter = function () {
	  function MDCRippleAdapter() {
	    _classCallCheck(this, MDCRippleAdapter);
	  }
	
	  _createClass(MDCRippleAdapter, [{
	    key: "browserSupportsCssVars",
	
	    /** @return {boolean} */
	    value: function browserSupportsCssVars() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isUnbounded",
	    value: function isUnbounded() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isSurfaceActive",
	    value: function isSurfaceActive() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isSurfaceDisabled",
	    value: function isSurfaceDisabled() {}
	
	    /** @param {string} className */
	
	  }, {
	    key: "addClass",
	    value: function addClass(className) {}
	
	    /** @param {string} className */
	
	  }, {
	    key: "removeClass",
	    value: function removeClass(className) {}
	
	    /** @param {!EventTarget} target */
	
	  }, {
	    key: "containsEventTarget",
	    value: function containsEventTarget(target) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerInteractionHandler",
	    value: function registerInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterInteractionHandler",
	    value: function deregisterInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerDocumentInteractionHandler",
	    value: function registerDocumentInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterDocumentInteractionHandler",
	    value: function deregisterDocumentInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerResizeHandler",
	    value: function registerResizeHandler(handler) {}
	
	    /**
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterResizeHandler",
	    value: function deregisterResizeHandler(handler) {}
	
	    /**
	     * @param {string} varName
	     * @param {?number|string} value
	     */
	
	  }, {
	    key: "updateCssVariable",
	    value: function updateCssVariable(varName, value) {}
	
	    /** @return {!ClientRect} */
	
	  }, {
	    key: "computeBoundingRect",
	    value: function computeBoundingRect() {}
	
	    /** @return {{x: number, y: number}} */
	
	  }, {
	    key: "getWindowPageOffset",
	    value: function getWindowPageOffset() {}
	  }]);
	
	  return MDCRippleAdapter;
	}();
	
	/* unused harmony default export */ var _unused_webpack_default_export = (MDCRippleAdapter);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDCRipple", function() { return MDCRipple; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RippleCapableSurface", function() { return RippleCapableSurface; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_base_component__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__foundation__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCRippleFoundation", function() { return __WEBPACK_IMPORTED_MODULE_2__foundation__["a"]; });
	/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "util", function() { return __WEBPACK_IMPORTED_MODULE_3__util__; });
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	
	/**
	 * @extends MDCComponent<!MDCRippleFoundation>
	 */
	
	var MDCRipple = function (_MDCComponent) {
	  _inherits(MDCRipple, _MDCComponent);
	
	  /** @param {...?} args */
	  function MDCRipple() {
	    var _ref;
	
	    _classCallCheck(this, MDCRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    /** @type {boolean} */
	    var _this = _possibleConstructorReturn(this, (_ref = MDCRipple.__proto__ || Object.getPrototypeOf(MDCRipple)).call.apply(_ref, [this].concat(args)));
	
	    _this.disabled = false;
	
	    /** @private {boolean} */
	    _this.unbounded_;
	    return _this;
	  }
	
	  /**
	   * @param {!Element} root
	   * @param {{isUnbounded: (boolean|undefined)}=} options
	   * @return {!MDCRipple}
	   */
	
	
	  _createClass(MDCRipple, [{
	    key: 'setUnbounded_',
	
	
	    /**
	     * Closure Compiler throws an access control error when directly accessing a
	     * protected or private property inside a getter/setter, like unbounded above.
	     * By accessing the protected property inside a method, we solve that problem.
	     * That's why this function exists.
	     * @private
	     */
	    value: function setUnbounded_() {
	      this.foundation_.setUnbounded(this.unbounded_);
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      this.foundation_.activate();
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this.foundation_.deactivate();
	    }
	  }, {
	    key: 'layout',
	    value: function layout() {
	      this.foundation_.layout();
	    }
	
	    /** @return {!MDCRippleFoundation} */
	
	  }, {
	    key: 'getDefaultFoundation',
	    value: function getDefaultFoundation() {
	      return new __WEBPACK_IMPORTED_MODULE_2__foundation__["a" /* default */](MDCRipple.createAdapter(this));
	    }
	  }, {
	    key: 'initialSyncWithDOM',
	    value: function initialSyncWithDOM() {
	      this.unbounded = 'mdcRippleIsUnbounded' in this.root_.dataset;
	    }
	  }, {
	    key: 'unbounded',
	
	
	    /** @return {boolean} */
	    get: function get() {
	      return this.unbounded_;
	    }
	
	    /** @param {boolean} unbounded */
	    ,
	    set: function set(unbounded) {
	      this.unbounded_ = Boolean(unbounded);
	      this.setUnbounded_();
	    }
	  }], [{
	    key: 'attachTo',
	    value: function attachTo(root) {
	      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref2$isUnbounded = _ref2.isUnbounded,
	          isUnbounded = _ref2$isUnbounded === undefined ? undefined : _ref2$isUnbounded;
	
	      var ripple = new MDCRipple(root);
	      // Only override unbounded behavior if option is explicitly specified
	      if (isUnbounded !== undefined) {
	        ripple.unbounded = /** @type {boolean} */isUnbounded;
	      }
	      return ripple;
	    }
	
	    /**
	     * @param {!RippleCapableSurface} instance
	     * @return {!MDCRippleAdapter}
	     */
	
	  }, {
	    key: 'createAdapter',
	    value: function createAdapter(instance) {
	      var MATCHES = __WEBPACK_IMPORTED_MODULE_3__util__["getMatchesProperty"](HTMLElement.prototype);
	
	      return {
	        browserSupportsCssVars: function browserSupportsCssVars() {
	          return __WEBPACK_IMPORTED_MODULE_3__util__["supportsCssVariables"](window);
	        },
	        isUnbounded: function isUnbounded() {
	          return instance.unbounded;
	        },
	        isSurfaceActive: function isSurfaceActive() {
	          return instance.root_[MATCHES](':active');
	        },
	        isSurfaceDisabled: function isSurfaceDisabled() {
	          return instance.disabled;
	        },
	        addClass: function addClass(className) {
	          return instance.root_.classList.add(className);
	        },
	        removeClass: function removeClass(className) {
	          return instance.root_.classList.remove(className);
	        },
	        containsEventTarget: function containsEventTarget(target) {
	          return instance.root_.contains(target);
	        },
	        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
	          return instance.root_.addEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
	          return instance.root_.removeEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
	          return document.documentElement.addEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
	          return document.documentElement.removeEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        registerResizeHandler: function registerResizeHandler(handler) {
	          return window.addEventListener('resize', handler);
	        },
	        deregisterResizeHandler: function deregisterResizeHandler(handler) {
	          return window.removeEventListener('resize', handler);
	        },
	        updateCssVariable: function updateCssVariable(varName, value) {
	          return instance.root_.style.setProperty(varName, value);
	        },
	        computeBoundingRect: function computeBoundingRect() {
	          return instance.root_.getBoundingClientRect();
	        },
	        getWindowPageOffset: function getWindowPageOffset() {
	          return { x: window.pageXOffset, y: window.pageYOffset };
	        }
	      };
	    }
	  }]);
	
	  return MDCRipple;
	}(__WEBPACK_IMPORTED_MODULE_0__material_base_component__["a" /* default */]);
	
	/**
	 * See Material Design spec for more details on when to use ripples.
	 * https://material.io/guidelines/motion/choreography.html#choreography-creation
	 * @record
	 */
	
	
	var RippleCapableSurface = function RippleCapableSurface() {
	  _classCallCheck(this, RippleCapableSurface);
	};
	
	/** @protected {!Element} */
	
	
	RippleCapableSurface.prototype.root_;
	
	/**
	 * Whether or not the ripple bleeds out of the bounds of the element.
	 * @type {boolean|undefined}
	 */
	RippleCapableSurface.prototype.unbounded;
	
	/**
	 * Whether or not the ripple is attached to a disabled component.
	 * @type {boolean|undefined}
	 */
	RippleCapableSurface.prototype.disabled;
	
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_base_foundation__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	
	/**
	 * @typedef {{
	 *   isActivated: (boolean|undefined),
	 *   hasDeactivationUXRun: (boolean|undefined),
	 *   wasActivatedByPointer: (boolean|undefined),
	 *   wasElementMadeActive: (boolean|undefined),
	 *   activationEvent: Event,
	 *   isProgrammatic: (boolean|undefined)
	 * }}
	 */
	var ActivationStateType = void 0;
	
	/**
	 * @typedef {{
	 *   activate: (string|undefined),
	 *   deactivate: (string|undefined),
	 *   focus: (string|undefined),
	 *   blur: (string|undefined)
	 * }}
	 */
	var ListenerInfoType = void 0;
	
	/**
	 * @typedef {{
	 *   activate: function(!Event),
	 *   deactivate: function(!Event),
	 *   focus: function(),
	 *   blur: function()
	 * }}
	 */
	var ListenersType = void 0;
	
	/**
	 * @typedef {{
	 *   x: number,
	 *   y: number
	 * }}
	 */
	var PointType = void 0;
	
	// Activation events registered on the root element of each instance for activation
	var ACTIVATION_EVENT_TYPES = ['touchstart', 'pointerdown', 'mousedown', 'keydown'];
	
	// Deactivation events registered on documentElement when a pointer-related down event occurs
	var POINTER_DEACTIVATION_EVENT_TYPES = ['touchend', 'pointerup', 'mouseup'];
	
	// Tracks activations that have occurred on the current frame, to avoid simultaneous nested activations
	/** @type {!Array<!EventTarget>} */
	var activatedTargets = [];
	
	/**
	 * @extends {MDCFoundation<!MDCRippleAdapter>}
	 */
	
	var MDCRippleFoundation = function (_MDCFoundation) {
	  _inherits(MDCRippleFoundation, _MDCFoundation);
	
	  _createClass(MDCRippleFoundation, null, [{
	    key: 'cssClasses',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */];
	    }
	  }, {
	    key: 'strings',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* strings */];
	    }
	  }, {
	    key: 'numbers',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */];
	    }
	  }, {
	    key: 'defaultAdapter',
	    get: function get() {
	      return {
	        browserSupportsCssVars: function browserSupportsCssVars() /* boolean - cached */{},
	        isUnbounded: function isUnbounded() /* boolean */{},
	        isSurfaceActive: function isSurfaceActive() /* boolean */{},
	        isSurfaceDisabled: function isSurfaceDisabled() /* boolean */{},
	        addClass: function addClass() /* className: string */{},
	        removeClass: function removeClass() /* className: string */{},
	        containsEventTarget: function containsEventTarget() /* target: !EventTarget */{},
	        registerInteractionHandler: function registerInteractionHandler() /* evtType: string, handler: EventListener */{},
	        deregisterInteractionHandler: function deregisterInteractionHandler() /* evtType: string, handler: EventListener */{},
	        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() /* evtType: string, handler: EventListener */{},
	        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() /* evtType: string, handler: EventListener */{},
	        registerResizeHandler: function registerResizeHandler() /* handler: EventListener */{},
	        deregisterResizeHandler: function deregisterResizeHandler() /* handler: EventListener */{},
	        updateCssVariable: function updateCssVariable() /* varName: string, value: string */{},
	        computeBoundingRect: function computeBoundingRect() /* ClientRect */{},
	        getWindowPageOffset: function getWindowPageOffset() /* {x: number, y: number} */{}
	      };
	    }
	  }]);
	
	  function MDCRippleFoundation(adapter) {
	    _classCallCheck(this, MDCRippleFoundation);
	
	    /** @private {number} */
	    var _this = _possibleConstructorReturn(this, (MDCRippleFoundation.__proto__ || Object.getPrototypeOf(MDCRippleFoundation)).call(this, _extends(MDCRippleFoundation.defaultAdapter, adapter)));
	
	    _this.layoutFrame_ = 0;
	
	    /** @private {!ClientRect} */
	    _this.frame_ = /** @type {!ClientRect} */{ width: 0, height: 0 };
	
	    /** @private {!ActivationStateType} */
	    _this.activationState_ = _this.defaultActivationState_();
	
	    /** @private {number} */
	    _this.initialSize_ = 0;
	
	    /** @private {number} */
	    _this.maxRadius_ = 0;
	
	    /** @private {function(!Event)} */
	    _this.activateHandler_ = function (e) {
	      return _this.activate_(e);
	    };
	
	    /** @private {function(!Event)} */
	    _this.deactivateHandler_ = function (e) {
	      return _this.deactivate_(e);
	    };
	
	    /** @private {function(?Event=)} */
	    _this.focusHandler_ = function () {
	      return requestAnimationFrame(function () {
	        return _this.adapter_.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
	      });
	    };
	
	    /** @private {function(?Event=)} */
	    _this.blurHandler_ = function () {
	      return requestAnimationFrame(function () {
	        return _this.adapter_.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
	      });
	    };
	
	    /** @private {!Function} */
	    _this.resizeHandler_ = function () {
	      return _this.layout();
	    };
	
	    /** @private {{left: number, top:number}} */
	    _this.unboundedCoords_ = {
	      left: 0,
	      top: 0
	    };
	
	    /** @private {number} */
	    _this.fgScale_ = 0;
	
	    /** @private {number} */
	    _this.activationTimer_ = 0;
	
	    /** @private {number} */
	    _this.fgDeactivationRemovalTimer_ = 0;
	
	    /** @private {boolean} */
	    _this.activationAnimationHasEnded_ = false;
	
	    /** @private {!Function} */
	    _this.activationTimerCallback_ = function () {
	      _this.activationAnimationHasEnded_ = true;
	      _this.runDeactivationUXLogicIfReady_();
	    };
	
	    /** @private {?Event} */
	    _this.previousActivationEvent_ = null;
	    return _this;
	  }
	
	  /**
	   * We compute this property so that we are not querying information about the client
	   * until the point in time where the foundation requests it. This prevents scenarios where
	   * client-side feature-detection may happen too early, such as when components are rendered on the server
	   * and then initialized at mount time on the client.
	   * @return {boolean}
	   * @private
	   */
	
	
	  _createClass(MDCRippleFoundation, [{
	    key: 'isSupported_',
	    value: function isSupported_() {
	      return this.adapter_.browserSupportsCssVars();
	    }
	
	    /**
	     * @return {!ActivationStateType}
	     */
	
	  }, {
	    key: 'defaultActivationState_',
	    value: function defaultActivationState_() {
	      return {
	        isActivated: false,
	        hasDeactivationUXRun: false,
	        wasActivatedByPointer: false,
	        wasElementMadeActive: false,
	        activationEvent: null,
	        isProgrammatic: false
	      };
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      if (!this.isSupported_()) {
	        return;
	      }
	      this.registerRootHandlers_();
	
	      var _MDCRippleFoundation$ = MDCRippleFoundation.cssClasses,
	          ROOT = _MDCRippleFoundation$.ROOT,
	          UNBOUNDED = _MDCRippleFoundation$.UNBOUNDED;
	
	      requestAnimationFrame(function () {
	        _this2.adapter_.addClass(ROOT);
	        if (_this2.adapter_.isUnbounded()) {
	          _this2.adapter_.addClass(UNBOUNDED);
	          // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
	          _this2.layoutInternal_();
	        }
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this3 = this;
	
	      if (!this.isSupported_()) {
	        return;
	      }
	
	      if (this.activationTimer_) {
	        clearTimeout(this.activationTimer_);
	        this.activationTimer_ = 0;
	        var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
	
	        this.adapter_.removeClass(FG_ACTIVATION);
	      }
	
	      this.deregisterRootHandlers_();
	      this.deregisterDeactivationHandlers_();
	
	      var _MDCRippleFoundation$2 = MDCRippleFoundation.cssClasses,
	          ROOT = _MDCRippleFoundation$2.ROOT,
	          UNBOUNDED = _MDCRippleFoundation$2.UNBOUNDED;
	
	      requestAnimationFrame(function () {
	        _this3.adapter_.removeClass(ROOT);
	        _this3.adapter_.removeClass(UNBOUNDED);
	        _this3.removeCssVars_();
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'registerRootHandlers_',
	    value: function registerRootHandlers_() {
	      var _this4 = this;
	
	      ACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this4.adapter_.registerInteractionHandler(type, _this4.activateHandler_);
	      });
	      this.adapter_.registerInteractionHandler('focus', this.focusHandler_);
	      this.adapter_.registerInteractionHandler('blur', this.blurHandler_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.adapter_.registerResizeHandler(this.resizeHandler_);
	      }
	    }
	
	    /**
	     * @param {!Event} e
	     * @private
	     */
	
	  }, {
	    key: 'registerDeactivationHandlers_',
	    value: function registerDeactivationHandlers_(e) {
	      var _this5 = this;
	
	      if (e.type === 'keydown') {
	        this.adapter_.registerInteractionHandler('keyup', this.deactivateHandler_);
	      } else {
	        POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (type) {
	          _this5.adapter_.registerDocumentInteractionHandler(type, _this5.deactivateHandler_);
	        });
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'deregisterRootHandlers_',
	    value: function deregisterRootHandlers_() {
	      var _this6 = this;
	
	      ACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this6.adapter_.deregisterInteractionHandler(type, _this6.activateHandler_);
	      });
	      this.adapter_.deregisterInteractionHandler('focus', this.focusHandler_);
	      this.adapter_.deregisterInteractionHandler('blur', this.blurHandler_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.adapter_.deregisterResizeHandler(this.resizeHandler_);
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'deregisterDeactivationHandlers_',
	    value: function deregisterDeactivationHandlers_() {
	      var _this7 = this;
	
	      this.adapter_.deregisterInteractionHandler('keyup', this.deactivateHandler_);
	      POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this7.adapter_.deregisterDocumentInteractionHandler(type, _this7.deactivateHandler_);
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'removeCssVars_',
	    value: function removeCssVars_() {
	      var _this8 = this;
	
	      var strings = MDCRippleFoundation.strings;
	
	      Object.keys(strings).forEach(function (k) {
	        if (k.indexOf('VAR_') === 0) {
	          _this8.adapter_.updateCssVariable(strings[k], null);
	        }
	      });
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'activate_',
	    value: function activate_(e) {
	      var _this9 = this;
	
	      if (this.adapter_.isSurfaceDisabled()) {
	        return;
	      }
	
	      var activationState = this.activationState_;
	      if (activationState.isActivated) {
	        return;
	      }
	
	      // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
	      var previousActivationEvent = this.previousActivationEvent_;
	      var isSameInteraction = previousActivationEvent && e && previousActivationEvent.type !== e.type;
	      if (isSameInteraction) {
	        return;
	      }
	
	      activationState.isActivated = true;
	      activationState.isProgrammatic = e === null;
	      activationState.activationEvent = e;
	      activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : e.type === 'mousedown' || e.type === 'touchstart' || e.type === 'pointerdown';
	
	      var hasActivatedChild = e && activatedTargets.length > 0 && activatedTargets.some(function (target) {
	        return _this9.adapter_.containsEventTarget(target);
	      });
	      if (hasActivatedChild) {
	        // Immediately reset activation state, while preserving logic that prevents touch follow-on events
	        this.resetActivationState_();
	        return;
	      }
	
	      if (e) {
	        activatedTargets.push( /** @type {!EventTarget} */e.target);
	        this.registerDeactivationHandlers_(e);
	      }
	
	      activationState.wasElementMadeActive = this.checkElementMadeActive_(e);
	      if (activationState.wasElementMadeActive) {
	        this.animateActivation_();
	      }
	
	      requestAnimationFrame(function () {
	        // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
	        activatedTargets = [];
	
	        if (!activationState.wasElementMadeActive && (e.key === ' ' || e.keyCode === 32)) {
	          // If space was pressed, try again within an rAF call to detect :active, because different UAs report
	          // active states inconsistently when they're called within event handling code:
	          // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
	          // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
	          // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
	          // variable is set within a rAF callback for a submit button interaction (#2241).
	          activationState.wasElementMadeActive = _this9.checkElementMadeActive_(e);
	          if (activationState.wasElementMadeActive) {
	            _this9.animateActivation_();
	          }
	        }
	
	        if (!activationState.wasElementMadeActive) {
	          // Reset activation state immediately if element was not made active.
	          _this9.activationState_ = _this9.defaultActivationState_();
	        }
	      });
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'checkElementMadeActive_',
	    value: function checkElementMadeActive_(e) {
	      return e && e.type === 'keydown' ? this.adapter_.isSurfaceActive() : true;
	    }
	
	    /**
	     * @param {?Event=} event Optional event containing position information.
	     */
	
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.activate_(event);
	    }
	
	    /** @private */
	
	  }, {
	    key: 'animateActivation_',
	    value: function animateActivation_() {
	      var _this10 = this;
	
	      var _MDCRippleFoundation$3 = MDCRippleFoundation.strings,
	          VAR_FG_TRANSLATE_START = _MDCRippleFoundation$3.VAR_FG_TRANSLATE_START,
	          VAR_FG_TRANSLATE_END = _MDCRippleFoundation$3.VAR_FG_TRANSLATE_END;
	      var _MDCRippleFoundation$4 = MDCRippleFoundation.cssClasses,
	          FG_DEACTIVATION = _MDCRippleFoundation$4.FG_DEACTIVATION,
	          FG_ACTIVATION = _MDCRippleFoundation$4.FG_ACTIVATION;
	      var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
	
	
	      this.layoutInternal_();
	
	      var translateStart = '';
	      var translateEnd = '';
	
	      if (!this.adapter_.isUnbounded()) {
	        var _getFgTranslationCoor = this.getFgTranslationCoordinates_(),
	            startPoint = _getFgTranslationCoor.startPoint,
	            endPoint = _getFgTranslationCoor.endPoint;
	
	        translateStart = startPoint.x + 'px, ' + startPoint.y + 'px';
	        translateEnd = endPoint.x + 'px, ' + endPoint.y + 'px';
	      }
	
	      this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
	      this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
	      // Cancel any ongoing activation/deactivation animations
	      clearTimeout(this.activationTimer_);
	      clearTimeout(this.fgDeactivationRemovalTimer_);
	      this.rmBoundedActivationClasses_();
	      this.adapter_.removeClass(FG_DEACTIVATION);
	
	      // Force layout in order to re-trigger the animation.
	      this.adapter_.computeBoundingRect();
	      this.adapter_.addClass(FG_ACTIVATION);
	      this.activationTimer_ = setTimeout(function () {
	        return _this10.activationTimerCallback_();
	      }, DEACTIVATION_TIMEOUT_MS);
	    }
	
	    /**
	     * @private
	     * @return {{startPoint: PointType, endPoint: PointType}}
	     */
	
	  }, {
	    key: 'getFgTranslationCoordinates_',
	    value: function getFgTranslationCoordinates_() {
	      var _activationState_ = this.activationState_,
	          activationEvent = _activationState_.activationEvent,
	          wasActivatedByPointer = _activationState_.wasActivatedByPointer;
	
	
	      var startPoint = void 0;
	      if (wasActivatedByPointer) {
	        startPoint = Object(__WEBPACK_IMPORTED_MODULE_3__util__["getNormalizedEventCoords"])(
	        /** @type {!Event} */activationEvent, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect());
	      } else {
	        startPoint = {
	          x: this.frame_.width / 2,
	          y: this.frame_.height / 2
	        };
	      }
	      // Center the element around the start point.
	      startPoint = {
	        x: startPoint.x - this.initialSize_ / 2,
	        y: startPoint.y - this.initialSize_ / 2
	      };
	
	      var endPoint = {
	        x: this.frame_.width / 2 - this.initialSize_ / 2,
	        y: this.frame_.height / 2 - this.initialSize_ / 2
	      };
	
	      return { startPoint: startPoint, endPoint: endPoint };
	    }
	
	    /** @private */
	
	  }, {
	    key: 'runDeactivationUXLogicIfReady_',
	    value: function runDeactivationUXLogicIfReady_() {
	      var _this11 = this;
	
	      // This method is called both when a pointing device is released, and when the activation animation ends.
	      // The deactivation animation should only run after both of those occur.
	      var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
	      var _activationState_2 = this.activationState_,
	          hasDeactivationUXRun = _activationState_2.hasDeactivationUXRun,
	          isActivated = _activationState_2.isActivated;
	
	      var activationHasEnded = hasDeactivationUXRun || !isActivated;
	
	      if (activationHasEnded && this.activationAnimationHasEnded_) {
	        this.rmBoundedActivationClasses_();
	        this.adapter_.addClass(FG_DEACTIVATION);
	        this.fgDeactivationRemovalTimer_ = setTimeout(function () {
	          _this11.adapter_.removeClass(FG_DEACTIVATION);
	        }, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */].FG_DEACTIVATION_MS);
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'rmBoundedActivationClasses_',
	    value: function rmBoundedActivationClasses_() {
	      var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
	
	      this.adapter_.removeClass(FG_ACTIVATION);
	      this.activationAnimationHasEnded_ = false;
	      this.adapter_.computeBoundingRect();
	    }
	  }, {
	    key: 'resetActivationState_',
	    value: function resetActivationState_() {
	      var _this12 = this;
	
	      this.previousActivationEvent_ = this.activationState_.activationEvent;
	      this.activationState_ = this.defaultActivationState_();
	      // Touch devices may fire additional events for the same interaction within a short time.
	      // Store the previous event until it's safe to assume that subsequent events are for new interactions.
	      setTimeout(function () {
	        return _this12.previousActivationEvent_ = null;
	      }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'deactivate_',
	    value: function deactivate_(e) {
	      var _this13 = this;
	
	      var activationState = this.activationState_;
	      // This can happen in scenarios such as when you have a keyup event that blurs the element.
	      if (!activationState.isActivated) {
	        return;
	      }
	
	      var state = /** @type {!ActivationStateType} */_extends({}, activationState);
	
	      if (activationState.isProgrammatic) {
	        var evtObject = null;
	        requestAnimationFrame(function () {
	          return _this13.animateDeactivation_(evtObject, state);
	        });
	        this.resetActivationState_();
	      } else {
	        this.deregisterDeactivationHandlers_();
	        requestAnimationFrame(function () {
	          _this13.activationState_.hasDeactivationUXRun = true;
	          _this13.animateDeactivation_(e, state);
	          _this13.resetActivationState_();
	        });
	      }
	    }
	
	    /**
	     * @param {?Event=} event Optional event containing position information.
	     */
	
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.deactivate_(event);
	    }
	
	    /**
	     * @param {Event} e
	     * @param {!ActivationStateType} options
	     * @private
	     */
	
	  }, {
	    key: 'animateDeactivation_',
	    value: function animateDeactivation_(e, _ref) {
	      var wasActivatedByPointer = _ref.wasActivatedByPointer,
	          wasElementMadeActive = _ref.wasElementMadeActive;
	
	      if (wasActivatedByPointer || wasElementMadeActive) {
	        this.runDeactivationUXLogicIfReady_();
	      }
	    }
	  }, {
	    key: 'layout',
	    value: function layout() {
	      var _this14 = this;
	
	      if (this.layoutFrame_) {
	        cancelAnimationFrame(this.layoutFrame_);
	      }
	      this.layoutFrame_ = requestAnimationFrame(function () {
	        _this14.layoutInternal_();
	        _this14.layoutFrame_ = 0;
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'layoutInternal_',
	    value: function layoutInternal_() {
	      var _this15 = this;
	
	      this.frame_ = this.adapter_.computeBoundingRect();
	      var maxDim = Math.max(this.frame_.height, this.frame_.width);
	
	      // Surface diameter is treated differently for unbounded vs. bounded ripples.
	      // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
	      // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
	      // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
	      // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
	      // `overflow: hidden`.
	      var getBoundedRadius = function getBoundedRadius() {
	        var hypotenuse = Math.sqrt(Math.pow(_this15.frame_.width, 2) + Math.pow(_this15.frame_.height, 2));
	        return hypotenuse + MDCRippleFoundation.numbers.PADDING;
	      };
	
	      this.maxRadius_ = this.adapter_.isUnbounded() ? maxDim : getBoundedRadius();
	
	      // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
	      this.initialSize_ = maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE;
	      this.fgScale_ = this.maxRadius_ / this.initialSize_;
	
	      this.updateLayoutCssVars_();
	    }
	
	    /** @private */
	
	  }, {
	    key: 'updateLayoutCssVars_',
	    value: function updateLayoutCssVars_() {
	      var _MDCRippleFoundation$5 = MDCRippleFoundation.strings,
	          VAR_FG_SIZE = _MDCRippleFoundation$5.VAR_FG_SIZE,
	          VAR_LEFT = _MDCRippleFoundation$5.VAR_LEFT,
	          VAR_TOP = _MDCRippleFoundation$5.VAR_TOP,
	          VAR_FG_SCALE = _MDCRippleFoundation$5.VAR_FG_SCALE;
	
	
	      this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + 'px');
	      this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.unboundedCoords_ = {
	          left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
	          top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
	        };
	
	        this.adapter_.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + 'px');
	        this.adapter_.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + 'px');
	      }
	    }
	
	    /** @param {boolean} unbounded */
	
	  }, {
	    key: 'setUnbounded',
	    value: function setUnbounded(unbounded) {
	      var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
	
	      if (unbounded) {
	        this.adapter_.addClass(UNBOUNDED);
	      } else {
	        this.adapter_.removeClass(UNBOUNDED);
	      }
	    }
	  }]);
	
	  return MDCRippleFoundation;
	}(__WEBPACK_IMPORTED_MODULE_0__material_base_foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCRippleFoundation);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cssClasses; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return strings; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numbers; });
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var cssClasses = {
	  // Ripple is a special case where the "root" component is really a "mixin" of sorts,
	  // given that it's an 'upgrade' to an existing component. That being said it is the root
	  // CSS class that all other CSS classes derive from.
	  ROOT: 'mdc-ripple-upgraded',
	  UNBOUNDED: 'mdc-ripple-upgraded--unbounded',
	  BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
	  FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
	  FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation'
	};
	
	var strings = {
	  VAR_LEFT: '--mdc-ripple-left',
	  VAR_TOP: '--mdc-ripple-top',
	  VAR_FG_SIZE: '--mdc-ripple-fg-size',
	  VAR_FG_SCALE: '--mdc-ripple-fg-scale',
	  VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
	  VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end'
	};
	
	var numbers = {
	  PADDING: 10,
	  INITIAL_ORIGIN_SCALE: 0.6,
	  DEACTIVATION_TIMEOUT_MS: 225, // Corresponds to $mdc-ripple-translate-duration (i.e. activation animation duration)
	  FG_DEACTIVATION_MS: 150, // Corresponds to $mdc-ripple-fade-out-duration (i.e. deactivation animation duration)
	  TAP_DELAY_MS: 300 };
	
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=mdc.ripple.js.map

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 Material Components for the Web
	 Copyright (c) 2018 Google Inc.
	 License: Apache-2.0
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["topAppBar"] = factory();
		else
			root["mdc"] = root["mdc"] || {}, root["mdc"]["topAppBar"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * @template A
	 */
	var MDCFoundation = function () {
	  _createClass(MDCFoundation, null, [{
	    key: "cssClasses",
	
	    /** @return enum{cssClasses} */
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports every
	      // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
	      return {};
	    }
	
	    /** @return enum{strings} */
	
	  }, {
	    key: "strings",
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports all
	      // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
	      return {};
	    }
	
	    /** @return enum{numbers} */
	
	  }, {
	    key: "numbers",
	    get: function get() {
	      // Classes extending MDCFoundation should implement this method to return an object which exports all
	      // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
	      return {};
	    }
	
	    /** @return {!Object} */
	
	  }, {
	    key: "defaultAdapter",
	    get: function get() {
	      // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
	      // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
	      // validation.
	      return {};
	    }
	
	    /**
	     * @param {A=} adapter
	     */
	
	  }]);
	
	  function MDCFoundation() {
	    var adapter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, MDCFoundation);
	
	    /** @protected {!A} */
	    this.adapter_ = adapter;
	  }
	
	  _createClass(MDCFoundation, [{
	    key: "init",
	    value: function init() {
	      // Subclasses should override this method to perform initialization routines (registering events, etc.)
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
	    }
	  }]);
	
	  return MDCFoundation;
	}();
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCFoundation);
	
	/***/ }),
	
	/***/ 1:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__foundation__ = __webpack_require__(0);
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	/**
	 * @template F
	 */
	
	var MDCComponent = function () {
	  _createClass(MDCComponent, null, [{
	    key: 'attachTo',
	
	    /**
	     * @param {!Element} root
	     * @return {!MDCComponent}
	     */
	    value: function attachTo(root) {
	      // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
	      // returns an instantiated component with its root set to that element. Also note that in the cases of
	      // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
	      // from getDefaultFoundation().
	      return new MDCComponent(root, new __WEBPACK_IMPORTED_MODULE_0__foundation__["a" /* default */]());
	    }
	
	    /**
	     * @param {!Element} root
	     * @param {F=} foundation
	     * @param {...?} args
	     */
	
	  }]);
	
	  function MDCComponent(root) {
	    var foundation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	    _classCallCheck(this, MDCComponent);
	
	    /** @protected {!Element} */
	    this.root_ = root;
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    this.initialize.apply(this, args);
	    // Note that we initialize foundation here and not within the constructor's default param so that
	    // this.root_ is defined and can be used within the foundation class.
	    /** @protected {!F} */
	    this.foundation_ = foundation === undefined ? this.getDefaultFoundation() : foundation;
	    this.foundation_.init();
	    this.initialSyncWithDOM();
	  }
	
	  _createClass(MDCComponent, [{
	    key: 'initialize',
	    value: function initialize() /* ...args */{}
	    // Subclasses can override this to do any additional setup work that would be considered part of a
	    // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
	    // initialized. Any additional arguments besides root and foundation will be passed in here.
	
	
	    /**
	     * @return {!F} foundation
	     */
	
	  }, {
	    key: 'getDefaultFoundation',
	    value: function getDefaultFoundation() {
	      // Subclasses must override this method to return a properly configured foundation class for the
	      // component.
	      throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' + 'foundation class');
	    }
	  }, {
	    key: 'initialSyncWithDOM',
	    value: function initialSyncWithDOM() {
	      // Subclasses should override this method if they need to perform work to synchronize with a host DOM
	      // object. An example of this would be a form control wrapper that needs to synchronize its internal state
	      // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
	      // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      // Subclasses may implement this method to release any resources / deregister any listeners they have
	      // attached. An example of this might be deregistering a resize event from the window object.
	      this.foundation_.destroy();
	    }
	
	    /**
	     * Wrapper method to add an event listener to the component's root element. This is most useful when
	     * listening for custom events.
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: 'listen',
	    value: function listen(evtType, handler) {
	      this.root_.addEventListener(evtType, handler);
	    }
	
	    /**
	     * Wrapper method to remove an event listener to the component's root element. This is most useful when
	     * unlistening for custom events.
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: 'unlisten',
	    value: function unlisten(evtType, handler) {
	      this.root_.removeEventListener(evtType, handler);
	    }
	
	    /**
	     * Fires a cross-browser-compatible custom event from the component root of the given type,
	     * with the given data.
	     * @param {string} evtType
	     * @param {!Object} evtData
	     * @param {boolean=} shouldBubble
	     */
	
	  }, {
	    key: 'emit',
	    value: function emit(evtType, evtData) {
	      var shouldBubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var evt = void 0;
	      if (typeof CustomEvent === 'function') {
	        evt = new CustomEvent(evtType, {
	          detail: evtData,
	          bubbles: shouldBubble
	        });
	      } else {
	        evt = document.createEvent('CustomEvent');
	        evt.initCustomEvent(evtType, shouldBubble, false, evtData);
	      }
	
	      this.root_.dispatchEvent(evt);
	    }
	  }]);
	
	  return MDCComponent;
	}();
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCComponent);
	
	/***/ }),
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDCTopAppBar", function() { return MDCTopAppBar; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adapter__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_base_component__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ripple_index__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__foundation__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fixed_foundation__ = __webpack_require__(115);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__short_foundation__ = __webpack_require__(116);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__standard_foundation__ = __webpack_require__(117);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCTopAppBarBaseFoundation", function() { return __WEBPACK_IMPORTED_MODULE_4__foundation__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCTopAppBarFoundation", function() { return __WEBPACK_IMPORTED_MODULE_7__standard_foundation__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCFixedTopAppBarFoundation", function() { return __WEBPACK_IMPORTED_MODULE_5__fixed_foundation__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCShortTopAppBarFoundation", function() { return __WEBPACK_IMPORTED_MODULE_6__short_foundation__["a"]; });
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	
	
	
	
	
	/**
	 * @extends {MDCComponent<!MDCTopAppBarBaseFoundation>}
	 * @final
	 */
	
	var MDCTopAppBar = function (_MDCComponent) {
	  _inherits(MDCTopAppBar, _MDCComponent);
	
	  /**
	   * @param {...?} args
	   */
	  function MDCTopAppBar() {
	    var _ref;
	
	    _classCallCheck(this, MDCTopAppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    /** @private {?Element} */
	    var _this = _possibleConstructorReturn(this, (_ref = MDCTopAppBar.__proto__ || Object.getPrototypeOf(MDCTopAppBar)).call.apply(_ref, [this].concat(args)));
	
	    _this.navIcon_;
	    /** @type {?Array<MDCRipple>} */
	    _this.iconRipples_;
	    return _this;
	  }
	
	  _createClass(MDCTopAppBar, [{
	    key: 'initialize',
	    value: function initialize() {
	      var rippleFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (el) {
	        return __WEBPACK_IMPORTED_MODULE_2__material_ripple_index__["MDCRipple"].attachTo(el);
	      };
	
	      this.navIcon_ = this.root_.querySelector(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* strings */].NAVIGATION_ICON_SELECTOR);
	
	      // Get all icons in the toolbar and instantiate the ripples
	      var icons = [].slice.call(this.root_.querySelectorAll(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* strings */].ACTION_ITEM_SELECTOR));
	      if (this.navIcon_) {
	        icons.push(this.navIcon_);
	      }
	
	      this.iconRipples_ = icons.map(function (icon) {
	        var ripple = rippleFactory(icon);
	        ripple.unbounded = true;
	        return ripple;
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.iconRipples_.forEach(function (iconRipple) {
	        return iconRipple.destroy();
	      });
	      _get(MDCTopAppBar.prototype.__proto__ || Object.getPrototypeOf(MDCTopAppBar.prototype), 'destroy', this).call(this);
	    }
	
	    /**
	     * @param {!Element} root
	     * @return {!MDCTopAppBar}
	     */
	
	  }, {
	    key: 'getDefaultFoundation',
	
	
	    /**
	     * @return {!MDCTopAppBarBaseFoundation}
	     */
	    value: function getDefaultFoundation() {
	      var _this2 = this;
	
	      /** @type {!MDCTopAppBarAdapter} */
	      var adapter = /** @type {!MDCTopAppBarAdapter} */_extends({
	        hasClass: function hasClass(className) {
	          return _this2.root_.classList.contains(className);
	        },
	        addClass: function addClass(className) {
	          return _this2.root_.classList.add(className);
	        },
	        removeClass: function removeClass(className) {
	          return _this2.root_.classList.remove(className);
	        },
	        setStyle: function setStyle(property, value) {
	          return _this2.root_.style.setProperty(property, value);
	        },
	        getTopAppBarHeight: function getTopAppBarHeight() {
	          return _this2.root_.clientHeight;
	        },
	        registerNavigationIconInteractionHandler: function registerNavigationIconInteractionHandler(evtType, handler) {
	          if (_this2.navIcon_) {
	            _this2.navIcon_.addEventListener(evtType, handler);
	          }
	        },
	        deregisterNavigationIconInteractionHandler: function deregisterNavigationIconInteractionHandler(evtType, handler) {
	          if (_this2.navIcon_) {
	            _this2.navIcon_.removeEventListener(evtType, handler);
	          }
	        },
	        notifyNavigationIconClicked: function notifyNavigationIconClicked() {
	          _this2.emit(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* strings */].NAVIGATION_EVENT, {});
	        },
	        registerScrollHandler: function registerScrollHandler(handler) {
	          return window.addEventListener('scroll', handler);
	        },
	        deregisterScrollHandler: function deregisterScrollHandler(handler) {
	          return window.removeEventListener('scroll', handler);
	        },
	        registerResizeHandler: function registerResizeHandler(handler) {
	          return window.addEventListener('resize', handler);
	        },
	        deregisterResizeHandler: function deregisterResizeHandler(handler) {
	          return window.removeEventListener('resize', handler);
	        },
	        getViewportScrollY: function getViewportScrollY() {
	          return window.pageYOffset;
	        },
	        getTotalActionItems: function getTotalActionItems() {
	          return _this2.root_.querySelectorAll(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* strings */].ACTION_ITEM_SELECTOR).length;
	        }
	      });
	
	      /** @type {!MDCTopAppBarBaseFoundation} */
	      var foundation = void 0;
	      if (this.root_.classList.contains(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* cssClasses */].SHORT_CLASS)) {
	        foundation = new __WEBPACK_IMPORTED_MODULE_6__short_foundation__["a" /* default */](adapter);
	      } else if (this.root_.classList.contains(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* cssClasses */].FIXED_CLASS)) {
	        foundation = new __WEBPACK_IMPORTED_MODULE_5__fixed_foundation__["a" /* default */](adapter);
	      } else {
	        foundation = new __WEBPACK_IMPORTED_MODULE_7__standard_foundation__["a" /* default */](adapter);
	      }
	
	      return foundation;
	    }
	  }], [{
	    key: 'attachTo',
	    value: function attachTo(root) {
	      return new MDCTopAppBar(root);
	    }
	  }]);
	
	  return MDCTopAppBar;
	}(__WEBPACK_IMPORTED_MODULE_1__material_base_component__["a" /* default */]);
	
	
	
	/***/ }),
	
	/***/ 115:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__foundation__ = __webpack_require__(23);
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	/**
	 * @extends {MDCTopAppBarFoundation<!MDCFixedTopAppBarFoundation>}
	 * @final
	 */
	
	var MDCFixedTopAppBarFoundation = function (_MDCTopAppBarFoundati) {
	  _inherits(MDCFixedTopAppBarFoundation, _MDCTopAppBarFoundati);
	
	  /**
	   * @param {!MDCTopAppBarAdapter} adapter
	   */
	  function MDCFixedTopAppBarFoundation(adapter) {
	    _classCallCheck(this, MDCFixedTopAppBarFoundation);
	
	    /** State variable for the previous scroll iteration top app bar state */
	    var _this = _possibleConstructorReturn(this, (MDCFixedTopAppBarFoundation.__proto__ || Object.getPrototypeOf(MDCFixedTopAppBarFoundation)).call(this, adapter));
	
	    _this.wasScrolled_ = false;
	
	    _this.scrollHandler_ = function () {
	      return _this.fixedScrollHandler_();
	    };
	    return _this;
	  }
	
	  _createClass(MDCFixedTopAppBarFoundation, [{
	    key: 'init',
	    value: function init() {
	      _get(MDCFixedTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCFixedTopAppBarFoundation.prototype), 'init', this).call(this);
	      this.adapter_.registerScrollHandler(this.scrollHandler_);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get(MDCFixedTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCFixedTopAppBarFoundation.prototype), 'destroy', this).call(this);
	      this.adapter_.deregisterScrollHandler(this.scrollHandler_);
	    }
	
	    /**
	     * Scroll handler for applying/removing the modifier class
	     * on the fixed top app bar.
	     */
	
	  }, {
	    key: 'fixedScrollHandler_',
	    value: function fixedScrollHandler_() {
	      var currentScroll = this.adapter_.getViewportScrollY();
	
	      if (currentScroll <= 0) {
	        if (this.wasScrolled_) {
	          this.adapter_.removeClass(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* cssClasses */].FIXED_SCROLLED_CLASS);
	          this.wasScrolled_ = false;
	        }
	      } else {
	        if (!this.wasScrolled_) {
	          this.adapter_.addClass(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* cssClasses */].FIXED_SCROLLED_CLASS);
	          this.wasScrolled_ = true;
	        }
	      }
	    }
	  }]);
	
	  return MDCFixedTopAppBarFoundation;
	}(__WEBPACK_IMPORTED_MODULE_2__foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCFixedTopAppBarFoundation);
	
	/***/ }),
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adapter__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__foundation__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(21);
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	/**
	 * @extends {MDCTopAppBarBaseFoundation<!MDCShortTopAppBarFoundation>}
	 * @final
	 */
	
	var MDCShortTopAppBarFoundation = function (_MDCTopAppBarBaseFoun) {
	  _inherits(MDCShortTopAppBarFoundation, _MDCTopAppBarBaseFoun);
	
	  /**
	   * @param {!MDCTopAppBarAdapter} adapter
	   */
	  function MDCShortTopAppBarFoundation(adapter) {
	    _classCallCheck(this, MDCShortTopAppBarFoundation);
	
	    // State variable for the current top app bar state
	    var _this = _possibleConstructorReturn(this, (MDCShortTopAppBarFoundation.__proto__ || Object.getPrototypeOf(MDCShortTopAppBarFoundation)).call(this, adapter));
	
	    _this.isCollapsed = false;
	
	    _this.scrollHandler_ = function () {
	      return _this.shortAppBarScrollHandler_();
	    };
	    return _this;
	  }
	
	  _createClass(MDCShortTopAppBarFoundation, [{
	    key: 'init',
	    value: function init() {
	      _get(MDCShortTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCShortTopAppBarFoundation.prototype), 'init', this).call(this);
	      var isAlwaysCollapsed = this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */].SHORT_COLLAPSED_CLASS);
	
	      if (this.adapter_.getTotalActionItems() > 0) {
	        this.adapter_.addClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */].SHORT_HAS_ACTION_ITEM_CLASS);
	      }
	
	      if (!isAlwaysCollapsed) {
	        this.adapter_.registerScrollHandler(this.scrollHandler_);
	        this.shortAppBarScrollHandler_();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get(MDCShortTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCShortTopAppBarFoundation.prototype), 'destroy', this).call(this);
	      this.adapter_.deregisterScrollHandler(this.scrollHandler_);
	    }
	
	    /**
	     * Scroll handler for applying/removing the collapsed modifier class
	     * on the short top app bar.
	     * @private
	     */
	
	  }, {
	    key: 'shortAppBarScrollHandler_',
	    value: function shortAppBarScrollHandler_() {
	      var currentScroll = this.adapter_.getViewportScrollY();
	
	      if (currentScroll <= 0) {
	        if (this.isCollapsed) {
	          this.adapter_.removeClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */].SHORT_COLLAPSED_CLASS);
	          this.isCollapsed = false;
	        }
	      } else {
	        if (!this.isCollapsed) {
	          this.adapter_.addClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */].SHORT_COLLAPSED_CLASS);
	          this.isCollapsed = true;
	        }
	      }
	    }
	  }]);
	
	  return MDCShortTopAppBarFoundation;
	}(__WEBPACK_IMPORTED_MODULE_1__foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCShortTopAppBarFoundation);
	
	/***/ }),
	
	/***/ 117:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adapter__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__foundation__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(21);
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	var INITIAL_VALUE = 0;
	/**
	 * @extends {MDCTopAppBarBaseFoundation<!MDCTopAppBarFoundation>}
	 * @final
	 */
	
	var MDCTopAppBarFoundation = function (_MDCTopAppBarBaseFoun) {
	  _inherits(MDCTopAppBarFoundation, _MDCTopAppBarBaseFoun);
	
	  /**
	   * @param {!MDCTopAppBarAdapter} adapter
	   */
	  function MDCTopAppBarFoundation(adapter) {
	    _classCallCheck(this, MDCTopAppBarFoundation);
	
	    /**
	     * Used for diffs of current scroll position vs previous scroll position
	     * @private {number}
	     */
	    var _this = _possibleConstructorReturn(this, (MDCTopAppBarFoundation.__proto__ || Object.getPrototypeOf(MDCTopAppBarFoundation)).call(this, adapter));
	
	    _this.lastScrollPosition_ = _this.adapter_.getViewportScrollY();
	
	    /**
	     * Used to verify when the top app bar is completely showing or completely hidden
	     * @private {number}
	     */
	    _this.topAppBarHeight_ = _this.adapter_.getTopAppBarHeight();
	
	    /**
	     * wasDocked_ is used to indicate if the top app bar was docked in the previous
	     * scroll handler iteration.
	     * @private {boolean}
	     */
	    _this.wasDocked_ = true;
	
	    /**
	     * isDockedShowing_ is used to indicate if the top app bar is docked in the fully
	     * shown position.
	     * @private {boolean}
	     */
	    _this.isDockedShowing_ = true;
	
	    /**
	     * Variable for current scroll position of the top app bar
	     * @private {number}
	     */
	    _this.currentAppBarOffsetTop_ = 0;
	
	    /**
	     * Used to prevent the top app bar from being scrolled out of view during resize events
	     * @private {boolean} */
	    _this.isCurrentlyBeingResized_ = false;
	
	    /**
	     * The timeout that's used to throttle the resize events
	     * @private {number}
	     */
	    _this.resizeThrottleId_ = INITIAL_VALUE;
	
	    /**
	     * The timeout that's used to debounce toggling the isCurrentlyBeingResized_ variable after a resize
	     * @private {number}
	     */
	    _this.resizeDebounceId_ = INITIAL_VALUE;
	
	    _this.scrollHandler_ = function () {
	      return _this.topAppBarScrollHandler_();
	    };
	    _this.resizeHandler_ = function () {
	      return _this.topAppBarResizeHandler_();
	    };
	    return _this;
	  }
	
	  _createClass(MDCTopAppBarFoundation, [{
	    key: 'init',
	    value: function init() {
	      _get(MDCTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCTopAppBarFoundation.prototype), 'init', this).call(this);
	      this.adapter_.registerScrollHandler(this.scrollHandler_);
	      this.adapter_.registerResizeHandler(this.resizeHandler_);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get(MDCTopAppBarFoundation.prototype.__proto__ || Object.getPrototypeOf(MDCTopAppBarFoundation.prototype), 'destroy', this).call(this);
	      this.adapter_.deregisterScrollHandler(this.scrollHandler_);
	      this.adapter_.deregisterResizeHandler(this.resizeHandler_);
	      this.adapter_.setStyle('top', '');
	    }
	
	    /**
	     * Function to determine if the DOM needs to update.
	     * @return {boolean}
	     * @private
	     */
	
	  }, {
	    key: 'checkForUpdate_',
	    value: function checkForUpdate_() {
	      var offscreenBoundaryTop = -this.topAppBarHeight_;
	      var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop_ < 0;
	      var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop_ > offscreenBoundaryTop;
	      var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
	
	      // If it's partially showing, it can't be docked.
	      if (partiallyShowing) {
	        this.wasDocked_ = false;
	      } else {
	        // Not previously docked and not partially showing, it's now docked.
	        if (!this.wasDocked_) {
	          this.wasDocked_ = true;
	          return true;
	        } else if (this.isDockedShowing_ !== hasAnyPixelsOnscreen) {
	          this.isDockedShowing_ = hasAnyPixelsOnscreen;
	          return true;
	        }
	      }
	
	      return partiallyShowing;
	    }
	
	    /**
	     * Function to move the top app bar if needed.
	     * @private
	     */
	
	  }, {
	    key: 'moveTopAppBar_',
	    value: function moveTopAppBar_() {
	      if (this.checkForUpdate_()) {
	        // Once the top app bar is fully hidden we use the max potential top app bar height as our offset
	        // so the top app bar doesn't show if the window resizes and the new height > the old height.
	        var offset = this.currentAppBarOffsetTop_;
	        if (Math.abs(offset) >= this.topAppBarHeight_) {
	          offset = -__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */].MAX_TOP_APP_BAR_HEIGHT;
	        }
	
	        this.adapter_.setStyle('top', offset + 'px');
	      }
	    }
	
	    /**
	     * Scroll handler for the default scroll behavior of the top app bar.
	     * @private
	     */
	
	  }, {
	    key: 'topAppBarScrollHandler_',
	    value: function topAppBarScrollHandler_() {
	      var currentScrollPosition = Math.max(this.adapter_.getViewportScrollY(), 0);
	      var diff = currentScrollPosition - this.lastScrollPosition_;
	      this.lastScrollPosition_ = currentScrollPosition;
	
	      // If the window is being resized the lastScrollPosition_ needs to be updated but the
	      // current scroll of the top app bar should stay in the same position.
	      if (!this.isCurrentlyBeingResized_) {
	        this.currentAppBarOffsetTop_ -= diff;
	
	        if (this.currentAppBarOffsetTop_ > 0) {
	          this.currentAppBarOffsetTop_ = 0;
	        } else if (Math.abs(this.currentAppBarOffsetTop_) > this.topAppBarHeight_) {
	          this.currentAppBarOffsetTop_ = -this.topAppBarHeight_;
	        }
	
	        this.moveTopAppBar_();
	      }
	    }
	
	    /**
	     * Top app bar resize handler that throttle/debounce functions that execute updates.
	     * @private
	     */
	
	  }, {
	    key: 'topAppBarResizeHandler_',
	    value: function topAppBarResizeHandler_() {
	      var _this2 = this;
	
	      // Throttle resize events 10 p/s
	      if (!this.resizeThrottleId_) {
	        this.resizeThrottleId_ = setTimeout(function () {
	          _this2.resizeThrottleId_ = INITIAL_VALUE;
	          _this2.throttledResizeHandler_();
	        }, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */].DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
	      }
	
	      this.isCurrentlyBeingResized_ = true;
	
	      if (this.resizeDebounceId_) {
	        clearTimeout(this.resizeDebounceId_);
	      }
	
	      this.resizeDebounceId_ = setTimeout(function () {
	        _this2.topAppBarScrollHandler_();
	        _this2.isCurrentlyBeingResized_ = false;
	        _this2.resizeDebounceId_ = INITIAL_VALUE;
	      }, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */].DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
	    }
	
	    /**
	     * Throttled function that updates the top app bar scrolled values if the
	     * top app bar height changes.
	     * @private
	     */
	
	  }, {
	    key: 'throttledResizeHandler_',
	    value: function throttledResizeHandler_() {
	      var currentHeight = this.adapter_.getTopAppBarHeight();
	      if (this.topAppBarHeight_ !== currentHeight) {
	        this.wasDocked_ = false;
	
	        // Since the top app bar has a different height depending on the screen width, this
	        // will ensure that the top app bar remains in the correct location if
	        // completely hidden and a resize makes the top app bar a different height.
	        this.currentAppBarOffsetTop_ -= this.topAppBarHeight_ - currentHeight;
	        this.topAppBarHeight_ = currentHeight;
	      }
	      this.topAppBarScrollHandler_();
	    }
	  }]);
	
	  return MDCTopAppBarFoundation;
	}(__WEBPACK_IMPORTED_MODULE_1__foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCTopAppBarFoundation);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "supportsCssVariables", function() { return supportsCssVariables; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyPassive", function() { return applyPassive; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatchesProperty", function() { return getMatchesProperty; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNormalizedEventCoords", function() { return getNormalizedEventCoords; });
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Stores result from supportsCssVariables to avoid redundant processing to detect CSS custom variable support.
	 * @private {boolean|undefined}
	 */
	var supportsCssVariables_ = void 0;
	
	/**
	 * Stores result from applyPassive to avoid redundant processing to detect passive event listener support.
	 * @private {boolean|undefined}
	 */
	var supportsPassive_ = void 0;
	
	/**
	 * @param {!Window} windowObj
	 * @return {boolean}
	 */
	function detectEdgePseudoVarBug(windowObj) {
	  // Detect versions of Edge with buggy var() support
	  // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11495448/
	  var document = windowObj.document;
	  var node = document.createElement('div');
	  node.className = 'mdc-ripple-surface--test-edge-var-bug';
	  document.body.appendChild(node);
	
	  // The bug exists if ::before style ends up propagating to the parent element.
	  // Additionally, getComputedStyle returns null in iframes with display: "none" in Firefox,
	  // but Firefox is known to support CSS custom properties correctly.
	  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = windowObj.getComputedStyle(node);
	  var hasPseudoVarBug = computedStyle !== null && computedStyle.borderTopStyle === 'solid';
	  node.remove();
	  return hasPseudoVarBug;
	}
	
	/**
	 * @param {!Window} windowObj
	 * @param {boolean=} forceRefresh
	 * @return {boolean|undefined}
	 */
	
	function supportsCssVariables(windowObj) {
	  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var supportsCssVariables = supportsCssVariables_;
	  if (typeof supportsCssVariables_ === 'boolean' && !forceRefresh) {
	    return supportsCssVariables;
	  }
	
	  var supportsFunctionPresent = windowObj.CSS && typeof windowObj.CSS.supports === 'function';
	  if (!supportsFunctionPresent) {
	    return;
	  }
	
	  var explicitlySupportsCssVars = windowObj.CSS.supports('--css-vars', 'yes');
	  // See: https://bugs.webkit.org/show_bug.cgi?id=154669
	  // See: README section on Safari
	  var weAreFeatureDetectingSafari10plus = windowObj.CSS.supports('(--css-vars: yes)') && windowObj.CSS.supports('color', '#00000000');
	
	  if (explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus) {
	    supportsCssVariables = !detectEdgePseudoVarBug(windowObj);
	  } else {
	    supportsCssVariables = false;
	  }
	
	  if (!forceRefresh) {
	    supportsCssVariables_ = supportsCssVariables;
	  }
	  return supportsCssVariables;
	}
	
	//
	/**
	 * Determine whether the current browser supports passive event listeners, and if so, use them.
	 * @param {!Window=} globalObj
	 * @param {boolean=} forceRefresh
	 * @return {boolean|{passive: boolean}}
	 */
	function applyPassive() {
	  var globalObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
	  var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (supportsPassive_ === undefined || forceRefresh) {
	    var isSupported = false;
	    try {
	      globalObj.document.addEventListener('test', null, { get passive() {
	          isSupported = true;
	        } });
	    } catch (e) {}
	
	    supportsPassive_ = isSupported;
	  }
	
	  return supportsPassive_ ? { passive: true } : false;
	}
	
	/**
	 * @param {!Object} HTMLElementPrototype
	 * @return {!Array<string>}
	 */
	function getMatchesProperty(HTMLElementPrototype) {
	  return ['webkitMatchesSelector', 'msMatchesSelector', 'matches'].filter(function (p) {
	    return p in HTMLElementPrototype;
	  }).pop();
	}
	
	/**
	 * @param {!Event} ev
	 * @param {{x: number, y: number}} pageOffset
	 * @param {!ClientRect} clientRect
	 * @return {{x: number, y: number}}
	 */
	function getNormalizedEventCoords(ev, pageOffset, clientRect) {
	  var x = pageOffset.x,
	      y = pageOffset.y;
	
	  var documentX = x + clientRect.left;
	  var documentY = y + clientRect.top;
	
	  var normalizedX = void 0;
	  var normalizedY = void 0;
	  // Determine touch point relative to the ripple container.
	  if (ev.type === 'touchstart') {
	    normalizedX = ev.changedTouches[0].pageX - documentX;
	    normalizedY = ev.changedTouches[0].pageY - documentY;
	  } else {
	    normalizedX = ev.pageX - documentX;
	    normalizedY = ev.pageY - documentY;
	  }
	
	  return { x: normalizedX, y: normalizedY };
	}
	
	
	
	/***/ }),
	
	/***/ 20:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* eslint no-unused-vars: [2, {"args": "none"}] */
	
	/**
	 * Adapter for MDC Top App Bar
	 *
	 * Defines the shape of the adapter expected by the foundation. Implement this
	 * adapter to integrate the Top App Bar into your framework. See
	 * https://github.com/material-components/material-components-web/blob/master/docs/authoring-components.md
	 * for more information.
	 *
	 * @record
	 */
	var MDCTopAppBarAdapter = function () {
	  function MDCTopAppBarAdapter() {
	    _classCallCheck(this, MDCTopAppBarAdapter);
	  }
	
	  _createClass(MDCTopAppBarAdapter, [{
	    key: "addClass",
	
	    /**
	     * Adds a class to the root Element.
	     * @param {string} className
	     */
	    value: function addClass(className) {}
	
	    /**
	     * Removes a class from the root Element.
	     * @param {string} className
	     */
	
	  }, {
	    key: "removeClass",
	    value: function removeClass(className) {}
	
	    /**
	     * Returns true if the root Element contains the given class.
	     * @param {string} className
	     * @return {boolean}
	     */
	
	  }, {
	    key: "hasClass",
	    value: function hasClass(className) {}
	
	    /**
	     * Sets the specified inline style property on the root Element to the given value.
	     * @param {string} property
	     * @param {string} value
	     */
	
	  }, {
	    key: "setStyle",
	    value: function setStyle(property, value) {}
	
	    /**
	     * Gets the height of the top app bar.
	     * @return {number}
	     */
	
	  }, {
	    key: "getTopAppBarHeight",
	    value: function getTopAppBarHeight() {}
	
	    /**
	     * Registers an event handler on the navigation icon element for a given event.
	     * @param {string} type
	     * @param {function(!Event): undefined} handler
	     */
	
	  }, {
	    key: "registerNavigationIconInteractionHandler",
	    value: function registerNavigationIconInteractionHandler(type, handler) {}
	
	    /**
	     * Deregisters an event handler on the navigation icon element for a given event.
	     * @param {string} type
	     * @param {function(!Event): undefined} handler
	     */
	
	  }, {
	    key: "deregisterNavigationIconInteractionHandler",
	    value: function deregisterNavigationIconInteractionHandler(type, handler) {}
	
	    /**
	     * Emits an event when the navigation icon is clicked.
	     */
	
	  }, {
	    key: "notifyNavigationIconClicked",
	    value: function notifyNavigationIconClicked() {}
	
	    /** @param {function(!Event)} handler */
	
	  }, {
	    key: "registerScrollHandler",
	    value: function registerScrollHandler(handler) {}
	
	    /** @param {function(!Event)} handler */
	
	  }, {
	    key: "deregisterScrollHandler",
	    value: function deregisterScrollHandler(handler) {}
	
	    /** @param {function(!Event)} handler */
	
	  }, {
	    key: "registerResizeHandler",
	    value: function registerResizeHandler(handler) {}
	
	    /** @param {function(!Event)} handler */
	
	  }, {
	    key: "deregisterResizeHandler",
	    value: function deregisterResizeHandler(handler) {}
	
	    /** @return {number} */
	
	  }, {
	    key: "getViewportScrollY",
	    value: function getViewportScrollY() {}
	
	    /** @return {number} */
	
	  }, {
	    key: "getTotalActionItems",
	    value: function getTotalActionItems() {}
	  }]);
	
	  return MDCTopAppBarAdapter;
	}();
	
	/* unused harmony default export */ var _unused_webpack_default_export = (MDCTopAppBarAdapter);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return strings; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cssClasses; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numbers; });
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @enum {string} */
	var cssClasses = {
	  FIXED_CLASS: 'mdc-top-app-bar--fixed',
	  FIXED_SCROLLED_CLASS: 'mdc-top-app-bar--fixed-scrolled',
	  SHORT_CLASS: 'mdc-top-app-bar--short',
	  SHORT_HAS_ACTION_ITEM_CLASS: 'mdc-top-app-bar--short-has-action-item',
	  SHORT_COLLAPSED_CLASS: 'mdc-top-app-bar--short-collapsed'
	};
	
	/** @enum {number} */
	var numbers = {
	  DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
	  MAX_TOP_APP_BAR_HEIGHT: 128
	};
	
	/** @enum {string} */
	var strings = {
	  ACTION_ITEM_SELECTOR: '.mdc-top-app-bar__action-item',
	  NAVIGATION_EVENT: 'MDCTopAppBar:nav',
	  NAVIGATION_ICON_SELECTOR: '.mdc-top-app-bar__navigation-icon',
	  ROOT_SELECTOR: '.mdc-top-app-bar',
	  TITLE_SELECTOR: '.mdc-top-app-bar__title'
	};
	
	
	
	/***/ }),
	
	/***/ 23:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_base_foundation__ = __webpack_require__(0);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	/**
	 * @extends {MDCFoundation<!MDCTopAppBarAdapter>}
	 */
	
	var MDCTopAppBarBaseFoundation = function (_MDCFoundation) {
	  _inherits(MDCTopAppBarBaseFoundation, _MDCFoundation);
	
	  _createClass(MDCTopAppBarBaseFoundation, null, [{
	    key: 'strings',
	
	    /** @return enum {string} */
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* strings */];
	    }
	
	    /** @return enum {string} */
	
	  }, {
	    key: 'cssClasses',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* cssClasses */];
	    }
	
	    /** @return enum {number} */
	
	  }, {
	    key: 'numbers',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* numbers */];
	    }
	
	    /**
	     * {@see MDCTopAppBarAdapter} for typing information on parameters and return
	     * types.
	     * @return {!MDCTopAppBarAdapter}
	     */
	
	  }, {
	    key: 'defaultAdapter',
	    get: function get() {
	      return (/** @type {!MDCTopAppBarAdapter} */{
	          hasClass: function hasClass() /* className: string */{},
	          addClass: function addClass() /* className: string */{},
	          removeClass: function removeClass() /* className: string */{},
	          setStyle: function setStyle() /* property: string, value: string */{},
	          getTopAppBarHeight: function getTopAppBarHeight() {},
	          registerNavigationIconInteractionHandler: function registerNavigationIconInteractionHandler() /* type: string, handler: EventListener */{},
	          deregisterNavigationIconInteractionHandler: function deregisterNavigationIconInteractionHandler() /* type: string, handler: EventListener */{},
	          notifyNavigationIconClicked: function notifyNavigationIconClicked() {},
	          registerScrollHandler: function registerScrollHandler() /* handler: EventListener */{},
	          deregisterScrollHandler: function deregisterScrollHandler() /* handler: EventListener */{},
	          registerResizeHandler: function registerResizeHandler() /* handler: EventListener */{},
	          deregisterResizeHandler: function deregisterResizeHandler() /* handler: EventListener */{},
	          getViewportScrollY: function getViewportScrollY() {
	            return (/* number */0
	            );
	          },
	          getTotalActionItems: function getTotalActionItems() {
	            return (/* number */0
	            );
	          }
	        }
	      );
	    }
	
	    /**
	     * @param {!MDCTopAppBarAdapter} adapter
	     */
	
	  }]);
	
	  function MDCTopAppBarBaseFoundation( /** @type {!MDCTopAppBarAdapter} */adapter) {
	    _classCallCheck(this, MDCTopAppBarBaseFoundation);
	
	    var _this = _possibleConstructorReturn(this, (MDCTopAppBarBaseFoundation.__proto__ || Object.getPrototypeOf(MDCTopAppBarBaseFoundation)).call(this, _extends(MDCTopAppBarBaseFoundation.defaultAdapter, adapter)));
	
	    _this.navClickHandler_ = function () {
	      return _this.adapter_.notifyNavigationIconClicked();
	    };
	    return _this;
	  }
	
	  _createClass(MDCTopAppBarBaseFoundation, [{
	    key: 'init',
	    value: function init() {
	      this.adapter_.registerNavigationIconInteractionHandler('click', this.navClickHandler_);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.adapter_.deregisterNavigationIconInteractionHandler('click', this.navClickHandler_);
	    }
	  }]);
	
	  return MDCTopAppBarBaseFoundation;
	}(__WEBPACK_IMPORTED_MODULE_2__material_base_foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCTopAppBarBaseFoundation);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* eslint no-unused-vars: [2, {"args": "none"}] */
	
	/**
	 * Adapter for MDC Ripple. Provides an interface for managing
	 * - classes
	 * - dom
	 * - CSS variables
	 * - position
	 * - dimensions
	 * - scroll position
	 * - event handlers
	 * - unbounded, active and disabled states
	 *
	 * Additionally, provides type information for the adapter to the Closure
	 * compiler.
	 *
	 * Implement this adapter for your framework of choice to delegate updates to
	 * the component in your framework of choice. See architecture documentation
	 * for more details.
	 * https://github.com/material-components/material-components-web/blob/master/docs/code/architecture.md
	 *
	 * @record
	 */
	var MDCRippleAdapter = function () {
	  function MDCRippleAdapter() {
	    _classCallCheck(this, MDCRippleAdapter);
	  }
	
	  _createClass(MDCRippleAdapter, [{
	    key: "browserSupportsCssVars",
	
	    /** @return {boolean} */
	    value: function browserSupportsCssVars() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isUnbounded",
	    value: function isUnbounded() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isSurfaceActive",
	    value: function isSurfaceActive() {}
	
	    /** @return {boolean} */
	
	  }, {
	    key: "isSurfaceDisabled",
	    value: function isSurfaceDisabled() {}
	
	    /** @param {string} className */
	
	  }, {
	    key: "addClass",
	    value: function addClass(className) {}
	
	    /** @param {string} className */
	
	  }, {
	    key: "removeClass",
	    value: function removeClass(className) {}
	
	    /** @param {!EventTarget} target */
	
	  }, {
	    key: "containsEventTarget",
	    value: function containsEventTarget(target) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerInteractionHandler",
	    value: function registerInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterInteractionHandler",
	    value: function deregisterInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerDocumentInteractionHandler",
	    value: function registerDocumentInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {string} evtType
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterDocumentInteractionHandler",
	    value: function deregisterDocumentInteractionHandler(evtType, handler) {}
	
	    /**
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "registerResizeHandler",
	    value: function registerResizeHandler(handler) {}
	
	    /**
	     * @param {!Function} handler
	     */
	
	  }, {
	    key: "deregisterResizeHandler",
	    value: function deregisterResizeHandler(handler) {}
	
	    /**
	     * @param {string} varName
	     * @param {?number|string} value
	     */
	
	  }, {
	    key: "updateCssVariable",
	    value: function updateCssVariable(varName, value) {}
	
	    /** @return {!ClientRect} */
	
	  }, {
	    key: "computeBoundingRect",
	    value: function computeBoundingRect() {}
	
	    /** @return {{x: number, y: number}} */
	
	  }, {
	    key: "getWindowPageOffset",
	    value: function getWindowPageOffset() {}
	  }]);
	
	  return MDCRippleAdapter;
	}();
	
	/* unused harmony default export */ var _unused_webpack_default_export = (MDCRippleAdapter);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDCRipple", function() { return MDCRipple; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RippleCapableSurface", function() { return RippleCapableSurface; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_base_component__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__foundation__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MDCRippleFoundation", function() { return __WEBPACK_IMPORTED_MODULE_2__foundation__["a"]; });
	/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "util", function() { return __WEBPACK_IMPORTED_MODULE_3__util__; });
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	
	/**
	 * @extends MDCComponent<!MDCRippleFoundation>
	 */
	
	var MDCRipple = function (_MDCComponent) {
	  _inherits(MDCRipple, _MDCComponent);
	
	  /** @param {...?} args */
	  function MDCRipple() {
	    var _ref;
	
	    _classCallCheck(this, MDCRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    /** @type {boolean} */
	    var _this = _possibleConstructorReturn(this, (_ref = MDCRipple.__proto__ || Object.getPrototypeOf(MDCRipple)).call.apply(_ref, [this].concat(args)));
	
	    _this.disabled = false;
	
	    /** @private {boolean} */
	    _this.unbounded_;
	    return _this;
	  }
	
	  /**
	   * @param {!Element} root
	   * @param {{isUnbounded: (boolean|undefined)}=} options
	   * @return {!MDCRipple}
	   */
	
	
	  _createClass(MDCRipple, [{
	    key: 'setUnbounded_',
	
	
	    /**
	     * Closure Compiler throws an access control error when directly accessing a
	     * protected or private property inside a getter/setter, like unbounded above.
	     * By accessing the protected property inside a method, we solve that problem.
	     * That's why this function exists.
	     * @private
	     */
	    value: function setUnbounded_() {
	      this.foundation_.setUnbounded(this.unbounded_);
	    }
	  }, {
	    key: 'activate',
	    value: function activate() {
	      this.foundation_.activate();
	    }
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this.foundation_.deactivate();
	    }
	  }, {
	    key: 'layout',
	    value: function layout() {
	      this.foundation_.layout();
	    }
	
	    /** @return {!MDCRippleFoundation} */
	
	  }, {
	    key: 'getDefaultFoundation',
	    value: function getDefaultFoundation() {
	      return new __WEBPACK_IMPORTED_MODULE_2__foundation__["a" /* default */](MDCRipple.createAdapter(this));
	    }
	  }, {
	    key: 'initialSyncWithDOM',
	    value: function initialSyncWithDOM() {
	      this.unbounded = 'mdcRippleIsUnbounded' in this.root_.dataset;
	    }
	  }, {
	    key: 'unbounded',
	
	
	    /** @return {boolean} */
	    get: function get() {
	      return this.unbounded_;
	    }
	
	    /** @param {boolean} unbounded */
	    ,
	    set: function set(unbounded) {
	      this.unbounded_ = Boolean(unbounded);
	      this.setUnbounded_();
	    }
	  }], [{
	    key: 'attachTo',
	    value: function attachTo(root) {
	      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref2$isUnbounded = _ref2.isUnbounded,
	          isUnbounded = _ref2$isUnbounded === undefined ? undefined : _ref2$isUnbounded;
	
	      var ripple = new MDCRipple(root);
	      // Only override unbounded behavior if option is explicitly specified
	      if (isUnbounded !== undefined) {
	        ripple.unbounded = /** @type {boolean} */isUnbounded;
	      }
	      return ripple;
	    }
	
	    /**
	     * @param {!RippleCapableSurface} instance
	     * @return {!MDCRippleAdapter}
	     */
	
	  }, {
	    key: 'createAdapter',
	    value: function createAdapter(instance) {
	      var MATCHES = __WEBPACK_IMPORTED_MODULE_3__util__["getMatchesProperty"](HTMLElement.prototype);
	
	      return {
	        browserSupportsCssVars: function browserSupportsCssVars() {
	          return __WEBPACK_IMPORTED_MODULE_3__util__["supportsCssVariables"](window);
	        },
	        isUnbounded: function isUnbounded() {
	          return instance.unbounded;
	        },
	        isSurfaceActive: function isSurfaceActive() {
	          return instance.root_[MATCHES](':active');
	        },
	        isSurfaceDisabled: function isSurfaceDisabled() {
	          return instance.disabled;
	        },
	        addClass: function addClass(className) {
	          return instance.root_.classList.add(className);
	        },
	        removeClass: function removeClass(className) {
	          return instance.root_.classList.remove(className);
	        },
	        containsEventTarget: function containsEventTarget(target) {
	          return instance.root_.contains(target);
	        },
	        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
	          return instance.root_.addEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
	          return instance.root_.removeEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
	          return document.documentElement.addEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
	          return document.documentElement.removeEventListener(evtType, handler, __WEBPACK_IMPORTED_MODULE_3__util__["applyPassive"]());
	        },
	        registerResizeHandler: function registerResizeHandler(handler) {
	          return window.addEventListener('resize', handler);
	        },
	        deregisterResizeHandler: function deregisterResizeHandler(handler) {
	          return window.removeEventListener('resize', handler);
	        },
	        updateCssVariable: function updateCssVariable(varName, value) {
	          return instance.root_.style.setProperty(varName, value);
	        },
	        computeBoundingRect: function computeBoundingRect() {
	          return instance.root_.getBoundingClientRect();
	        },
	        getWindowPageOffset: function getWindowPageOffset() {
	          return { x: window.pageXOffset, y: window.pageYOffset };
	        }
	      };
	    }
	  }]);
	
	  return MDCRipple;
	}(__WEBPACK_IMPORTED_MODULE_0__material_base_component__["a" /* default */]);
	
	/**
	 * See Material Design spec for more details on when to use ripples.
	 * https://material.io/guidelines/motion/choreography.html#choreography-creation
	 * @record
	 */
	
	
	var RippleCapableSurface = function RippleCapableSurface() {
	  _classCallCheck(this, RippleCapableSurface);
	};
	
	/** @protected {!Element} */
	
	
	RippleCapableSurface.prototype.root_;
	
	/**
	 * Whether or not the ripple bleeds out of the bounds of the element.
	 * @type {boolean|undefined}
	 */
	RippleCapableSurface.prototype.unbounded;
	
	/**
	 * Whether or not the ripple is attached to a disabled component.
	 * @type {boolean|undefined}
	 */
	RippleCapableSurface.prototype.disabled;
	
	
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_base_foundation__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapter__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	
	
	
	
	/**
	 * @typedef {{
	 *   isActivated: (boolean|undefined),
	 *   hasDeactivationUXRun: (boolean|undefined),
	 *   wasActivatedByPointer: (boolean|undefined),
	 *   wasElementMadeActive: (boolean|undefined),
	 *   activationEvent: Event,
	 *   isProgrammatic: (boolean|undefined)
	 * }}
	 */
	var ActivationStateType = void 0;
	
	/**
	 * @typedef {{
	 *   activate: (string|undefined),
	 *   deactivate: (string|undefined),
	 *   focus: (string|undefined),
	 *   blur: (string|undefined)
	 * }}
	 */
	var ListenerInfoType = void 0;
	
	/**
	 * @typedef {{
	 *   activate: function(!Event),
	 *   deactivate: function(!Event),
	 *   focus: function(),
	 *   blur: function()
	 * }}
	 */
	var ListenersType = void 0;
	
	/**
	 * @typedef {{
	 *   x: number,
	 *   y: number
	 * }}
	 */
	var PointType = void 0;
	
	// Activation events registered on the root element of each instance for activation
	var ACTIVATION_EVENT_TYPES = ['touchstart', 'pointerdown', 'mousedown', 'keydown'];
	
	// Deactivation events registered on documentElement when a pointer-related down event occurs
	var POINTER_DEACTIVATION_EVENT_TYPES = ['touchend', 'pointerup', 'mouseup'];
	
	// Tracks activations that have occurred on the current frame, to avoid simultaneous nested activations
	/** @type {!Array<!EventTarget>} */
	var activatedTargets = [];
	
	/**
	 * @extends {MDCFoundation<!MDCRippleAdapter>}
	 */
	
	var MDCRippleFoundation = function (_MDCFoundation) {
	  _inherits(MDCRippleFoundation, _MDCFoundation);
	
	  _createClass(MDCRippleFoundation, null, [{
	    key: 'cssClasses',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* cssClasses */];
	    }
	  }, {
	    key: 'strings',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* strings */];
	    }
	  }, {
	    key: 'numbers',
	    get: function get() {
	      return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */];
	    }
	  }, {
	    key: 'defaultAdapter',
	    get: function get() {
	      return {
	        browserSupportsCssVars: function browserSupportsCssVars() /* boolean - cached */{},
	        isUnbounded: function isUnbounded() /* boolean */{},
	        isSurfaceActive: function isSurfaceActive() /* boolean */{},
	        isSurfaceDisabled: function isSurfaceDisabled() /* boolean */{},
	        addClass: function addClass() /* className: string */{},
	        removeClass: function removeClass() /* className: string */{},
	        containsEventTarget: function containsEventTarget() /* target: !EventTarget */{},
	        registerInteractionHandler: function registerInteractionHandler() /* evtType: string, handler: EventListener */{},
	        deregisterInteractionHandler: function deregisterInteractionHandler() /* evtType: string, handler: EventListener */{},
	        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() /* evtType: string, handler: EventListener */{},
	        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() /* evtType: string, handler: EventListener */{},
	        registerResizeHandler: function registerResizeHandler() /* handler: EventListener */{},
	        deregisterResizeHandler: function deregisterResizeHandler() /* handler: EventListener */{},
	        updateCssVariable: function updateCssVariable() /* varName: string, value: string */{},
	        computeBoundingRect: function computeBoundingRect() /* ClientRect */{},
	        getWindowPageOffset: function getWindowPageOffset() /* {x: number, y: number} */{}
	      };
	    }
	  }]);
	
	  function MDCRippleFoundation(adapter) {
	    _classCallCheck(this, MDCRippleFoundation);
	
	    /** @private {number} */
	    var _this = _possibleConstructorReturn(this, (MDCRippleFoundation.__proto__ || Object.getPrototypeOf(MDCRippleFoundation)).call(this, _extends(MDCRippleFoundation.defaultAdapter, adapter)));
	
	    _this.layoutFrame_ = 0;
	
	    /** @private {!ClientRect} */
	    _this.frame_ = /** @type {!ClientRect} */{ width: 0, height: 0 };
	
	    /** @private {!ActivationStateType} */
	    _this.activationState_ = _this.defaultActivationState_();
	
	    /** @private {number} */
	    _this.initialSize_ = 0;
	
	    /** @private {number} */
	    _this.maxRadius_ = 0;
	
	    /** @private {function(!Event)} */
	    _this.activateHandler_ = function (e) {
	      return _this.activate_(e);
	    };
	
	    /** @private {function(!Event)} */
	    _this.deactivateHandler_ = function (e) {
	      return _this.deactivate_(e);
	    };
	
	    /** @private {function(?Event=)} */
	    _this.focusHandler_ = function () {
	      return requestAnimationFrame(function () {
	        return _this.adapter_.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
	      });
	    };
	
	    /** @private {function(?Event=)} */
	    _this.blurHandler_ = function () {
	      return requestAnimationFrame(function () {
	        return _this.adapter_.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
	      });
	    };
	
	    /** @private {!Function} */
	    _this.resizeHandler_ = function () {
	      return _this.layout();
	    };
	
	    /** @private {{left: number, top:number}} */
	    _this.unboundedCoords_ = {
	      left: 0,
	      top: 0
	    };
	
	    /** @private {number} */
	    _this.fgScale_ = 0;
	
	    /** @private {number} */
	    _this.activationTimer_ = 0;
	
	    /** @private {number} */
	    _this.fgDeactivationRemovalTimer_ = 0;
	
	    /** @private {boolean} */
	    _this.activationAnimationHasEnded_ = false;
	
	    /** @private {!Function} */
	    _this.activationTimerCallback_ = function () {
	      _this.activationAnimationHasEnded_ = true;
	      _this.runDeactivationUXLogicIfReady_();
	    };
	
	    /** @private {?Event} */
	    _this.previousActivationEvent_ = null;
	    return _this;
	  }
	
	  /**
	   * We compute this property so that we are not querying information about the client
	   * until the point in time where the foundation requests it. This prevents scenarios where
	   * client-side feature-detection may happen too early, such as when components are rendered on the server
	   * and then initialized at mount time on the client.
	   * @return {boolean}
	   * @private
	   */
	
	
	  _createClass(MDCRippleFoundation, [{
	    key: 'isSupported_',
	    value: function isSupported_() {
	      return this.adapter_.browserSupportsCssVars();
	    }
	
	    /**
	     * @return {!ActivationStateType}
	     */
	
	  }, {
	    key: 'defaultActivationState_',
	    value: function defaultActivationState_() {
	      return {
	        isActivated: false,
	        hasDeactivationUXRun: false,
	        wasActivatedByPointer: false,
	        wasElementMadeActive: false,
	        activationEvent: null,
	        isProgrammatic: false
	      };
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      if (!this.isSupported_()) {
	        return;
	      }
	      this.registerRootHandlers_();
	
	      var _MDCRippleFoundation$ = MDCRippleFoundation.cssClasses,
	          ROOT = _MDCRippleFoundation$.ROOT,
	          UNBOUNDED = _MDCRippleFoundation$.UNBOUNDED;
	
	      requestAnimationFrame(function () {
	        _this2.adapter_.addClass(ROOT);
	        if (_this2.adapter_.isUnbounded()) {
	          _this2.adapter_.addClass(UNBOUNDED);
	          // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
	          _this2.layoutInternal_();
	        }
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this3 = this;
	
	      if (!this.isSupported_()) {
	        return;
	      }
	
	      if (this.activationTimer_) {
	        clearTimeout(this.activationTimer_);
	        this.activationTimer_ = 0;
	        var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
	
	        this.adapter_.removeClass(FG_ACTIVATION);
	      }
	
	      this.deregisterRootHandlers_();
	      this.deregisterDeactivationHandlers_();
	
	      var _MDCRippleFoundation$2 = MDCRippleFoundation.cssClasses,
	          ROOT = _MDCRippleFoundation$2.ROOT,
	          UNBOUNDED = _MDCRippleFoundation$2.UNBOUNDED;
	
	      requestAnimationFrame(function () {
	        _this3.adapter_.removeClass(ROOT);
	        _this3.adapter_.removeClass(UNBOUNDED);
	        _this3.removeCssVars_();
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'registerRootHandlers_',
	    value: function registerRootHandlers_() {
	      var _this4 = this;
	
	      ACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this4.adapter_.registerInteractionHandler(type, _this4.activateHandler_);
	      });
	      this.adapter_.registerInteractionHandler('focus', this.focusHandler_);
	      this.adapter_.registerInteractionHandler('blur', this.blurHandler_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.adapter_.registerResizeHandler(this.resizeHandler_);
	      }
	    }
	
	    /**
	     * @param {!Event} e
	     * @private
	     */
	
	  }, {
	    key: 'registerDeactivationHandlers_',
	    value: function registerDeactivationHandlers_(e) {
	      var _this5 = this;
	
	      if (e.type === 'keydown') {
	        this.adapter_.registerInteractionHandler('keyup', this.deactivateHandler_);
	      } else {
	        POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (type) {
	          _this5.adapter_.registerDocumentInteractionHandler(type, _this5.deactivateHandler_);
	        });
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'deregisterRootHandlers_',
	    value: function deregisterRootHandlers_() {
	      var _this6 = this;
	
	      ACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this6.adapter_.deregisterInteractionHandler(type, _this6.activateHandler_);
	      });
	      this.adapter_.deregisterInteractionHandler('focus', this.focusHandler_);
	      this.adapter_.deregisterInteractionHandler('blur', this.blurHandler_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.adapter_.deregisterResizeHandler(this.resizeHandler_);
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'deregisterDeactivationHandlers_',
	    value: function deregisterDeactivationHandlers_() {
	      var _this7 = this;
	
	      this.adapter_.deregisterInteractionHandler('keyup', this.deactivateHandler_);
	      POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (type) {
	        _this7.adapter_.deregisterDocumentInteractionHandler(type, _this7.deactivateHandler_);
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'removeCssVars_',
	    value: function removeCssVars_() {
	      var _this8 = this;
	
	      var strings = MDCRippleFoundation.strings;
	
	      Object.keys(strings).forEach(function (k) {
	        if (k.indexOf('VAR_') === 0) {
	          _this8.adapter_.updateCssVariable(strings[k], null);
	        }
	      });
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'activate_',
	    value: function activate_(e) {
	      var _this9 = this;
	
	      if (this.adapter_.isSurfaceDisabled()) {
	        return;
	      }
	
	      var activationState = this.activationState_;
	      if (activationState.isActivated) {
	        return;
	      }
	
	      // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
	      var previousActivationEvent = this.previousActivationEvent_;
	      var isSameInteraction = previousActivationEvent && e && previousActivationEvent.type !== e.type;
	      if (isSameInteraction) {
	        return;
	      }
	
	      activationState.isActivated = true;
	      activationState.isProgrammatic = e === null;
	      activationState.activationEvent = e;
	      activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : e.type === 'mousedown' || e.type === 'touchstart' || e.type === 'pointerdown';
	
	      var hasActivatedChild = e && activatedTargets.length > 0 && activatedTargets.some(function (target) {
	        return _this9.adapter_.containsEventTarget(target);
	      });
	      if (hasActivatedChild) {
	        // Immediately reset activation state, while preserving logic that prevents touch follow-on events
	        this.resetActivationState_();
	        return;
	      }
	
	      if (e) {
	        activatedTargets.push( /** @type {!EventTarget} */e.target);
	        this.registerDeactivationHandlers_(e);
	      }
	
	      activationState.wasElementMadeActive = this.checkElementMadeActive_(e);
	      if (activationState.wasElementMadeActive) {
	        this.animateActivation_();
	      }
	
	      requestAnimationFrame(function () {
	        // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
	        activatedTargets = [];
	
	        if (!activationState.wasElementMadeActive && (e.key === ' ' || e.keyCode === 32)) {
	          // If space was pressed, try again within an rAF call to detect :active, because different UAs report
	          // active states inconsistently when they're called within event handling code:
	          // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
	          // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
	          // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
	          // variable is set within a rAF callback for a submit button interaction (#2241).
	          activationState.wasElementMadeActive = _this9.checkElementMadeActive_(e);
	          if (activationState.wasElementMadeActive) {
	            _this9.animateActivation_();
	          }
	        }
	
	        if (!activationState.wasElementMadeActive) {
	          // Reset activation state immediately if element was not made active.
	          _this9.activationState_ = _this9.defaultActivationState_();
	        }
	      });
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'checkElementMadeActive_',
	    value: function checkElementMadeActive_(e) {
	      return e && e.type === 'keydown' ? this.adapter_.isSurfaceActive() : true;
	    }
	
	    /**
	     * @param {?Event=} event Optional event containing position information.
	     */
	
	  }, {
	    key: 'activate',
	    value: function activate() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.activate_(event);
	    }
	
	    /** @private */
	
	  }, {
	    key: 'animateActivation_',
	    value: function animateActivation_() {
	      var _this10 = this;
	
	      var _MDCRippleFoundation$3 = MDCRippleFoundation.strings,
	          VAR_FG_TRANSLATE_START = _MDCRippleFoundation$3.VAR_FG_TRANSLATE_START,
	          VAR_FG_TRANSLATE_END = _MDCRippleFoundation$3.VAR_FG_TRANSLATE_END;
	      var _MDCRippleFoundation$4 = MDCRippleFoundation.cssClasses,
	          FG_DEACTIVATION = _MDCRippleFoundation$4.FG_DEACTIVATION,
	          FG_ACTIVATION = _MDCRippleFoundation$4.FG_ACTIVATION;
	      var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
	
	
	      this.layoutInternal_();
	
	      var translateStart = '';
	      var translateEnd = '';
	
	      if (!this.adapter_.isUnbounded()) {
	        var _getFgTranslationCoor = this.getFgTranslationCoordinates_(),
	            startPoint = _getFgTranslationCoor.startPoint,
	            endPoint = _getFgTranslationCoor.endPoint;
	
	        translateStart = startPoint.x + 'px, ' + startPoint.y + 'px';
	        translateEnd = endPoint.x + 'px, ' + endPoint.y + 'px';
	      }
	
	      this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
	      this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
	      // Cancel any ongoing activation/deactivation animations
	      clearTimeout(this.activationTimer_);
	      clearTimeout(this.fgDeactivationRemovalTimer_);
	      this.rmBoundedActivationClasses_();
	      this.adapter_.removeClass(FG_DEACTIVATION);
	
	      // Force layout in order to re-trigger the animation.
	      this.adapter_.computeBoundingRect();
	      this.adapter_.addClass(FG_ACTIVATION);
	      this.activationTimer_ = setTimeout(function () {
	        return _this10.activationTimerCallback_();
	      }, DEACTIVATION_TIMEOUT_MS);
	    }
	
	    /**
	     * @private
	     * @return {{startPoint: PointType, endPoint: PointType}}
	     */
	
	  }, {
	    key: 'getFgTranslationCoordinates_',
	    value: function getFgTranslationCoordinates_() {
	      var _activationState_ = this.activationState_,
	          activationEvent = _activationState_.activationEvent,
	          wasActivatedByPointer = _activationState_.wasActivatedByPointer;
	
	
	      var startPoint = void 0;
	      if (wasActivatedByPointer) {
	        startPoint = Object(__WEBPACK_IMPORTED_MODULE_3__util__["getNormalizedEventCoords"])(
	        /** @type {!Event} */activationEvent, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect());
	      } else {
	        startPoint = {
	          x: this.frame_.width / 2,
	          y: this.frame_.height / 2
	        };
	      }
	      // Center the element around the start point.
	      startPoint = {
	        x: startPoint.x - this.initialSize_ / 2,
	        y: startPoint.y - this.initialSize_ / 2
	      };
	
	      var endPoint = {
	        x: this.frame_.width / 2 - this.initialSize_ / 2,
	        y: this.frame_.height / 2 - this.initialSize_ / 2
	      };
	
	      return { startPoint: startPoint, endPoint: endPoint };
	    }
	
	    /** @private */
	
	  }, {
	    key: 'runDeactivationUXLogicIfReady_',
	    value: function runDeactivationUXLogicIfReady_() {
	      var _this11 = this;
	
	      // This method is called both when a pointing device is released, and when the activation animation ends.
	      // The deactivation animation should only run after both of those occur.
	      var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
	      var _activationState_2 = this.activationState_,
	          hasDeactivationUXRun = _activationState_2.hasDeactivationUXRun,
	          isActivated = _activationState_2.isActivated;
	
	      var activationHasEnded = hasDeactivationUXRun || !isActivated;
	
	      if (activationHasEnded && this.activationAnimationHasEnded_) {
	        this.rmBoundedActivationClasses_();
	        this.adapter_.addClass(FG_DEACTIVATION);
	        this.fgDeactivationRemovalTimer_ = setTimeout(function () {
	          _this11.adapter_.removeClass(FG_DEACTIVATION);
	        }, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* numbers */].FG_DEACTIVATION_MS);
	      }
	    }
	
	    /** @private */
	
	  }, {
	    key: 'rmBoundedActivationClasses_',
	    value: function rmBoundedActivationClasses_() {
	      var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
	
	      this.adapter_.removeClass(FG_ACTIVATION);
	      this.activationAnimationHasEnded_ = false;
	      this.adapter_.computeBoundingRect();
	    }
	  }, {
	    key: 'resetActivationState_',
	    value: function resetActivationState_() {
	      var _this12 = this;
	
	      this.previousActivationEvent_ = this.activationState_.activationEvent;
	      this.activationState_ = this.defaultActivationState_();
	      // Touch devices may fire additional events for the same interaction within a short time.
	      // Store the previous event until it's safe to assume that subsequent events are for new interactions.
	      setTimeout(function () {
	        return _this12.previousActivationEvent_ = null;
	      }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
	    }
	
	    /**
	     * @param {?Event} e
	     * @private
	     */
	
	  }, {
	    key: 'deactivate_',
	    value: function deactivate_(e) {
	      var _this13 = this;
	
	      var activationState = this.activationState_;
	      // This can happen in scenarios such as when you have a keyup event that blurs the element.
	      if (!activationState.isActivated) {
	        return;
	      }
	
	      var state = /** @type {!ActivationStateType} */_extends({}, activationState);
	
	      if (activationState.isProgrammatic) {
	        var evtObject = null;
	        requestAnimationFrame(function () {
	          return _this13.animateDeactivation_(evtObject, state);
	        });
	        this.resetActivationState_();
	      } else {
	        this.deregisterDeactivationHandlers_();
	        requestAnimationFrame(function () {
	          _this13.activationState_.hasDeactivationUXRun = true;
	          _this13.animateDeactivation_(e, state);
	          _this13.resetActivationState_();
	        });
	      }
	    }
	
	    /**
	     * @param {?Event=} event Optional event containing position information.
	     */
	
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.deactivate_(event);
	    }
	
	    /**
	     * @param {Event} e
	     * @param {!ActivationStateType} options
	     * @private
	     */
	
	  }, {
	    key: 'animateDeactivation_',
	    value: function animateDeactivation_(e, _ref) {
	      var wasActivatedByPointer = _ref.wasActivatedByPointer,
	          wasElementMadeActive = _ref.wasElementMadeActive;
	
	      if (wasActivatedByPointer || wasElementMadeActive) {
	        this.runDeactivationUXLogicIfReady_();
	      }
	    }
	  }, {
	    key: 'layout',
	    value: function layout() {
	      var _this14 = this;
	
	      if (this.layoutFrame_) {
	        cancelAnimationFrame(this.layoutFrame_);
	      }
	      this.layoutFrame_ = requestAnimationFrame(function () {
	        _this14.layoutInternal_();
	        _this14.layoutFrame_ = 0;
	      });
	    }
	
	    /** @private */
	
	  }, {
	    key: 'layoutInternal_',
	    value: function layoutInternal_() {
	      var _this15 = this;
	
	      this.frame_ = this.adapter_.computeBoundingRect();
	      var maxDim = Math.max(this.frame_.height, this.frame_.width);
	
	      // Surface diameter is treated differently for unbounded vs. bounded ripples.
	      // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
	      // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
	      // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
	      // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
	      // `overflow: hidden`.
	      var getBoundedRadius = function getBoundedRadius() {
	        var hypotenuse = Math.sqrt(Math.pow(_this15.frame_.width, 2) + Math.pow(_this15.frame_.height, 2));
	        return hypotenuse + MDCRippleFoundation.numbers.PADDING;
	      };
	
	      this.maxRadius_ = this.adapter_.isUnbounded() ? maxDim : getBoundedRadius();
	
	      // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
	      this.initialSize_ = maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE;
	      this.fgScale_ = this.maxRadius_ / this.initialSize_;
	
	      this.updateLayoutCssVars_();
	    }
	
	    /** @private */
	
	  }, {
	    key: 'updateLayoutCssVars_',
	    value: function updateLayoutCssVars_() {
	      var _MDCRippleFoundation$5 = MDCRippleFoundation.strings,
	          VAR_FG_SIZE = _MDCRippleFoundation$5.VAR_FG_SIZE,
	          VAR_LEFT = _MDCRippleFoundation$5.VAR_LEFT,
	          VAR_TOP = _MDCRippleFoundation$5.VAR_TOP,
	          VAR_FG_SCALE = _MDCRippleFoundation$5.VAR_FG_SCALE;
	
	
	      this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + 'px');
	      this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
	
	      if (this.adapter_.isUnbounded()) {
	        this.unboundedCoords_ = {
	          left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
	          top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
	        };
	
	        this.adapter_.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + 'px');
	        this.adapter_.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + 'px');
	      }
	    }
	
	    /** @param {boolean} unbounded */
	
	  }, {
	    key: 'setUnbounded',
	    value: function setUnbounded(unbounded) {
	      var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
	
	      if (unbounded) {
	        this.adapter_.addClass(UNBOUNDED);
	      } else {
	        this.adapter_.removeClass(UNBOUNDED);
	      }
	    }
	  }]);
	
	  return MDCRippleFoundation;
	}(__WEBPACK_IMPORTED_MODULE_0__material_base_foundation__["a" /* default */]);
	
	/* harmony default export */ __webpack_exports__["a"] = (MDCRippleFoundation);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cssClasses; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return strings; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numbers; });
	/**
	 * @license
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var cssClasses = {
	  // Ripple is a special case where the "root" component is really a "mixin" of sorts,
	  // given that it's an 'upgrade' to an existing component. That being said it is the root
	  // CSS class that all other CSS classes derive from.
	  ROOT: 'mdc-ripple-upgraded',
	  UNBOUNDED: 'mdc-ripple-upgraded--unbounded',
	  BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
	  FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
	  FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation'
	};
	
	var strings = {
	  VAR_LEFT: '--mdc-ripple-left',
	  VAR_TOP: '--mdc-ripple-top',
	  VAR_FG_SIZE: '--mdc-ripple-fg-size',
	  VAR_FG_SCALE: '--mdc-ripple-fg-scale',
	  VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
	  VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end'
	};
	
	var numbers = {
	  PADDING: 10,
	  INITIAL_ORIGIN_SCALE: 0.6,
	  DEACTIVATION_TIMEOUT_MS: 225, // Corresponds to $mdc-ripple-translate-duration (i.e. activation animation duration)
	  FG_DEACTIVATION_MS: 150, // Corresponds to $mdc-ripple-fade-out-duration (i.e. deactivation animation duration)
	  TAP_DELAY_MS: 300 };
	
	
	
	/***/ })
	
	/******/ });
	});
	//# sourceMappingURL=mdc.topAppBar.js.map

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(525);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var commentre = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g
	
	module.exports = function(css, options){
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   */
	
	  function updatePosition(str) {
	    var lines = str.match(/\n/g);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf('\n');
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   */
	
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node){
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node
	   */
	
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string
	   */
	
	  Position.prototype.content = css;
	
	  /**
	   * Error `msg`.
	   */
	
	  var errorsList = [];
	
	  function error(msg) {
	    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = css;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Parse stylesheet.
	   */
	
	  function stylesheet() {
	    var rulesList = rules();
	
	    return {
	      type: 'stylesheet',
	      stylesheet: {
	        source: options.source,
	        rules: rulesList,
	        parsingErrors: errorsList
	      }
	    };
	  }
	
	  /**
	   * Opening brace.
	   */
	
	  function open() {
	    return match(/^{\s*/);
	  }
	
	  /**
	   * Closing brace.
	   */
	
	  function close() {
	    return match(/^}/);
	  }
	
	  /**
	   * Parse ruleset.
	   */
	
	  function rules() {
	    var node;
	    var rules = [];
	    whitespace();
	    comments(rules);
	    while (css.length && css.charAt(0) != '}' && (node = atrule() || rule())) {
	      if (node !== false) {
	        rules.push(node);
	        comments(rules);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Match `re` and return captures.
	   */
	
	  function match(re) {
	    var m = re.exec(css);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    css = css.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	
	  function whitespace() {
	    match(/^\s*/);
	  }
	
	  /**
	   * Parse comments;
	   */
	
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while (c = comment()) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   */
	
	  function comment() {
	    var pos = position();
	    if ('/' != css.charAt(0) || '*' != css.charAt(1)) return;
	
	    var i = 2;
	    while ("" != css.charAt(i) && ('*' != css.charAt(i) || '/' != css.charAt(i + 1))) ++i;
	    i += 2;
	
	    if ("" === css.charAt(i-1)) {
	      return error('End of comment missing');
	    }
	
	    var str = css.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    css = css.slice(i);
	    column += 2;
	
	    return pos({
	      type: 'comment',
	      comment: str
	    });
	  }
	
	  /**
	   * Parse selector.
	   */
	
	  function selector() {
	    var m = match(/^([^{]+)/);
	    if (!m) return;
	    /* @fix Remove all comments from selectors
	     * http://ostermiller.org/findcomment.html */
	    return trim(m[0])
	      .replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, '')
	      .replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
	        return m.replace(/,/g, '\u200C');
	      })
	      .split(/\s*(?![^(]*\)),\s*/)
	      .map(function(s) {
	        return s.replace(/\u200C/g, ',');
	      });
	  }
	
	  /**
	   * Parse declaration.
	   */
	
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
	    if (!prop) return;
	    prop = trim(prop[0]);
	
	    // :
	    if (!match(/^:\s*/)) return error("property missing ':'");
	
	    // val
	    var val = match(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/);
	
	    var ret = pos({
	      type: 'declaration',
	      property: prop.replace(commentre, ''),
	      value: val ? trim(val[0]).replace(commentre, '') : ''
	    });
	
	    // ;
	    match(/^[;\s]*/);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   */
	
	  function declarations() {
	    var decls = [];
	
	    if (!open()) return error("missing '{'");
	    comments(decls);
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    if (!close()) return error("missing '}'");
	    return decls;
	  }
	
	  /**
	   * Parse keyframe.
	   */
	
	  function keyframe() {
	    var m;
	    var vals = [];
	    var pos = position();
	
	    while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
	      vals.push(m[1]);
	      match(/^,\s*/);
	    }
	
	    if (!vals.length) return;
	
	    return pos({
	      type: 'keyframe',
	      values: vals,
	      declarations: declarations()
	    });
	  }
	
	  /**
	   * Parse keyframes.
	   */
	
	  function atkeyframes() {
	    var pos = position();
	    var m = match(/^@([-\w]+)?keyframes\s*/);
	
	    if (!m) return;
	    var vendor = m[1];
	
	    // identifier
	    var m = match(/^([-\w]+)\s*/);
	    if (!m) return error("@keyframes missing name");
	    var name = m[1];
	
	    if (!open()) return error("@keyframes missing '{'");
	
	    var frame;
	    var frames = comments();
	    while (frame = keyframe()) {
	      frames.push(frame);
	      frames = frames.concat(comments());
	    }
	
	    if (!close()) return error("@keyframes missing '}'");
	
	    return pos({
	      type: 'keyframes',
	      name: name,
	      vendor: vendor,
	      keyframes: frames
	    });
	  }
	
	  /**
	   * Parse supports.
	   */
	
	  function atsupports() {
	    var pos = position();
	    var m = match(/^@supports *([^{]+)/);
	
	    if (!m) return;
	    var supports = trim(m[1]);
	
	    if (!open()) return error("@supports missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@supports missing '}'");
	
	    return pos({
	      type: 'supports',
	      supports: supports,
	      rules: style
	    });
	  }
	
	  /**
	   * Parse host.
	   */
	
	  function athost() {
	    var pos = position();
	    var m = match(/^@host\s*/);
	
	    if (!m) return;
	
	    if (!open()) return error("@host missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@host missing '}'");
	
	    return pos({
	      type: 'host',
	      rules: style
	    });
	  }
	
	  /**
	   * Parse media.
	   */
	
	  function atmedia() {
	    var pos = position();
	    var m = match(/^@media *([^{]+)/);
	
	    if (!m) return;
	    var media = trim(m[1]);
	
	    if (!open()) return error("@media missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@media missing '}'");
	
	    return pos({
	      type: 'media',
	      media: media,
	      rules: style
	    });
	  }
	
	
	  /**
	   * Parse custom-media.
	   */
	
	  function atcustommedia() {
	    var pos = position();
	    var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
	    if (!m) return;
	
	    return pos({
	      type: 'custom-media',
	      name: trim(m[1]),
	      media: trim(m[2])
	    });
	  }
	
	  /**
	   * Parse paged media.
	   */
	
	  function atpage() {
	    var pos = position();
	    var m = match(/^@page */);
	    if (!m) return;
	
	    var sel = selector() || [];
	
	    if (!open()) return error("@page missing '{'");
	    var decls = comments();
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      decls.push(decl);
	      decls = decls.concat(comments());
	    }
	
	    if (!close()) return error("@page missing '}'");
	
	    return pos({
	      type: 'page',
	      selectors: sel,
	      declarations: decls
	    });
	  }
	
	  /**
	   * Parse document.
	   */
	
	  function atdocument() {
	    var pos = position();
	    var m = match(/^@([-\w]+)?document *([^{]+)/);
	    if (!m) return;
	
	    var vendor = trim(m[1]);
	    var doc = trim(m[2]);
	
	    if (!open()) return error("@document missing '{'");
	
	    var style = comments().concat(rules());
	
	    if (!close()) return error("@document missing '}'");
	
	    return pos({
	      type: 'document',
	      document: doc,
	      vendor: vendor,
	      rules: style
	    });
	  }
	
	  /**
	   * Parse font-face.
	   */
	
	  function atfontface() {
	    var pos = position();
	    var m = match(/^@font-face\s*/);
	    if (!m) return;
	
	    if (!open()) return error("@font-face missing '{'");
	    var decls = comments();
	
	    // declarations
	    var decl;
	    while (decl = declaration()) {
	      decls.push(decl);
	      decls = decls.concat(comments());
	    }
	
	    if (!close()) return error("@font-face missing '}'");
	
	    return pos({
	      type: 'font-face',
	      declarations: decls
	    });
	  }
	
	  /**
	   * Parse import
	   */
	
	  var atimport = _compileAtrule('import');
	
	  /**
	   * Parse charset
	   */
	
	  var atcharset = _compileAtrule('charset');
	
	  /**
	   * Parse namespace
	   */
	
	  var atnamespace = _compileAtrule('namespace');
	
	  /**
	   * Parse non-block at-rules
	   */
	
	
	  function _compileAtrule(name) {
	    var re = new RegExp('^@' + name + '\\s*([^;]+);');
	    return function() {
	      var pos = position();
	      var m = match(re);
	      if (!m) return;
	      var ret = { type: name };
	      ret[name] = m[1].trim();
	      return pos(ret);
	    }
	  }
	
	  /**
	   * Parse at rule.
	   */
	
	  function atrule() {
	    if (css[0] != '@') return;
	
	    return atkeyframes()
	      || atmedia()
	      || atcustommedia()
	      || atsupports()
	      || atimport()
	      || atcharset()
	      || atnamespace()
	      || atdocument()
	      || atpage()
	      || athost()
	      || atfontface();
	  }
	
	  /**
	   * Parse rule.
	   */
	
	  function rule() {
	    var pos = position();
	    var sel = selector();
	
	    if (!sel) return error('selector missing');
	    comments();
	
	    return pos({
	      type: 'rule',
	      selectors: sel,
	      declarations: declarations()
	    });
	  }
	
	  return addParent(stylesheet());
	};
	
	/**
	 * Trim `str`.
	 */
	
	function trim(str) {
	  return str ? str.replace(/^\s+|\s+$/g, '') : '';
	}
	
	/**
	 * Adds non-enumerable parent node reference to each node.
	 */
	
	function addParent(obj, parent) {
	  var isNode = obj && typeof obj.type === 'string';
	  var childParent = isNode ? obj : parent;
	
	  for (var k in obj) {
	    var value = obj[k];
	    if (Array.isArray(value)) {
	      value.forEach(function(v) { addParent(v, childParent); });
	    } else if (value && typeof value === 'object') {
	      addParent(value, childParent);
	    }
	  }
	
	  if (isNode) {
	    Object.defineProperty(obj, 'parent', {
	      configurable: true,
	      writable: true,
	      enumerable: false,
	      value: parent || null
	    });
	  }
	
	  return obj;
	}


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(46);
	var isArguments = __webpack_require__(45);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(317);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(321);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(130);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowStart: true,
	  gridRowEnd: true,
	  gridColumn: true,
	  gridColumnStart: true,
	  gridColumnEnd: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	
	  /**
	   * @param {string} prefix vendor-specific prefix, eg: Webkit
	   * @param {string} key style name, eg: transitionDuration
	   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	   * WebkitTransitionDuration
	   */
	};function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	exports.default = CSSProperty;

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(518);
	
	var _CSSProperty2 = _interopRequireDefault(_CSSProperty);
	
	var _warning = __webpack_require__(201);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	exports.default = dangerousStyleValue;

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyleName = undefined;
	exports.createMarkupForStyles = createMarkupForStyles;
	
	var _camelizeStyleName = __webpack_require__(318);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _dangerousStyleValue = __webpack_require__(519);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(322);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _memoizeStringOnly = __webpack_require__(325);
	
	var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);
	
	var _warning = __webpack_require__(201);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
	                                                                                                                   * Copyright 2013-present, Facebook, Inc.
	                                                                                                                   * All rights reserved.
	                                                                                                                   *
	                                                                                                                   * This source code is licensed under the BSD-style license found in the
	                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
	                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                   *
	                                                                                                                   * @providesModule CSSPropertyOperations
	                                                                                                                   */
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    //eslint-disable-line no-var
	    var owner = void 0;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	
	function createMarkupForStyles(styles, component) {
	  var serialized = '';
	  for (var styleName in styles) {
	    var isCustomProp = styleName.indexOf('--') === 0;
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    if (styleName === 'label') {
	      continue;
	    }
	    var styleValue = styles[styleName];
	    if (false) {
	      warnValidStyle(styleName, styleValue, component);
	    }
	    if (styleValue != null) {
	      if (isCustomProp) {
	        serialized += styleName + ':' + styleValue + ';';
	      } else {
	        serialized += processStyleName(styleName) + ':';
	        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
	      }
	    }
	  }
	  return serialized || null;
	}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = clean;
	// Returns true for null, false, undefined and {}
	function isFalsy(value) {
	  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
	}
	
	function cleanObject(object) {
	  if (isFalsy(object)) return null;
	  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;
	
	  var acc = {},
	      keys = Object.keys(object),
	      hasFalsy = false;
	  for (var i = 0; i < keys.length; i++) {
	    var value = object[keys[i]];
	    var filteredValue = clean(value);
	    if (filteredValue === null || filteredValue !== value) {
	      hasFalsy = true;
	    }
	    if (filteredValue !== null) {
	      acc[keys[i]] = filteredValue;
	    }
	  }
	  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
	}
	
	function cleanArray(rules) {
	  var hasFalsy = false;
	  var filtered = [];
	  rules.forEach(function (rule) {
	    var filteredRule = clean(rule);
	    if (filteredRule === null || filteredRule !== rule) {
	      hasFalsy = true;
	    }
	    if (filteredRule !== null) {
	      filtered.push(filteredRule);
	    }
	  });
	  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
	}
	
	// Takes style array or object provided by user and clears all the falsy data 
	// If there is no styles left after filtration returns null
	function clean(input) {
	  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
	}

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
	exports.speedy = speedy;
	exports.simulations = simulations;
	exports.simulate = simulate;
	exports.cssLabels = cssLabels;
	exports.isLikeRule = isLikeRule;
	exports.idFor = idFor;
	exports.css = css;
	exports.rehydrate = rehydrate;
	exports.flush = flush;
	exports.select = select;
	exports.parent = parent;
	exports.media = media;
	exports.pseudo = pseudo;
	exports.active = active;
	exports.any = any;
	exports.checked = checked;
	exports.disabled = disabled;
	exports.empty = empty;
	exports.enabled = enabled;
	exports._default = _default;
	exports.first = first;
	exports.firstChild = firstChild;
	exports.firstOfType = firstOfType;
	exports.fullscreen = fullscreen;
	exports.focus = focus;
	exports.hover = hover;
	exports.indeterminate = indeterminate;
	exports.inRange = inRange;
	exports.invalid = invalid;
	exports.lastChild = lastChild;
	exports.lastOfType = lastOfType;
	exports.left = left;
	exports.link = link;
	exports.onlyChild = onlyChild;
	exports.onlyOfType = onlyOfType;
	exports.optional = optional;
	exports.outOfRange = outOfRange;
	exports.readOnly = readOnly;
	exports.readWrite = readWrite;
	exports.required = required;
	exports.right = right;
	exports.root = root;
	exports.scope = scope;
	exports.target = target;
	exports.valid = valid;
	exports.visited = visited;
	exports.dir = dir;
	exports.lang = lang;
	exports.not = not;
	exports.nthChild = nthChild;
	exports.nthLastChild = nthLastChild;
	exports.nthLastOfType = nthLastOfType;
	exports.nthOfType = nthOfType;
	exports.after = after;
	exports.before = before;
	exports.firstLetter = firstLetter;
	exports.firstLine = firstLine;
	exports.selection = selection;
	exports.backdrop = backdrop;
	exports.placeholder = placeholder;
	exports.cssFor = cssFor;
	exports.attribsFor = attribsFor;
	
	var _objectAssign = __webpack_require__(30);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _sheet = __webpack_require__(524);
	
	var _CSSPropertyOperations = __webpack_require__(202);
	
	var _clean = __webpack_require__(520);
	
	var _clean2 = _interopRequireDefault(_clean);
	
	var _plugins = __webpack_require__(522);
	
	var _hash = __webpack_require__(521);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	/* stylesheet */
	
	
	var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
	// an isomorphic StyleSheet shim. hides all the nitty gritty.
	
	// /**************** LIFTOFF IN 3... 2... 1... ****************/
	styleSheet.inject(); //eslint-disable-line indent
	// /****************      TO THE MOOOOOOON     ****************/
	
	// convenience function to toggle speedy
	function speedy(bool) {
	  return styleSheet.speedy(bool);
	}
	
	// plugins
	// we include these by default
	var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
	plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
	plugins.fontFace = new _plugins.PluginSet();
	plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);
	
	// define some constants
	
	var isDev = ("production") === 'development' || !("production");
	var isTest = ("production") === 'test';
	var isBrowser = typeof window !== 'undefined';
	
	/**** simulations  ****/
	
	// a flag to enable simulation meta tags on dom nodes
	// defaults to true in dev mode. recommend *not* to
	// toggle often.
	var canSimulate = isDev;
	
	// we use these flags for issuing warnings when simulate is called
	// in prod / in incorrect order
	var warned1 = false,
	    warned2 = false;
	
	// toggles simulation activity. shouldn't be needed in most cases
	function simulations() {
	  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  canSimulate = !!bool;
	}
	
	// use this on dom nodes to 'simulate' pseudoclasses
	// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
	// you can even send in some weird ones, as long as it's in simple format
	// and matches an existing rule on the element
	// eg simulate('nthChild2', ':hover:active') etc
	function simulate() {
	  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
	    pseudos[_key] = arguments[_key];
	  }
	
	  pseudos = (0, _clean2.default)(pseudos);
	  if (!pseudos) return {};
	  if (!canSimulate) {
	    if (!warned1) {
	      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
	      warned1 = true;
	    }
	    if (!isDev && !isTest && !warned2) {
	      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
	      warned2 = true;
	    }
	    return {};
	  }
	  return pseudos.reduce(function (o, p) {
	    return o['data-simulate-' + simple(p)] = '', o;
	  }, {});
	}
	
	/**** labels ****/
	// toggle for debug labels.
	// *shouldn't* have to mess with this manually
	var hasLabels = isDev;
	
	function cssLabels(bool) {
	  hasLabels = !!bool;
	}
	
	// takes a string, converts to lowercase, strips out nonalphanumeric.
	function simple(str) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
	}
	
	// hashes a string to something 'unique'
	// we use this to generate ids for styles
	
	
	function hashify(obj) {
	  var str = JSON.stringify(obj);
	  var toRet = (0, _hash2.default)(str).toString(36);
	  if (obj.label && obj.label.length > 0 && isDev) {
	    return simple(obj.label.join('.'), '-') + '-' + toRet;
	  }
	  return toRet;
	}
	
	// of shape { 'data-css-<id>': '' }
	function isLikeRule(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) {
	    return false;
	  }
	  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
	}
	
	// extracts id from a { 'data-css-<id>': ''} like object
	function idFor(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) throw new Error('not a rule');
	  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
	  var match = regex.exec(keys[0]);
	  if (!match) throw new Error('not a rule');
	  return match[1];
	}
	
	// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	// "Tokenizes" the selectors into parts relevant for the next function.
	// Strings and comments are matched, but ignored afterwards.
	// This is not a full tokenizers. It only recognizes comas, parentheses,
	// strings and comments.
	// regexp generated by scripts/regexps.js then trimmed by hand
	var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;
	
	/**
	 * This will split a coma-separated selector list into individual selectors,
	 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
	 *
	 * @param {string} selector
	 * @return {string[]}
	 */
	
	function splitSelector(selector) {
	  if (selector.indexOf(',') === -1) {
	    return [selector];
	  }
	
	  var indices = [],
	      res = [],
	      inParen = 0,
	      o;
	  /*eslint-disable no-cond-assign*/
	  while (o = selectorTokenizer.exec(selector)) {
	    /*eslint-enable no-cond-assign*/
	    switch (o[0]) {
	      case '(':
	        inParen++;break;
	      case ')':
	        inParen--;break;
	      case ',':
	        if (inParen) break;indices.push(o.index);
	    }
	  }
	  for (o = indices.length; o--;) {
	    res.unshift(selector.slice(indices[o] + 1));
	    selector = selector.slice(0, indices[o]);
	  }
	  res.unshift(selector);
	  return res;
	}
	
	function selector(id, path) {
	  if (!id) {
	    return path.replace(/\&/g, '');
	  }
	  if (!path) return '.css-' + id + ',[data-css-' + id + ']';
	
	  var x = splitSelector(path).map(function (x) {
	    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
	    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
	  }).join(',');
	
	  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
	    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
	  }
	  return x;
	}
	
	// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	
	function toCSS(_ref) {
	  var selector = _ref.selector,
	      style = _ref.style;
	
	  var result = plugins.transform({ selector: selector, style: style });
	  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	}
	
	function deconstruct(style) {
	  // we can be sure it's not infinitely nested here
	  var plain = void 0,
	      selects = void 0,
	      medias = void 0,
	      supports = void 0;
	  Object.keys(style).forEach(function (key) {
	    if (key.indexOf('&') >= 0) {
	      selects = selects || {};
	      selects[key] = style[key];
	    } else if (key.indexOf('@media') === 0) {
	      medias = medias || {};
	      medias[key] = deconstruct(style[key]);
	    } else if (key.indexOf('@supports') === 0) {
	      supports = supports || {};
	      supports[key] = deconstruct(style[key]);
	    } else if (key === 'label') {
	      if (style.label.length > 0) {
	        plain = plain || {};
	        plain.label = hasLabels ? style.label.join('.') : '';
	      }
	    } else {
	      plain = plain || {};
	      plain[key] = style[key];
	    }
	  });
	  return { plain: plain, selects: selects, medias: medias, supports: supports };
	}
	
	function deconstructedStyleToCSS(id, style) {
	  var css = [];
	
	  // plugins here
	  var plain = style.plain,
	      selects = style.selects,
	      medias = style.medias,
	      supports = style.supports;
	
	  if (plain) {
	    css.push(toCSS({ style: plain, selector: selector(id) }));
	  }
	  if (selects) {
	    Object.keys(selects).forEach(function (key) {
	      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
	    });
	  }
	  if (medias) {
	    Object.keys(medias).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
	    });
	  }
	  if (supports) {
	    Object.keys(supports).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
	    });
	  }
	  return css;
	}
	
	// this cache to track which rules have
	// been inserted into the stylesheet
	var inserted = styleSheet.inserted = {};
	
	// and helpers to insert rules into said styleSheet
	function insert(spec) {
	  if (!inserted[spec.id]) {
	    inserted[spec.id] = true;
	    var deconstructed = deconstruct(spec.style);
	    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
	    inserted[spec.id] = isBrowser ? true : rules;
	    rules.forEach(function (cssRule) {
	      return styleSheet.insert(cssRule);
	    });
	  }
	}
	
	// a simple cache to store generated rules
	var registered = styleSheet.registered = {};
	function register(spec) {
	  if (!registered[spec.id]) {
	    registered[spec.id] = spec;
	  }
	}
	
	function _getRegistered(rule) {
	  if (isLikeRule(rule)) {
	    var ret = registered[idFor(rule)];
	    if (ret == null) {
	      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
	    }
	    return ret;
	  }
	  return rule;
	}
	
	// todo - perf
	var ruleCache = {};
	function toRule(spec) {
	  register(spec);
	  insert(spec);
	
	  if (ruleCache[spec.id]) {
	    return ruleCache[spec.id];
	  }
	
	  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
	  Object.defineProperty(ret, 'toString', {
	    enumerable: false, value: function value() {
	      return 'css-' + spec.id;
	    }
	  });
	  ruleCache[spec.id] = ret;
	  return ret;
	}
	
	function log() {
	  //eslint-disable-line no-unused-vars
	  console.log(this); //eslint-disable-line no-console
	  return this;
	}
	
	function isSelector(key) {
	  var possibles = [':', '.', '[', '>', ' '],
	      found = false,
	      ch = key.charAt(0);
	  for (var i = 0; i < possibles.length; i++) {
	    if (ch === possibles[i]) {
	      found = true;
	      break;
	    }
	  }
	  return found || key.indexOf('&') >= 0;
	}
	
	function joinSelectors(a, b) {
	  var as = splitSelector(a).map(function (a) {
	    return !(a.indexOf('&') >= 0) ? '&' + a : a;
	  });
	  var bs = splitSelector(b).map(function (b) {
	    return !(b.indexOf('&') >= 0) ? '&' + b : b;
	  });
	
	  return bs.reduce(function (arr, b) {
	    return arr.concat(as.map(function (a) {
	      return b.replace(/\&/g, a);
	    }));
	  }, []).join(',');
	}
	
	function joinMediaQueries(a, b) {
	  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
	}
	
	function isMediaQuery(key) {
	  return key.indexOf('@media') === 0;
	}
	
	function isSupports(key) {
	  return key.indexOf('@supports') === 0;
	}
	
	function joinSupports(a, b) {
	  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
	}
	
	// flatten a nested array
	function flatten(inArr) {
	  var arr = [];
	  for (var i = 0; i < inArr.length; i++) {
	    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
	  }
	  return arr;
	}
	
	var prefixedPseudoSelectors = {
	  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
	  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']
	
	  // mutable! modifies dest.
	};function build(dest, _ref2) {
	  var _ref2$selector = _ref2.selector,
	      selector = _ref2$selector === undefined ? '' : _ref2$selector,
	      _ref2$mq = _ref2.mq,
	      mq = _ref2$mq === undefined ? '' : _ref2$mq,
	      _ref2$supp = _ref2.supp,
	      supp = _ref2$supp === undefined ? '' : _ref2$supp,
	      _ref2$src = _ref2.src,
	      src = _ref2$src === undefined ? {} : _ref2$src;
	
	
	  if (!Array.isArray(src)) {
	    src = [src];
	  }
	  src = flatten(src);
	
	  src.forEach(function (_src) {
	    if (isLikeRule(_src)) {
	      var reg = _getRegistered(_src);
	      if (reg.type !== 'css') {
	        throw new Error('cannot merge this rule');
	      }
	      _src = reg.style;
	    }
	    _src = (0, _clean2.default)(_src);
	    if (_src && _src.composes) {
	      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
	    }
	    Object.keys(_src || {}).forEach(function (key) {
	      if (isSelector(key)) {
	
	        if (prefixedPseudoSelectors[key]) {
	          prefixedPseudoSelectors[key].forEach(function (p) {
	            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
	          });
	        }
	
	        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
	      } else if (isMediaQuery(key)) {
	        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
	      } else if (isSupports(key)) {
	        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
	      } else if (key === 'composes') {
	        // ignore, we already dealth with it
	      } else {
	        var _dest = dest;
	        if (supp) {
	          _dest[supp] = _dest[supp] || {};
	          _dest = _dest[supp];
	        }
	        if (mq) {
	          _dest[mq] = _dest[mq] || {};
	          _dest = _dest[mq];
	        }
	        if (selector) {
	          _dest[selector] = _dest[selector] || {};
	          _dest = _dest[selector];
	        }
	
	        if (key === 'label') {
	          if (hasLabels) {
	            dest.label = dest.label.concat(_src.label);
	          }
	        } else {
	          _dest[key] = _src[key];
	        }
	      }
	    });
	  });
	}
	
	function _css(rules) {
	  var style = { label: [] };
	  build(style, { src: rules }); // mutative! but worth it.
	
	  var spec = {
	    id: hashify(style),
	    style: style, label: hasLabels ? style.label.join('.') : '',
	    type: 'css'
	  };
	  return toRule(spec);
	}
	
	var nullrule = {
	  // 'data-css-nil': ''
	};
	Object.defineProperty(nullrule, 'toString', {
	  enumerable: false, value: function value() {
	    return 'css-nil';
	  }
	});
	
	var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];
	
	var warnedWeakMapError = false;
	function multiIndexCache(fn) {
	  return function (args) {
	    if (inputCaches[args.length]) {
	      var coi = inputCaches[args.length];
	      var ctr = 0;
	      while (ctr < args.length - 1) {
	        if (!coi.has(args[ctr])) {
	          coi.set(args[ctr], new WeakMap());
	        }
	        coi = coi.get(args[ctr]);
	        ctr++;
	      }
	      if (coi.has(args[args.length - 1])) {
	        var ret = coi.get(args[ctr]);
	
	        if (registered[ret.toString().substring(4)]) {
	          // make sure it hasn't been flushed
	          return ret;
	        }
	      }
	    }
	    var value = fn(args);
	    if (inputCaches[args.length]) {
	      var _ctr = 0,
	          _coi = inputCaches[args.length];
	      while (_ctr < args.length - 1) {
	        _coi = _coi.get(args[_ctr]);
	        _ctr++;
	      }
	      try {
	        _coi.set(args[_ctr], value);
	      } catch (err) {
	        if (isDev && !warnedWeakMapError) {
	          var _console;
	
	          warnedWeakMapError = true;
	          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
	          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
	        }
	      }
	    }
	    return value;
	  };
	}
	
	var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;
	
	function css() {
	  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    rules[_key2] = arguments[_key2];
	  }
	
	  if (rules[0] && rules[0].length && rules[0].raw) {
	    throw new Error('you forgot to include glamor/babel in your babel plugins.');
	  }
	
	  rules = (0, _clean2.default)(rules);
	  if (!rules) {
	    return nullrule;
	  }
	
	  return cachedCss(rules);
	}
	
	css.insert = function (css) {
	  var spec = {
	    id: hashify(css),
	    css: css,
	    type: 'raw'
	  };
	  register(spec);
	  if (!inserted[spec.id]) {
	    styleSheet.insert(spec.css);
	    inserted[spec.id] = isBrowser ? true : [spec.css];
	  }
	};
	
	var insertRule = exports.insertRule = css.insert;
	
	css.global = function (selector, style) {
	  style = (0, _clean2.default)(style);
	  if (style) {
	    return css.insert(toCSS({ selector: selector, style: style }));
	  }
	};
	
	var insertGlobal = exports.insertGlobal = css.global;
	
	function insertKeyframe(spec) {
	  if (!inserted[spec.id]) {
	    var inner = Object.keys(spec.keyframes).map(function (kf) {
	      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
	      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	    }).join('');
	
	    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
	      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
	    });
	    rules.forEach(function (rule) {
	      return styleSheet.insert(rule);
	    });
	
	    inserted[spec.id] = isBrowser ? true : rules;
	  }
	}
	css.keyframes = function (name, kfs) {
	  if (!kfs) {
	    kfs = name, name = 'animation';
	  }
	
	  // do not ignore empty keyframe definitions for now.
	  kfs = (0, _clean2.default)(kfs) || {};
	  var spec = {
	    id: hashify({ name: name, kfs: kfs }),
	    type: 'keyframes',
	    name: name,
	    keyframes: kfs
	  };
	  register(spec);
	  insertKeyframe(spec);
	  return name + '_' + spec.id;
	};
	
	// we don't go all out for fonts as much, giving a simple font loading strategy
	// use a fancier lib if you need moar power
	css.fontFace = function (font) {
	  font = (0, _clean2.default)(font);
	  var spec = {
	    id: hashify(font),
	    type: 'font-face',
	    font: font
	  };
	  register(spec);
	  insertFontFace(spec);
	
	  return font.fontFamily;
	};
	
	var fontFace = exports.fontFace = css.fontFace;
	var keyframes = exports.keyframes = css.keyframes;
	
	function insertFontFace(spec) {
	  if (!inserted[spec.id]) {
	    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
	    styleSheet.insert(rule);
	    inserted[spec.id] = isBrowser ? true : [rule];
	  }
	}
	
	// rehydrate the insertion cache with ids sent from
	// renderStatic / renderStaticOptimized
	function rehydrate(ids) {
	  // load up ids
	  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
	    return o[i] = true, o;
	  }, {}));
	  // assume css loaded separately
	}
	
	// clears out the cache and empties the stylesheet
	// best for tests, though there might be some value for SSR.
	
	function flush() {
	  inserted = styleSheet.inserted = {};
	  registered = styleSheet.registered = {};
	  ruleCache = {};
	  styleSheet.flush();
	  styleSheet.inject();
	}
	
	var presets = exports.presets = {
	  mobile: '(min-width: 400px)',
	  Mobile: '@media (min-width: 400px)',
	  phablet: '(min-width: 550px)',
	  Phablet: '@media (min-width: 550px)',
	  tablet: '(min-width: 750px)',
	  Tablet: '@media (min-width: 750px)',
	  desktop: '(min-width: 1000px)',
	  Desktop: '@media (min-width: 1000px)',
	  hd: '(min-width: 1200px)',
	  Hd: '@media (min-width: 1200px)'
	};
	
	var style = exports.style = css;
	
	function select(selector) {
	  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    styles[_key3 - 1] = arguments[_key3];
	  }
	
	  if (!selector) {
	    return style(styles);
	  }
	  return css(_defineProperty({}, selector, styles));
	}
	var $ = exports.$ = select;
	
	function parent(selector) {
	  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    styles[_key4 - 1] = arguments[_key4];
	  }
	
	  return css(_defineProperty({}, selector + ' &', styles));
	}
	
	var merge = exports.merge = css;
	var compose = exports.compose = css;
	
	function media(query) {
	  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    rules[_key5 - 1] = arguments[_key5];
	  }
	
	  return css(_defineProperty({}, '@media ' + query, rules));
	}
	
	function pseudo(selector) {
	  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    styles[_key6 - 1] = arguments[_key6];
	  }
	
	  return css(_defineProperty({}, selector, styles));
	}
	
	// allllll the pseudoclasses
	
	function active(x) {
	  return pseudo(':active', x);
	}
	
	function any(x) {
	  return pseudo(':any', x);
	}
	
	function checked(x) {
	  return pseudo(':checked', x);
	}
	
	function disabled(x) {
	  return pseudo(':disabled', x);
	}
	
	function empty(x) {
	  return pseudo(':empty', x);
	}
	
	function enabled(x) {
	  return pseudo(':enabled', x);
	}
	
	function _default(x) {
	  return pseudo(':default', x); // note '_default' name
	}
	
	function first(x) {
	  return pseudo(':first', x);
	}
	
	function firstChild(x) {
	  return pseudo(':first-child', x);
	}
	
	function firstOfType(x) {
	  return pseudo(':first-of-type', x);
	}
	
	function fullscreen(x) {
	  return pseudo(':fullscreen', x);
	}
	
	function focus(x) {
	  return pseudo(':focus', x);
	}
	
	function hover(x) {
	  return pseudo(':hover', x);
	}
	
	function indeterminate(x) {
	  return pseudo(':indeterminate', x);
	}
	
	function inRange(x) {
	  return pseudo(':in-range', x);
	}
	
	function invalid(x) {
	  return pseudo(':invalid', x);
	}
	
	function lastChild(x) {
	  return pseudo(':last-child', x);
	}
	
	function lastOfType(x) {
	  return pseudo(':last-of-type', x);
	}
	
	function left(x) {
	  return pseudo(':left', x);
	}
	
	function link(x) {
	  return pseudo(':link', x);
	}
	
	function onlyChild(x) {
	  return pseudo(':only-child', x);
	}
	
	function onlyOfType(x) {
	  return pseudo(':only-of-type', x);
	}
	
	function optional(x) {
	  return pseudo(':optional', x);
	}
	
	function outOfRange(x) {
	  return pseudo(':out-of-range', x);
	}
	
	function readOnly(x) {
	  return pseudo(':read-only', x);
	}
	
	function readWrite(x) {
	  return pseudo(':read-write', x);
	}
	
	function required(x) {
	  return pseudo(':required', x);
	}
	
	function right(x) {
	  return pseudo(':right', x);
	}
	
	function root(x) {
	  return pseudo(':root', x);
	}
	
	function scope(x) {
	  return pseudo(':scope', x);
	}
	
	function target(x) {
	  return pseudo(':target', x);
	}
	
	function valid(x) {
	  return pseudo(':valid', x);
	}
	
	function visited(x) {
	  return pseudo(':visited', x);
	}
	
	// parameterized pseudoclasses
	function dir(p, x) {
	  return pseudo(':dir(' + p + ')', x);
	}
	function lang(p, x) {
	  return pseudo(':lang(' + p + ')', x);
	}
	function not(p, x) {
	  // should this be a plugin?
	  var selector = p.split(',').map(function (x) {
	    return x.trim();
	  }).map(function (x) {
	    return ':not(' + x + ')';
	  });
	  if (selector.length === 1) {
	    return pseudo(':not(' + p + ')', x);
	  }
	  return select(selector.join(''), x);
	}
	function nthChild(p, x) {
	  return pseudo(':nth-child(' + p + ')', x);
	}
	function nthLastChild(p, x) {
	  return pseudo(':nth-last-child(' + p + ')', x);
	}
	function nthLastOfType(p, x) {
	  return pseudo(':nth-last-of-type(' + p + ')', x);
	}
	function nthOfType(p, x) {
	  return pseudo(':nth-of-type(' + p + ')', x);
	}
	
	// pseudoelements
	function after(x) {
	  return pseudo('::after', x);
	}
	function before(x) {
	  return pseudo('::before', x);
	}
	function firstLetter(x) {
	  return pseudo('::first-letter', x);
	}
	function firstLine(x) {
	  return pseudo('::first-line', x);
	}
	function selection(x) {
	  return pseudo('::selection', x);
	}
	function backdrop(x) {
	  return pseudo('::backdrop', x);
	}
	function placeholder(x) {
	  // https://github.com/threepointone/glamor/issues/14
	  return css({ '::placeholder': x });
	}
	
	/*** helpers for web components ***/
	// https://github.com/threepointone/glamor/issues/16
	
	function cssFor() {
	  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    rules[_key7] = arguments[_key7];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  return rules ? rules.map(function (r) {
	    var style = { label: [] };
	    build(style, { src: r }); // mutative! but worth it.
	    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
	  }).join('') : '';
	}
	
	function attribsFor() {
	  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	    rules[_key8] = arguments[_key8];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  var htmlAttributes = rules ? rules.map(function (rule) {
	    idFor(rule); // throwaway check for rule
	    var key = Object.keys(rule)[0],
	        value = rule[key];
	    return key + '="' + (value || '') + '"';
	  }).join(' ') : '';
	
	  return htmlAttributes;
	}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.PluginSet = PluginSet;
	exports.fallbacks = fallbacks;
	exports.contentWrap = contentWrap;
	exports.prefixes = prefixes;
	
	var _objectAssign = __webpack_require__(30);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _CSSPropertyOperations = __webpack_require__(202);
	
	var _prefixer = __webpack_require__(523);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	
	function PluginSet(initial) {
	  this.fns = initial || [];
	}
	
	(0, _objectAssign2.default)(PluginSet.prototype, {
	  add: function add() {
	    var _this = this;
	
	    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	      fns[_key] = arguments[_key];
	    }
	
	    fns.forEach(function (fn) {
	      if (_this.fns.indexOf(fn) >= 0) {
	        if (isDev) {
	          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
	        }
	      } else {
	        _this.fns = [fn].concat(_this.fns);
	      }
	    });
	  },
	  remove: function remove(fn) {
	    this.fns = this.fns.filter(function (x) {
	      return x !== fn;
	    });
	  },
	  clear: function clear() {
	    this.fns = [];
	  },
	  transform: function transform(o) {
	    return this.fns.reduce(function (o, fn) {
	      return fn(o);
	    }, o);
	  }
	});
	
	function fallbacks(node) {
	  var hasArray = Object.keys(node.style).map(function (x) {
	    return Array.isArray(node.style[x]);
	  }).indexOf(true) >= 0;
	  if (hasArray) {
	    var style = node.style;
	
	    var flattened = Object.keys(style).reduce(function (o, key) {
	      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
	      return o;
	    }, {});
	    // todo - 
	    // flatten arrays which haven't been flattened yet 
	    return (0, _objectAssign2.default)({}, node, { style: flattened });
	  }
	  return node;
	}
	
	var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];
	
	function contentWrap(node) {
	  if (node.style.content) {
	    var cont = node.style.content;
	    if (contentValues.indexOf(cont) >= 0) {
	      return node;
	    }
	    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
	      return node;
	    }
	    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
	      return node;
	    }
	    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
	  }
	  return node;
	}
	
	function prefixes(node) {
	  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
	}

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixer;
	
	var _staticData = __webpack_require__(536);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prefixProperty = __webpack_require__(537);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(538);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _cursor = __webpack_require__(527);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(526);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(528);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(529);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(530);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(531);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(532);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(533);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(534);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(535);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer
	
	var prefixMap = _staticData2.default.prefixMap;
	
	function prefixer(style) {
	  for (var property in style) {
	    var value = style[property];
	
	    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	    // only modify the value if it was touched
	    // by any plugin to prevent unnecessary mutations
	    if (processedValue) {
	      style[property] = processedValue;
	    }
	
	    (0, _prefixProperty2.default)(prefixMap, property, style);
	  }
	  return style;
	}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleSheet = StyleSheet;
	
	var _objectAssign = __webpack_require__(30);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* 
	
	high performance StyleSheet for css-in-js systems 
	
	- uses multiple style tags behind the scenes for millions of rules 
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side 
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject() 
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }') 
	- appends a css rule into the stylesheet 
	
	styleSheet.flush() 
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  // this weirdness brought to you by firefox 
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof window !== 'undefined';
	var isDev = ("production") === 'development' || !("production"); //(x => (x === 'development') || !x)(process.env.NODE_ENV)
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-glamor', '');
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	function StyleSheet() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$speedy = _ref.speedy,
	      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	      _ref$maxLength = _ref.maxLength,
	      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	  this.sheet = undefined;
	  this.tags = [];
	  this.maxLength = maxLength;
	  this.ctr = 0;
	}
	
	(0, _objectAssign2.default)(StyleSheet.prototype, {
	  getSheet: function getSheet() {
	    return sheetForTag(last(this.tags));
	  },
	  inject: function inject() {
	    var _this = this;
	
	    if (this.injected) {
	      throw new Error('already injected stylesheet!');
	    }
	    if (isBrowser) {
	      this.tags[0] = makeStyleTag();
	    } else {
	      // server side 'polyfill'. just enough behavior to be useful.
	      this.sheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule) {
	          // enough 'spec compliance' to be able to extract the rules later  
	          // in other words, just the cssText field 
	          _this.sheet.cssRules.push({ cssText: rule });
	        }
	      };
	    }
	    this.injected = true;
	  },
	  speedy: function speedy(bool) {
	    if (this.ctr !== 0) {
	      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	    }
	    this.isSpeedy = !!bool;
	  },
	  _insert: function _insert(rule) {
	    // this weirdness for perf, and chrome's weird bug 
	    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	    try {
	      var sheet = this.getSheet();
	      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
	    } catch (e) {
	      if (isDev) {
	        // might need beter dx for this 
	        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	      }
	    }
	  },
	  insert: function insert(rule) {
	
	    if (isBrowser) {
	      // this is the ultrafast version, works across browsers 
	      if (this.isSpeedy && this.getSheet().insertRule) {
	        this._insert(rule);
	      }
	      // more browser weirdness. I don't even know    
	      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
	      //   this.tags::last().styleSheet.cssText+= rule
	      // }
	      else {
	          if (rule.indexOf('@import') !== -1) {
	            var tag = last(this.tags);
	            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
	          } else {
	            last(this.tags).appendChild(document.createTextNode(rule));
	          }
	        }
	    } else {
	      // server side is pretty simple         
	      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
	    }
	
	    this.ctr++;
	    if (isBrowser && this.ctr % this.maxLength === 0) {
	      this.tags.push(makeStyleTag());
	    }
	    return this.ctr - 1;
	  },
	
	  // commenting this out till we decide on v3's decision 
	  // _replace(index, rule) {
	  //   // this weirdness for perf, and chrome's weird bug 
	  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	  //   try {  
	  //     let sheet = this.getSheet()        
	  //     sheet.deleteRule(index) // todo - correct index here     
	  //     sheet.insertRule(rule, index)
	  //   }
	  //   catch(e) {
	  //     if(isDev) {
	  //       // might need beter dx for this 
	  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
	  //     }          
	  //   }          
	
	  // }
	  // replace(index, rule) {
	  //   if(isBrowser) {
	  //     if(this.isSpeedy && this.getSheet().insertRule) {
	  //       this._replace(index, rule)
	  //     }
	  //     else {
	  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
	  //       let _index = (index % this.maxLength) + 1
	  //       let tag = this.tags[_slot]
	  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
	  //     }
	  //   }
	  //   else {
	  //     let rules = this.sheet.cssRules
	  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
	  //   }
	  // }
	  delete: function _delete(index) {
	    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
	    return this.replace(index, '');
	  },
	  flush: function flush() {
	    if (isBrowser) {
	      this.tags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	      });
	      this.tags = [];
	      this.sheet = null;
	      this.ctr = 0;
	      // todo - look for remnants in document.styleSheets
	    } else {
	      // simpler on server 
	      this.sheet.cssRules = [];
	    }
	    this.injected = false;
	  },
	  rules: function rules() {
	    if (!isBrowser) {
	      return this.sheet.cssRules;
	    }
	    var arr = [];
	    this.tags.forEach(function (tag) {
	      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	    });
	    return arr;
	  }
	});

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(15);
	var detectIE = utilities.isIE;
	
	/**
	 * Constants.
	 */
	var HTML_TAG_NAME = 'html';
	var BODY_TAG_NAME = 'body';
	var HEAD_TAG_NAME = 'head';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_REGEX = /<\/head>/i;
	var BODY_REGEX = /<\/body>/i;
	// http://www.w3.org/TR/html/syntax.html#void-elements
	var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;
	
	// browser support
	var isIE = detectIE();
	var isIE9 = detectIE(9);
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	var parseFromString;
	if (typeof window.DOMParser === 'function') {
	    var domParser = new window.DOMParser();
	    // IE9 does not support 'text/html' MIME type
	    // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
	    var MIME_TYPE = isIE9 ? 'text/xml' : 'text/html';
	
	    /**
	     * Creates an HTML document using `DOMParser.parseFromString`.
	     *
	     * @param  {String} html      - The HTML string.
	     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
	     * @return {HTMLDocument}
	     */
	    parseFromString = function domStringParser(html, tagName) {
	        if (tagName) {
	            html = ['<', tagName, '>', html, '</', tagName, '>'].join('');
	        }
	        // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
	        if (isIE9) {
	            html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
	        }
	        return domParser.parseFromString(html, MIME_TYPE);
	    };
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	var parseFromDocument;
	if (typeof document.implementation === 'object') {
	    // title parameter is required in IE
	    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	    var doc = document.implementation.createHTMLDocument(isIE ? 'HTML_DOM_PARSER_TITLE' : undefined);
	
	    /**
	     * Use HTML document created by `document.implementation.createHTMLDocument`.
	     *
	     * @param  {String} html      - The HTML string.
	     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
	     * @return {HTMLDocument}
	     */
	    parseFromDocument = function createHTMLDocument(html, tagName) {
	        if (tagName) {
	            doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	            return doc;
	        }
	
	        try {
	            doc.documentElement.innerHTML = html;
	            return doc;
	        // fallback when certain elements in `documentElement` are read-only (IE9)
	        } catch (err) {
	            if (parseFromString) return parseFromString(html);
	        }
	    };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var parseFromTemplate;
	var template = document.createElement('template');
	if (template.content) {
	
	    /**
	     * Uses a template element (content fragment) to parse HTML.
	     *
	     * @param  {String} html - The HTML string.
	     * @return {NodeList}
	     */
	    parseFromTemplate = function templateParser(html) {
	        template.innerHTML = html;
	        return template.content.childNodes;
	    };
	}
	
	/** Fallback document parser. */
	var parseWithFallback = parseFromDocument || parseFromString;
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {String} html      - The HTML string.
	 * @param  {String} [tagName] - The tag name.
	 * @return {NodeList|Array}
	 */
	module.exports = function domparser(html) {
	    // try to match first tag
	    var tagName;
	    var match = html.match(FIRST_TAG_REGEX);
	    if (match && match[1]) {
	        tagName = match[1].toLowerCase();
	    }
	
	    var doc;
	    var element;
	    var elements;
	
	    switch (tagName) {
	        case HTML_TAG_NAME:
	            if (parseFromString) {
	                doc = parseFromString(html);
	
	                // the created document may come with filler head/body elements,
	                // so ake sure to remove them if they don't actually exist
	                if (!HEAD_REGEX.test(html)) {
	                    element = doc.getElementsByTagName(HEAD_TAG_NAME)[0];
	                    if (element) element.parentNode.removeChild(element);
	                }
	                if (!BODY_REGEX.test(html)) {
	                    element = doc.getElementsByTagName(BODY_TAG_NAME)[0];
	                    if (element) element.parentNode.removeChild(element);
	                }
	
	                return doc.getElementsByTagName(HTML_TAG_NAME);
	            }
	            break;
	
	        case HEAD_TAG_NAME:
	            if (parseWithFallback) {
	                elements = parseWithFallback(html).getElementsByTagName(HEAD_TAG_NAME);
	
	                // account for possibility of sibling
	                if (BODY_REGEX.test(html)) {
	                    return elements[0].parentNode.childNodes;
	                }
	                return elements;
	            }
	            break;
	
	        case BODY_TAG_NAME:
	            if (parseWithFallback) {
	                elements = parseWithFallback(html).getElementsByTagName(BODY_TAG_NAME);
	
	                // account for possibility of sibling (return both body and head)
	                if (HEAD_REGEX.test(html)) {
	                    return elements[0].parentNode.childNodes;
	                }
	                return elements;
	            }
	            break;
	
	        // low-level tag or text
	        default:
	            if (parseFromTemplate) return parseFromTemplate(html);
	            if (parseWithFallback) {
	                return parseWithFallback(html, BODY_TAG_NAME).getElementsByTagName(BODY_TAG_NAME)[0].childNodes;
	            }
	            break;
	    }
	
	    return [];
	};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var domparser = __webpack_require__(49);
	var utilities = __webpack_require__(15);
	var formatDOM = utilities.formatDOM;
	var isIE9 = utilities.isIE(9);
	
	/**
	 * Constants.
	 */
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML and reformats DOM nodes output.
	 *
	 * @param  {String} html - The HTML string.
	 * @return {Array}       - The formatted DOM nodes.
	 */
	module.exports = function parseDOM(html) {
	    if (typeof html !== 'string') {
	        throw new TypeError('First argument must be a string.');
	    }
	    if (!html) return [];
	
	    // match directive
	    var match = html.match(DIRECTIVE_REGEX);
	    var directive;
	    if (match && match[1]) {
	        directive = match[1];
	
	        // remove directive in IE9 because DOMParser uses
	        // MIME type 'text/xml' instead of 'text/html'
	        if (isIE9) {
	            html = html.replace(match[0], '');
	        }
	    }
	
	    return formatDOM(domparser(html), null, directive);
	};


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Format DOM attributes to an associative array.
	 *
	 * @param  {NamedNodeMap} - The list of attributes.
	 * @return {Object}       - The object of attributes.
	 */
	function formatAttributes(attributes) {
	    var result = {};
	    var attribute;
	
	    // NamedNodeMap is array-like
	    for (var i = 0, len = attributes.length; i < len; i++) {
	        attribute = attributes[i];
	        result[attribute.name] = attribute.value;
	    }
	
	    return result;
	}
	
	/**
	 * Format the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
	 *
	 * @param  {NodeList} nodes        - The DOM nodes.
	 * @param  {Object}   [parentObj]  - The formatted parent node.
	 * @param  {String}   [directive]  - The directive.
	 * @return {Object}                - The formatted DOM object.
	 */
	function formatDOM(nodes, parentObj, directive) {
	    parentObj = parentObj || null;
	
	    var result = [];
	    var node;
	    var prevNode;
	    var nodeObj;
	
	    // NodeList is array-like
	    for (var i = 0, len = nodes.length; i < len; i++) {
	        node = nodes[i];
	        // reset
	        nodeObj = {
	            next: null,
	            prev: result[i - 1] || null,
	            parent: parentObj
	        };
	
	        // set the next node for the previous node (if applicable)
	        prevNode = result[i - 1];
	        if (prevNode) {
	            prevNode.next = nodeObj;
	        }
	
	        // set the node name if it's not "#text" or "#comment"
	        // e.g., "div"
	        if (node.nodeName.indexOf('#') !== 0) {
	            nodeObj.name = node.nodeName.toLowerCase();
	
	            // also, nodes of type "tag" have "attribs"
	            nodeObj.attribs = {}; // default
	            if (node.attributes && node.attributes.length) {
	                nodeObj.attribs = formatAttributes(node.attributes);
	            }
	        }
	
	        // set the node type
	        // e.g., "tag"
	        switch (node.nodeType) {
	            // 1 = element
	            case 1:
	                if (nodeObj.name === 'script' || nodeObj.name === 'style') {
	                    nodeObj.type = nodeObj.name;
	                } else {
	                    nodeObj.type = 'tag';
	                }
	                // recursively format the children
	                nodeObj.children = formatDOM(node.childNodes, nodeObj);
	                break;
	                // 2 = attribute
	                // 3 = text
	            case 3:
	                nodeObj.type = 'text';
	                nodeObj.data = node.nodeValue;
	                break;
	                // 8 = comment
	            case 8:
	                nodeObj.type = 'comment';
	                nodeObj.data = node.nodeValue;
	                break;
	            default:
	                break;
	        }
	
	        result.push(nodeObj);
	    }
	
	    if (directive) {
	        result.unshift({
	            name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	            data: directive,
	            type: 'directive',
	            next: result[0] ? result[0] : null,
	            prev: null,
	            parent: parentObj
	        });
	
	        if (result[1]) {
	            result[1].prev = result[0];
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Detect IE with or without version.
	 *
	 * @param  {Number} [version] - The IE version to detect.
	 * @return {Boolean}          - Whether IE or the version has been detected.
	 */
	function isIE(version) {
	    if (version) {
	        return document.documentMode === version;
	    }
	    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	/**
	 * Export utilities.
	 */
	module.exports = {
	    formatAttributes: formatAttributes,
	    formatDOM: formatDOM,
	    isIE: isIE
	};


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var domToReact = __webpack_require__(52);
	var htmlToDOM = __webpack_require__(50);
	
	// decode HTML entities by default for `htmlparser2`
	var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };
	
	/**
	 * Convert HTML string to React elements.
	 *
	 * @param  {String}   html              - The HTML string.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function HTMLReactParser(html, options) {
	    if (typeof html !== 'string') {
	        throw new TypeError('First argument must be a string');
	    }
	    return domToReact(htmlToDOM(html, domParserOptions), options);
	}
	
	/**
	 * Export HTML to React parser.
	 */
	module.exports = HTMLReactParser;


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(16);
	var propertyConfig = __webpack_require__(53);
	var styleToObject = __webpack_require__(70);
	var config = propertyConfig.config;
	var isCustomAttribute = propertyConfig.HTMLDOMPropertyConfig.isCustomAttribute;
	
	var DOMProperty = __webpack_require__(17);
	DOMProperty.injection.injectDOMPropertyConfig(propertyConfig.HTMLDOMPropertyConfig);
	
	/**
	 * Make attributes compatible with React props.
	 *
	 * @param  {Object} attributes - The attributes.
	 * @return {Object}            - The props.
	 */
	function attributesToProps(attributes) {
	    attributes = attributes || {};
	    var props = {};
	    var propertyName;
	    var propertyValue;
	    var reactProperty;
	
	    for (propertyName in attributes) {
	        propertyValue = attributes[propertyName];
	
	        // custom attributes (`data-` and `aria-`)
	        if (isCustomAttribute(propertyName)) {
	            props[propertyName] = propertyValue;
	            continue;
	        }
	
	        // make HTML DOM attribute/property consistent with React attribute/property
	        reactProperty = config.html[propertyName.toLowerCase()];
	        if (reactProperty) {
	            if (DOMProperty.properties.hasOwnProperty(reactProperty) && DOMProperty.properties[reactProperty].hasBooleanValue) {
	                props[reactProperty] = true;
	            } else {
	                props[reactProperty] = propertyValue;
	            }
	            continue;
	        }
	
	        // make SVG DOM attribute/property consistent with React attribute/property
	        reactProperty = config.svg[propertyName];
	        if (reactProperty) {
	            props[reactProperty] = propertyValue;
	        }
	    }
	
	    // convert inline style to object
	    if (attributes.style != null) {
	        props.style = cssToJs(attributes.style);
	    }
	
	    return props;
	}
	
	/**
	 * Convert CSS style string to JS style object.
	 *
	 * @param  {String} style - The CSS style.
	 * @return {Object}       - The JS style object.
	 */
	function cssToJs(style) {
	    if (typeof style !== 'string') {
	        throw new Error('`cssToJs`: first argument must be a string. ');
	    }
	
	    var styleObj = {};
	
	    styleToObject(style, function(propName, propValue) {
	        // Check if it's not a comment node
	        if (propName && propValue) {
	            styleObj[utilities.camelCase(propName)] = propValue;
	        }
	    });
	
	    return styleObj;
	}
	
	/**
	 * Export attributes to props helper.
	 */
	module.exports = attributesToProps;


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var React = __webpack_require__(2);
	var attributesToProps = __webpack_require__(51);
	
	/**
	 * Convert DOM nodes to React elements.
	 *
	 * @param  {Array}    nodes             - The DOM nodes.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function domToReact(nodes, options) {
	    options = options || {};
	    var result = [];
	    var node;
	    var isReplacePresent = typeof options.replace === 'function';
	    var replacement;
	    var props;
	    var children;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	        node = nodes[i];
	
	        // replace with custom React element (if applicable)
	        if (isReplacePresent) {
	            replacement = options.replace(node);
	
	            if (React.isValidElement(replacement)) {
	                // specify a "key" prop if element has siblings
	                // https://fb.me/react-warning-keys
	                if (len > 1) {
	                    replacement = React.cloneElement(replacement, { key: i });
	                }
	                result.push(replacement);
	                continue;
	            }
	        }
	
	        if (node.type === 'text') {
	            result.push(node.data);
	            continue;
	        }
	
	        // update values
	        props = attributesToProps(node.attribs);
	        children = null;
	
	        // node type for <script> is "script"
	        // node type for <style> is "style"
	        if (node.type === 'script' || node.type === 'style') {
	            // prevent text in <script> or <style> from being escaped
	            // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
	            if (node.children[0]) {
	                props.dangerouslySetInnerHTML = {
	                    __html: node.children[0].data
	                };
	            }
	
	        } else if (node.type === 'tag') {
	            // setting textarea value in children is an antipattern in React
	            // https://facebook.github.io/react/docs/forms.html#why-textarea-value
	            if (node.name === 'textarea' && node.children[0]) {
	                props.defaultValue = node.children[0].data;
	
	            // continue recursion of creating React elements (if applicable)
	            } else if (node.children && node.children.length) {
	                children = domToReact(node.children, options);
	            }
	
	        // skip all other cases (e.g., comment)
	        } else {
	            continue;
	        }
	
	        // specify a "key" prop if element has siblings
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	            props.key = i;
	        }
	
	        result.push(
	            React.createElement(node.name, props, children)
	        );
	    }
	
	    if (result.length === 1) {
	        return result[0];
	    } else {
	        return result;
	    }
	}
	
	/**
	 * Export DOM to React parser.
	 */
	module.exports = domToReact;


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var utilities = __webpack_require__(16);
	
	// HTML and SVG DOM Property Configs
	var HTMLDOMPropertyConfig = __webpack_require__(56);
	var SVGDOMPropertyConfig = __webpack_require__(57);
	
	var config = {
	    html: {},
	    svg: {}
	};
	
	var propertyName;
	
	/**
	 * HTML DOM property config.
	 * https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 */
	
	// first map out the HTML attribute names
	// e.g., { className: 'class' } => { 'class': 'className' }
	config.html = utilities.invertObject(
	    HTMLDOMPropertyConfig.DOMAttributeNames
	);
	
	// then map out the rest of the HTML properties
	// e.g., { readOnly: 0 } => { readonly: 'readOnly' }
	for (propertyName in HTMLDOMPropertyConfig.Properties) {
	    // lowercase to make matching property names easier
	    config.html[propertyName.toLowerCase()] = propertyName;
	}
	
	/**
	 * SVG DOM property config.
	 * https://github.com/facebook/react/blob/master/src/renderers/dom/shared/SVGDOMPropertyConfig.js
	 */
	
	// first map out the SVG attribute names
	// e.g., { fontSize: 'font-size' } => { 'font-size': 'fontSize' }
	config.svg = utilities.invertObject(
	    SVGDOMPropertyConfig.DOMAttributeNames
	);
	
	// then map out the rest of the SVG properties
	// e.g., { fillRule: 0 } => { fillRule: 'fillRule' }
	for (propertyName in SVGDOMPropertyConfig.Properties) {
	    // do not lowercase as some svg properties are camel cased
	    config.html[propertyName] = propertyName;
	}
	
	/**
	 * Export property configs.
	 */
	module.exports = {
	    config: config,
	    HTMLDOMPropertyConfig: HTMLDOMPropertyConfig,
	    SVGDOMPropertyConfig: SVGDOMPropertyConfig
	};


/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	'use strict';
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Convert a string to camel case.
	 *
	 * @param  {String} string - The string.
	 * @return {String}
	 */
	function camelCase(string) {
	    if (typeof string !== 'string') { // null is an object
	        throw new TypeError('First argument must be a string');
	    }
	    if(string.indexOf('-') < 0) {
	        return string;
	    }
	    return string.toLowerCase().replace(_hyphenPattern, function(_, character) {
	        return character.toUpperCase();
	    });
	}
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	    if (typeof obj !== 'object' || !obj) { // null is an object
	        throw new TypeError('First argument must be an object');
	    }
	
	    var key;
	    var value;
	    var isOverridePresent = typeof override === 'function';
	    var overrides = {};
	    var result = {};
	
	    for (key in obj) {
	        value = obj[key];
	
	        if (isOverridePresent) {
	            overrides = override(key, value);
	            if (overrides && overrides.length === 2) {
	                result[overrides[0]] = overrides[1];
	                continue;
	            }
	        }
	
	        if (typeof value === 'string') {
	            result[value] = key;
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Export utilties.
	 */
	module.exports = {
	    camelCase: camelCase,
	    invertObject: invertObject
	};


/***/ }),

/***/ 525:
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(111);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(111);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(111);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(111);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(306);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(111);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(207);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(207);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(55);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var invariant = __webpack_require__(48);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(17);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(63);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(44);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(60);
	
	var _HelmetConstants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(30);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	/** @license React v16.4.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
	function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
	exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(61);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(47));
	var shallowEqual = _interopDefault(__webpack_require__(69));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withFoundation = exports.removeClass = exports.addClass = exports.syncFoundationProp = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/************************************************************************
	 * Utils
	 ***********************************************************************/
	var requestFrames = function requestFrames(callback, frameCount) {
	  var currentFrame = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  if (currentFrame < frameCount) {
	    window.requestAnimationFrame(function () {
	      return requestFrames(callback, frameCount, currentFrame + 1);
	    });
	  } else {
	    callback();
	  }
	};
	
	/** Copies all known properties from source to target. This is being used in here for class merging. */
	var copyProperties = function copyProperties(target, source) {
	  var allPropertyNames = Object.getOwnPropertyNames(source).concat(Object.getOwnPropertySymbols(source));
	
	  allPropertyNames.forEach(function (propertyName) {
	    if (String(propertyName).match(
	    // eslint-disable-next-line max-len
	    /^(?:constructor|prototype|arguments|caller|name|bind|call|apply|toString|length)$/)) {
	      return;
	    }
	    var value = Object.getOwnPropertyDescriptor(source, propertyName);
	    value !== undefined && Object.defineProperty(target, propertyName, value);
	  });
	};
	
	/** Simplifies redundant checks for syncWithProps */
	var syncFoundationProp = exports.syncFoundationProp = function syncFoundationProp(prop, foundationValue, callback) {
	  if (prop !== undefined && prop !== foundationValue) {
	    callback();
	  }
	};
	
	/************************************************************************
	 * Handler Factories
	 ***********************************************************************/
	var addClass = exports.addClass = function addClass() {
	  return function (className) {
	    if (!this.state.classes.has(className)) {
	      // The animation frame corrects an issue where MDC would set a class
	      // on a form element and cause re-render before the new value could actually be set from the onChange
	
	      this._safeSetState(function (prevState) {
	        return {
	          classes: prevState.classes.add(className)
	        };
	      });
	    }
	  };
	};
	
	var removeClass = exports.removeClass = function removeClass() {
	  return function (className) {
	    if (this.state.classes.has(className)) {
	      // The animation frame corrects an issue where MDC would set a class
	      // on a form element and cause re-render before the new value could actually be set from the onChange
	      this._safeSetState(function (prevState) {
	        return {
	          classes: prevState.classes.delete(className) ? prevState.classes : prevState.classes
	        };
	      });
	    }
	  };
	};
	
	/************************************************************************
	 * HOC
	 ***********************************************************************/
	var withFoundation = exports.withFoundation = function withFoundation(_ref) {
	  var FoundationConstructor = _ref.constructor,
	      _ref$adapter = _ref.adapter,
	      adapter = _ref$adapter === undefined ? {} : _ref$adapter,
	      _ref$refs = _ref.refs,
	      refs = _ref$refs === undefined ? ['root_'] : _ref$refs;
	
	  var Foundation = function (_React$Component) {
	    _inherits(Foundation, _React$Component);
	
	    function Foundation(props) {
	      _classCallCheck(this, Foundation);
	
	      var _this = _possibleConstructorReturn(this, (Foundation.__proto__ || Object.getPrototypeOf(Foundation)).call(this, props));
	
	      Object.defineProperty(_this, 'state', {
	        enumerable: true,
	        writable: true,
	        value: {
	          classes: new Set()
	        }
	      });
	
	
	      _this.foundationRefs = refs.reduce(function (acc, r) {
	        // Here we gracefully merge two refs together if one was passed down the chain
	        var propName = _this.props.elementRef && _this.props.elementRef.refName_ === r ? 'elementRef' : r;
	
	        acc[r] = function (ref) {
	          // React will return a null ref when unmounting which will
	          // in turn make our adapters error out. Make sure we only set a ref if its truthy.
	          if (ref) {
	            //$FlowFixMe
	            _this[r] = ref;
	            _this.props[propName] && _this.props[propName](ref);
	          }
	        };
	
	        // Store the refname on the object so we can reference it later and merge two of the same references together
	        acc[r].refName_ = r;
	
	        return acc;
	      }, {});
	
	      //$FlowFixMe
	      _this.syncWithProps = _this.syncWithProps.bind(_this);
	      return _this;
	    }
	
	    _createClass(Foundation, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.initFoundation();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this._safeSyncWithProps(nextProps);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.destroyComponent();
	      }
	    }, {
	      key: '_safeSyncWithProps',
	      value: function _safeSyncWithProps(props) {
	        this.foundation_ && this.syncWithProps(props);
	      }
	    }, {
	      key: '_safeSetState',
	      value: function _safeSetState() {
	        this.foundation_ && this.setState.apply(this, arguments);
	      }
	    }, {
	      key: 'initFoundation',
	      value: function initFoundation() {
	        var _this2 = this;
	
	        this.foundation_ = this.getDefaultFoundation();
	
	        Object.entries(adapter).forEach(function (_ref2) {
	          var _ref3 = _slicedToArray(_ref2, 2),
	              handlerName = _ref3[0],
	              handler = _ref3[1];
	
	          //$FlowFixMe
	          _this2.foundation_.adapter_[handlerName] = handler.bind(_this2);
	        });
	
	        this.initialize();
	        this.foundation_ && this.foundation_.init();
	        this.initialSyncWithDOM();
	        this._safeSyncWithProps(this.props);
	
	        // this method should be deprecated in the future in favor of standard refs
	        this.props.apiRef && this.props.apiRef(this);
	      }
	    }, {
	      key: 'destroyComponent',
	      value: function destroyComponent() {
	        var _this3 = this;
	
	        this.destroy();
	        this.foundation_ && this.foundation_.destroy();
	        this.foundation_ = undefined;
	
	        // We need to hold onto our refs until all child components are unmounted
	        // Here we just wait a few frames and set them to null so garbage collection will take over.
	        requestFrames(function () {
	          refs.forEach(function (refName) {
	            //$FlowFixMe
	            _this3[refName] && (_this3[refName] = undefined);
	          });
	        }, 3);
	      }
	    }, {
	      key: 'syncWithProps',
	      value: function syncWithProps(nextProps) {}
	    }, {
	      key: 'initialize',
	      value: function initialize() {}
	    }, {
	      key: 'initialSyncWithDOM',
	      value: function initialSyncWithDOM() {}
	    }, {
	      key: 'destroy',
	      value: function destroy() {}
	    }, {
	      key: 'getDefaultFoundation',
	      value: function getDefaultFoundation() {
	        return {};
	      }
	
	      /**
	       * Fires a cross-browser-compatible custom event from the component root of the given type,
	       */
	
	    }, {
	      key: 'emit',
	      value: function emit(evtType, evtData) {
	        var shouldBubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var evt = void 0;
	        if (typeof CustomEvent === 'function') {
	          evt = new CustomEvent(evtType, {
	            detail: evtData,
	            bubbles: shouldBubble
	          });
	        } else {
	          evt = document.createEvent('CustomEvent');
	          evt.initCustomEvent(evtType, shouldBubble, false, evtData);
	        }
	
	        var baseName = evtType.split(':').slice(-1).pop();
	        var propName = 'on' + baseName.charAt(0).toUpperCase() + baseName.slice(1);
	
	        this.props[propName] && this.props[propName](evt);
	
	        // MDC can change state internally, if we are triggering a handler, re-sync with our props
	        this._safeSyncWithProps(this.props);
	
	        return evt;
	      }
	    }, {
	      key: 'classes',
	      get: function get() {
	        return (0, _classnames2.default)(this.props.className, [].concat(_toConsumableArray(this.state.classes)));
	      }
	    }]);
	
	    return Foundation;
	  }(React.Component);
	
	  copyProperties(Foundation.prototype, FoundationConstructor.prototype);
	
	  return Foundation;
	};


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleTag = __webpack_require__(64);
	
	Object.defineProperty(exports, 'simpleTag', {
	  enumerable: true,
	  get: function get() {
	    return _simpleTag.simpleTag;
	  }
	});
	
	var _withRipple = __webpack_require__(67);
	
	Object.defineProperty(exports, 'withRipple', {
	  enumerable: true,
	  get: function get() {
	    return _withRipple.withRipple;
	  }
	});
	
	var _withTheme = __webpack_require__(22);
	
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.withTheme;
	  }
	});
	
	var _withMDC = __webpack_require__(21);
	
	Object.defineProperty(exports, 'withMDC', {
	  enumerable: true,
	  get: function get() {
	    return _withMDC.withMDC;
	  }
	});
	
	var _withMDCToggle = __webpack_require__(66);
	
	Object.defineProperty(exports, 'withMDCToggle', {
	  enumerable: true,
	  get: function get() {
	    return _withMDCToggle.withMDCToggle;
	  }
	});
	
	var _noop = __webpack_require__(20);
	
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _noop.noop;
	  }
	});


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simpleTag = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withTheme = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var simpleTag = function simpleTag(_ref) {
	  var _ref$displayName = _ref.displayName,
	      displayName = _ref$displayName === undefined ? 'SimpleTag' : _ref$displayName,
	      _ref$defaultProps = _ref.defaultProps,
	      defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps,
	      _ref$consumeProps = _ref.consumeProps,
	      consumeProps = _ref$consumeProps === undefined ? [] : _ref$consumeProps,
	      tag = _ref.tag,
	      _ref$wrap = _ref.wrap,
	      defaultWrap = _ref$wrap === undefined ? false : _ref$wrap,
	      classNames = _ref.classNames;
	
	  var defaultTag = tag || 'div';
	
	  var SimpleTag = function (_React$Component) {
	    _inherits(SimpleTag, _React$Component);
	
	    function SimpleTag() {
	      _classCallCheck(this, SimpleTag);
	
	      return _possibleConstructorReturn(this, (SimpleTag.__proto__ || Object.getPrototypeOf(SimpleTag)).apply(this, arguments));
	    }
	
	    _createClass(SimpleTag, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            tag = _props.tag,
	            className = _props.className,
	            _props$wrap = _props.wrap,
	            wrap = _props$wrap === undefined ? false : _props$wrap,
	            elementRef = _props.elementRef,
	            theme = _props.theme,
	            rest = _objectWithoutProperties(_props, ['tag', 'className', 'wrap', 'elementRef', 'theme']);
	
	        // choose the tag we are going to render
	
	        var Component = typeof defaultTag === 'function' && typeof tag === 'string' ? defaultTag : tag || defaultTag;
	
	        // consume any props that shouldnt be passed along
	        var safeRest = Object.assign({}, rest);
	        consumeProps.forEach(function (p) {
	          delete safeRest[p];
	        });
	
	        // sometimes we are extending a component, we can still honor a text based tag
	        if (typeof defaultTag === 'function' && typeof tag === 'string') {
	          safeRest.tag = tag;
	        }
	
	        // handle elementRefs
	        if (elementRef) {
	          // if the tag is a string, make our ref
	          // otherwise pass elementRef along
	          if (typeof Component === 'string') {
	            safeRest.ref = elementRef;
	          } else {
	            safeRest.elementRef = elementRef;
	          }
	        }
	
	        // generate the final classnames for the component
	        var safeClassNames = (0, _classnames2.default)(className, (0, _withTheme.parseThemeOptions)(theme), typeof classNames === 'function' ? classNames(rest) : classNames);
	
	        // handle wrapping components
	        if (wrap || defaultWrap) {
	          // sometimes we have undefined children
	          if (!rest.children) return null;
	
	          // make sure we delete our children here
	          // so we dont recursively clone ourselves
	          delete safeRest.children;
	          var child = React.Children.only(rest.children);
	          return React.cloneElement(child, Object.assign({}, child.props, safeRest, { className: safeClassNames }));
	        }
	
	        // default return
	        return React.createElement(Component, Object.assign({ className: safeClassNames }, safeRest));
	      }
	    }]);
	
	    return SimpleTag;
	  }(React.Component);
	
	  Object.defineProperty(SimpleTag, 'displayName', {
	    enumerable: true,
	    writable: true,
	    value: displayName
	  });
	  Object.defineProperty(SimpleTag, 'defaultProps', {
	    enumerable: true,
	    writable: true,
	    value: Object.assign({}, defaultProps, {
	      tag: defaultTag
	    })
	  });
	  Object.defineProperty(SimpleTag, 'isSimpleTag', {
	    enumerable: true,
	    writable: true,
	    value: true
	  });
	
	
	  return SimpleTag;
	};
	exports.simpleTag = simpleTag;


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var noop = exports.noop = function noop() {};
	exports.default = noop;


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Generates a pseudo random string for DOM ids
	 * Will return 'test' in the NODE test-env so things like storyshots doesnt break.
	 * */
	var randomId = exports.randomId = function randomId(prefix) {
	  var id =  false ? 'test' : (Math.random() + Math.random() + 1).toString(36).substring(2);
	  return prefix + '-' + id;
	};


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withMDC = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _noop = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that adds ripples to any component
	 */
	var withMDC = function withMDC(_ref) {
	  var MDCConstructor = _ref.mdcConstructor,
	      _ref$getMdcConstructo = _ref.getMdcConstructorOrInstance,
	      getMdcConstructorOrInstance = _ref$getMdcConstructo === undefined ? function () {
	    return null;
	  } : _ref$getMdcConstructo,
	      contextTypes = _ref.contextTypes,
	      _ref$mdcEvents = _ref.mdcEvents,
	      mdcEvents = _ref$mdcEvents === undefined ? {} : _ref$mdcEvents,
	      _ref$mdcElementRef = _ref.mdcElementRef,
	      mdcElementRef = _ref$mdcElementRef === undefined ? false : _ref$mdcElementRef,
	      _ref$mdcApiRef = _ref.mdcApiRef,
	      mdcApiRef = _ref$mdcApiRef === undefined ? false : _ref$mdcApiRef,
	      _ref$mdcComponentRein = _ref.mdcComponentReinit,
	      mdcComponentReinit = _ref$mdcComponentRein === undefined ? false : _ref$mdcComponentRein,
	      _ref$defaultProps = _ref.defaultProps,
	      defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps,
	      _ref$onMount = _ref.onMount,
	      onMount = _ref$onMount === undefined ? _noop.noop : _ref$onMount,
	      _ref$onUpdate = _ref.onUpdate,
	      onUpdate = _ref$onUpdate === undefined ? _noop.noop : _ref$onUpdate,
	      _ref$didUpdate = _ref.didUpdate,
	      didUpdate = _ref$didUpdate === undefined ? _noop.noop : _ref$didUpdate;
	  return function (Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class(props) {
	        _classCallCheck(this, _class);
	
	        //$FlowFixMe
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        Object.defineProperty(_this, 'mdcListeners', {
	          enumerable: true,
	          writable: true,
	          value: []
	        });
	        Object.defineProperty(_this, 'elementRefProps', {
	          enumerable: true,
	          writable: true,
	          value: {}
	        });
	        _this.mdcSetRootElement = _this.mdcSetRootElement.bind(_this);
	        _this.elementRefProps = mdcElementRef ? {
	          mdcElementRef: _this.mdcSetRootElement
	        } : {};
	        //$FlowFixMe
	        _this.mdcComponentReinit = _this.mdcComponentReinit.bind(_this);
	        return _this;
	      }
	
	      _createClass(_class, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.mdcComponentInit();
	        }
	      }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps) {
	          onUpdate(this.props, nextProps, this.mdcApi, this);
	        }
	      }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	          didUpdate(prevProps, this.props, this.mdcApi, this);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.mdcComponentDestroy();
	        }
	      }, {
	        key: 'mdcComponentInit',
	        value: function mdcComponentInit() {
	          var _this2 = this;
	
	          var MDCConstructorToUse = MDCConstructor || getMdcConstructorOrInstance(this.props, this.context);
	
	          // In select cases, getMdcConstructorOrInstance actually needs to handle an instance
	          // if we have an object instead of a function, handle it accordingly.
	          var isInstance = MDCConstructorToUse && (typeof MDCConstructorToUse === 'undefined' ? 'undefined' : _typeof(MDCConstructorToUse)) === 'object';
	
	          if (isInstance) {
	            this.mdcApi = MDCConstructorToUse;
	            this.mdcApi && this.props.apiRef(this.mdcApi);
	            //$FlowFixMe
	          } else if (MDCConstructorToUse && this.props && !this.props.cssOnly) {
	            var el = this.mdcGetRootElement();
	            try {
	              this.mdcApi = new MDCConstructorToUse(el);
	              this.props.apiRef(this.mdcApi);
	            } catch (err) {
	              console.warn(MDCConstructorToUse.name + ' failed to initialize because of the following error:', err);
	            }
	          }
	          onMount(this.props, this.mdcApi, this);
	
	          // register event listeners
	          Object.entries(typeof mdcEvents === 'function' ? mdcEvents(this.props) : mdcEvents).forEach(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                eventName = _ref3[0],
	                handler = _ref3[1];
	
	            typeof handler === 'function' && _this2.mdcRegisterListener(eventName, handler);
	          });
	
	          onUpdate(undefined, this.props, this.mdcApi, this);
	          didUpdate(undefined, this.props, this.mdcApi, this);
	        }
	      }, {
	        key: 'mdcComponentReinit',
	        value: function mdcComponentReinit() {
	          this.mdcComponentDestroy();
	          this.mdcComponentInit();
	        }
	      }, {
	        key: 'mdcComponentDestroy',
	        value: function mdcComponentDestroy() {
	          this.mdcUnregisterAllListeners();
	          this.mdcApi && this.mdcApi.destroy();
	          this.mdcApi = null;
	        }
	      }, {
	        key: 'mdcRegisterListener',
	        value: function mdcRegisterListener(eventName, func) {
	          var _this3 = this;
	
	          var wrappedHandler = function wrappedHandler(evt) {
	            return func(evt, _this3.props, _this3.mdcApi);
	          };
	          this.mdcApi && this.mdcApi.listen(eventName, wrappedHandler);
	          this.mdcListeners.push(function () {
	            return _this3.mdcApi && _this3.mdcApi.unlisten(eventName, wrappedHandler);
	          });
	        }
	      }, {
	        key: 'mdcUnregisterAllListeners',
	        value: function mdcUnregisterAllListeners() {
	          this.mdcListeners.forEach(function (unlisten) {
	            return unlisten();
	          });
	          this.mdcListeners.length = 0;
	        }
	      }, {
	        key: 'mdcSetRootElement',
	        value: function mdcSetRootElement(el) {
	          this.mdcRootElement = el;
	          return el;
	        }
	      }, {
	        key: 'mdcGetRootElement',
	        value: function mdcGetRootElement() {
	          return this.mdcRootElement || _reactDom2.default.findDOMNode(this);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              apiRef = _props.apiRef,
	              rest = _objectWithoutProperties(_props, ['apiRef']);
	
	          // This is for cases where we have to pass the api to the subcomponent
	
	
	          var apiRefProps = mdcApiRef ? {
	            mdcApiRef: this.mdcApi
	          } : {};
	
	          var mdcComponentReinitProp = mdcComponentReinit ? { mdcComponentReinit: this.mdcComponentReinit } : {};
	
	          return React.createElement(Component, Object.assign({}, mdcComponentReinitProp, apiRefProps, this.elementRefProps, rest));
	        }
	      }]);
	
	      return _class;
	    }(React.Component), Object.defineProperty(_class, 'displayName', {
	      enumerable: true,
	      writable: true,
	      value: 'withMDC(' + String(Component.displayName) + ')'
	    }), Object.defineProperty(_class, 'defaultProps', {
	      enumerable: true,
	      writable: true,
	      value: Object.assign({
	        apiRef: _noop.noop
	      }, defaultProps)
	    }), Object.defineProperty(_class, 'contextTypes', {
	      enumerable: true,
	      writable: true,
	      value: contextTypes
	    }), _temp;
	  };
	};
	exports.withMDC = withMDC;


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withMDCToggle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _withMDC = __webpack_require__(21);
	
	var _randomId = __webpack_require__(65);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withMDCToggle = exports.withMDCToggle = function withMDCToggle() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      mdcConstructor = _ref.mdcConstructor;
	
	  return function (Component) {
	    return (0, _withMDC.withMDC)({
	      mdcConstructor: mdcConstructor,
	      mdcElementRef: true,
	      defaultProps: {
	        label: undefined,
	        id: undefined,
	        checked: undefined,
	        indeterminate: undefined,
	        disabled: false
	      },
	      onUpdate: function onUpdate(props, nextProps, api) {
	        if (api && nextProps.indeterminate !== api.indeterminate) {
	          api.indeterminate = nextProps.indeterminate;
	        }
	      }
	    })(function (_React$Component) {
	      _inherits(_class2, _React$Component);
	
	      function _class2() {
	        _classCallCheck(this, _class2);
	
	        return _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).apply(this, arguments));
	      }
	
	      _createClass(_class2, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this.generatedId = (0, _randomId.randomId)('toggle');
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return React.createElement(Component, Object.assign({}, this.props, { generatedId: this.generatedId }));
	        }
	      }]);
	
	      return _class2;
	    }(React.Component));
	  };
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withRipple = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _Ripple = __webpack_require__(68);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that adds ripples to any component
	 */
	var withRipple = function withRipple() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      defaultUnbounded = _ref.unbounded,
	      _ref$surface = _ref.surface,
	      defaultSurface = _ref$surface === undefined ? true : _ref$surface;
	
	  return function (Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	      }
	
	      _createClass(_class, [{
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              ripple = _props.ripple,
	              rest = _objectWithoutProperties(_props, ['ripple']);
	
	          if (ripple && !rest.cssOnly) {
	            return React.createElement(
	              _Ripple.Ripple,
	              Object.assign({}, rest, {
	                unbounded: rest.unbounded || defaultUnbounded,
	                surface: rest.surface || defaultSurface
	              }),
	              React.createElement(Component, rest)
	            );
	          }
	
	          return React.createElement(Component, rest);
	        }
	      }]);
	
	      return _class;
	    }(React.Component), Object.defineProperty(_class, 'displayName', {
	      enumerable: true,
	      writable: true,
	      value: 'withRipple(' + (Component.displayName || 'Unknown') + ')'
	    }), Object.defineProperty(_class, 'defaultProps', {
	      enumerable: true,
	      writable: true,
	      value: {
	        ripple: true
	      }
	    }), _temp;
	  };
	};
	exports.withRipple = withRipple;


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTheme = exports.parseThemeOptions = undefined;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Actually parses the theme options
	 */
	var parseThemeOptions = exports.parseThemeOptions = function parseThemeOptions(theme) {
	  if (theme) {
	    var themeItems = Array.isArray(theme) ? theme : theme.split(' ');
	    return themeItems.map(function (v) {
	      return 'mdc-theme--' + v;
	    });
	  }
	  return [];
	};
	
	/**
	 * HOC that adds themeability to any component
	 */
	var withTheme = function withTheme(Component) {
	  var HOC = function HOC(_ref) {
	    var theme = _ref.theme,
	        className = _ref.className,
	        rest = _objectWithoutProperties(_ref, ['theme', 'className']);
	
	    if (theme) {
	      var classes = (0, _classnames2.default)(className, parseThemeOptions(theme));
	      return React.createElement(Component, Object.assign({ className: classes }, rest));
	    }
	
	    return React.createElement(Component, Object.assign({ className: className }, rest));
	  };
	
	  HOC.displayName = 'withTheme';
	
	  return HOC;
	};
	exports.withTheme = withTheme;


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Grid = exports.GridInner = exports.GridCell = exports.GridRoot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _Base = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/****************************************************************
	 * Private
	 ****************************************************************/
	var GridRoot = exports.GridRoot = (0, _Base.simpleTag)({
	  displayName: 'GridRoot',
	  classNames: function classNames(props) {
	    var _ref;
	
	    return ['mdc-layout-grid', (_ref = {}, _defineProperty(_ref, 'mdc-layout-grid__cell--align-' + props.align, props.align !== undefined), _defineProperty(_ref, 'mdc-layout-grid--fixed-column-width', props.fixedColumnWidth), _ref)];
	  },
	  consumeProps: ['fixedColumnWidth', 'align']
	});
	
	/****************************************************************
	 * Public
	 ****************************************************************/
	
	/** A Grid cell */
	var GridCell = exports.GridCell = function (_simpleTag) {
	  _inherits(GridCell, _simpleTag);
	
	  function GridCell() {
	    _classCallCheck(this, GridCell);
	
	    return _possibleConstructorReturn(this, (GridCell.__proto__ || Object.getPrototypeOf(GridCell)).apply(this, arguments));
	  }
	
	  _createClass(GridCell, [{
	    key: 'render',
	    value: function render() {
	      return _get(GridCell.prototype.__proto__ || Object.getPrototypeOf(GridCell.prototype), 'render', this).call(this);
	    }
	  }]);
	
	  return GridCell;
	}((0, _Base.simpleTag)({
	  displayName: 'GridCell',
	  defaultProps: {
	    span: undefined,
	    phone: undefined,
	    tablet: undefined,
	    desktop: undefined,
	    order: undefined
	  },
	  classNames: function classNames(props) {
	    var _ref2;
	
	    return ['mdc-layout-grid__cell', (_ref2 = {}, _defineProperty(_ref2, 'mdc-layout-grid__cell--order-' + props.order, props.order !== undefined), _defineProperty(_ref2, 'mdc-layout-grid__cell--align-' + props.align, props.align !== undefined), _defineProperty(_ref2, 'mdc-layout-grid__cell--span-' + props.span, props.span !== undefined), _defineProperty(_ref2, 'mdc-layout-grid__cell--span-' + props.phone + '-phone', props.phone !== undefined), _defineProperty(_ref2, 'mdc-layout-grid__cell--span-' + props.tablet + '-tablet', props.tablet !== undefined), _defineProperty(_ref2, 'mdc-layout-grid__cell--span-' + props.desktop + '-desktop', props.desktop !== undefined), _ref2)];
	  },
	  consumeProps: ['span', 'phone', 'tablet', 'desktop', 'order', 'align']
	}));
	
	/** By default, an inner grid component is included inside of <Grid>. Use GridInner when doing nested Grids. */
	
	
	var GridInner = exports.GridInner = (0, _Base.simpleTag)({
	  displayName: 'GridInner',
	  classNames: 'mdc-layout-grid__inner'
	});
	
	/** A Grid component */
	var Grid = function Grid(_ref3) {
	  var children = _ref3.children,
	      rest = _objectWithoutProperties(_ref3, ['children']);
	
	  return React.createElement(
	    GridRoot,
	    rest,
	    React.createElement(
	      GridInner,
	      null,
	      children
	    )
	  );
	};
	
	exports.Grid = Grid;
	Grid.displayName = 'Grid';


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Icon = exports.IconRoot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(10);
	
	var _Base = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconRoot = exports.IconRoot = (0, _Base.simpleTag)({ displayName: 'IconRoot', tag: 'i' });
	
	// prettier-ignore
	
	
	var renderLigature = function renderLigature(_ref) {
	  var content = _ref.content,
	      rest = _objectWithoutProperties(_ref, ['content']);
	
	  return React.createElement(
	    IconRoot,
	    rest,
	    content
	  );
	};
	
	var renderClassName = function renderClassName(_ref2) {
	  var content = _ref2.content,
	      rest = _objectWithoutProperties(_ref2, ['content']);
	
	  return React.createElement(IconRoot, rest);
	};
	
	var renderUrl = function renderUrl(_ref3) {
	  var content = _ref3.content,
	      rest = _objectWithoutProperties(_ref3, ['content']);
	
	  return React.createElement(IconRoot, Object.assign({ tag: 'img', src: content }, rest));
	};
	
	var renderComponent = function renderComponent(_ref4) {
	  var content = _ref4.content,
	      rest = _objectWithoutProperties(_ref4, ['content']);
	
	  return React.createElement(
	    IconRoot,
	    rest,
	    content
	  );
	};
	
	var iconRenderMap = {
	  ligature: renderLigature,
	  className: renderClassName,
	  url: renderUrl,
	  component: renderComponent
	};
	
	/**
	 * Given content, tries to figure out an appropriate strategy for it
	 */
	var processAutoStrategy = function processAutoStrategy(content) {
	  // check for URLS
	  if (typeof content === 'string' && (content.startsWith('/') || content.startsWith('http://') || content.startsWith('https://'))) {
	    return 'url';
	  }
	
	  // handle JSX components
	  if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object') {
	    return 'component';
	  }
	
	  // we dont know what it is, default to ligature for compat with material icons
	  return 'ligature';
	};
	
	/**
	 * Get the actual icon strategy to use
	 */
	var getIconStrategy = function getIconStrategy(content, strategy, defaultStrategy) {
	  strategy = strategy || defaultStrategy;
	
	  if (strategy === 'auto') {
	    return processAutoStrategy(content);
	  }
	
	  return strategy;
	};
	
	/**
	 * An Icon component. Most of these options can be set once globally, read the documentation on Provider for more info.
	 */
	var Icon = exports.Icon = function (_React$PureComponent) {
	  _inherits(Icon, _React$PureComponent);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.providerOptions = (0, _Provider.getProviderOptions)(this.context);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          use = _props.use,
	          children = _props.children,
	          render = _props.render,
	          strategy = _props.strategy,
	          prefix = _props.prefix,
	          basename = _props.basename,
	          rest = _objectWithoutProperties(_props, ['use', 'children', 'render', 'strategy', 'prefix', 'basename']);
	
	      var _providerOptions = this.providerOptions,
	          defaultBasename = _providerOptions.iconClassNameBase,
	          defaultPrefix = _providerOptions.iconClassNamePrefix,
	          defaultStrategy = _providerOptions.iconStrategy,
	          defaultCustomRender = _providerOptions.iconRender;
	
	
	      var content = use || children;
	      var strategyToUse = getIconStrategy(content, strategy, defaultStrategy);
	      var prefixToUse = prefix || defaultPrefix;
	      var basenameToUse = basename === undefined ? defaultBasename : basename;
	      var iconClassName = strategyToUse === 'className' && typeof content === 'string' ? '' + String(prefixToUse) + content : null;
	
	      var renderToUse = strategyToUse === 'custom' ? render || defaultCustomRender : // $FlowFixMe
	      iconRenderMap[strategyToUse];
	
	      if (!renderToUse) {
	        console.error('Icon: rendering not implemented for ' + String(strategyToUse) + '.');
	        return null;
	      }
	
	      //$FlowFixMe
	      return renderToUse(Object.assign({}, rest, {
	        content: content,
	        className: (0, _classnames2.default)(basenameToUse, rest.className, iconClassName)
	      }));
	    }
	  }]);
	
	  return Icon;
	}(React.PureComponent);
	
	Object.defineProperty(Icon, 'defaultProps', {
	  enumerable: true,
	  writable: true,
	  value: {
	    use: undefined
	  }
	});
	Object.defineProperty(Icon, 'contextTypes', {
	  enumerable: true,
	  writable: true,
	  value: {
	    RMWCOptions: _propTypes2.default.object
	  }
	});
	exports.default = Icon;


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RMWCProvider = exports.getProviderOptions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Default provider options
	
	
	// prettier-ignore
	// eslint-disable-next-line max-len
	var providerDefaults = {
	  buttonDefaultRipple: true,
	  listItemDefaultRipple: true,
	  iconClassNameBase: 'material-icons',
	  iconClassNamePrefix: '',
	  iconStrategy: 'auto',
	  iconRender: undefined
	};
	
	// A function for safely getting context options
	// this is so we can use the provider defaults even
	// when RMWCProvider inst being used
	var getProviderOptions = exports.getProviderOptions = function getProviderOptions(context) {
	  return context && context.RMWCOptions ? context.RMWCOptions : providerDefaults;
	};
	
	/**
	 * Provides default options for children
	 * Prop override options in providerDefaults with the same name
	 */
	
	var RMWCProvider = exports.RMWCProvider = function (_React$Component) {
	  _inherits(RMWCProvider, _React$Component);
	
	  function RMWCProvider(props) {
	    _classCallCheck(this, RMWCProvider);
	
	    var _this = _possibleConstructorReturn(this, (RMWCProvider.__proto__ || Object.getPrototypeOf(RMWCProvider)).call(this, props));
	
	    _this.options = _this.buildOptions(props);
	    return _this;
	  }
	
	  _createClass(RMWCProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        RMWCOptions: this.options
	      };
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      this.options = this.buildOptions(nextProps);
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions(props) {
	      return Object.assign({}, providerDefaults, props || {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RMWCProvider;
	}(React.Component);
	
	Object.defineProperty(RMWCProvider, 'defaultProps', {
	  enumerable: true,
	  writable: true,
	  value: providerDefaults
	});
	Object.defineProperty(RMWCProvider, 'childContextTypes', {
	  enumerable: true,
	  writable: true,
	  value: {
	    RMWCOptions: _propTypes2.default.object
	  }
	});
	exports.default = RMWCProvider;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ripple = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdc = __webpack_require__(39);
	
	var _MDCFoundation = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ripple = exports.Ripple = function (_withFoundation) {
	  _inherits(Ripple, _withFoundation);
	
	  function Ripple() {
	    _classCallCheck(this, Ripple);
	
	    return _possibleConstructorReturn(this, (Ripple.__proto__ || Object.getPrototypeOf(Ripple)).apply(this, arguments));
	  }
	
	  _createClass(Ripple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Ripples can be used with many types of components
	      // we need to use ReactDOM as an escape hatch to just find the DOMNode
	      this.root_ = _reactDom2.default.findDOMNode(this);
	      _get(Ripple.prototype.__proto__ || Object.getPrototypeOf(Ripple.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'syncWithProps',
	    value: function syncWithProps(nextProps) {
	      var _this2 = this;
	
	      // We dont know how React might have changed our dom node, re-grab it.
	      this.root_ = _reactDom2.default.findDOMNode(this);
	
	      // unbounded
	      (0, _MDCFoundation.syncFoundationProp)(nextProps.unbounded, this.unbounded, function () {
	        return _this2.unbounded = nextProps.unbounded;
	      });
	
	      //disabled
	      (0, _MDCFoundation.syncFoundationProp)(nextProps.disabled, this.disabled, function () {
	        return _this2.disabled = nextProps.disabled;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          primary = _props.primary,
	          accent = _props.accent,
	          unbounded = _props.unbounded,
	          surface = _props.surface,
	          apiRef = _props.apiRef,
	          rest = _objectWithoutProperties(_props, ['children', 'className', 'primary', 'accent', 'unbounded', 'surface', 'apiRef']);
	
	      var child = React.Children.only(children);
	
	      var unboundedProp = unbounded ? { 'data-mdc-ripple-is-unbounded': true } : {};
	
	      return React.cloneElement(child, Object.assign({}, child.props, rest, unboundedProp, {
	        className: (0, _classnames2.default)(child.props.className, [].concat(_toConsumableArray(this.state.classes)), {
	          'mdc-ripple-surface': surface !== undefined ? surface : true,
	          'mdc-ripple-surface--primary': primary,
	          'mdc-ripple-surface--accent': accent
	        })
	      }));
	    }
	  }]);
	
	  return Ripple;
	}((0, _MDCFoundation.withFoundation)({
	  constructor: _mdc.MDCRipple,
	  adapter: {}
	}));
	
	Object.defineProperty(Ripple, 'displayName', {
	  enumerable: true,
	  writable: true,
	  value: 'Ripple'
	});
	exports.default = Ripple;


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Theme = undefined;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _Base = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ThemeRoot = (0, _Base.simpleTag)({
	  tag: 'span'
	});
	
	/**
	 * A Theme Component.
	 */
	var Theme = function Theme(_ref) {
	  var use = _ref.use,
	      rest = _objectWithoutProperties(_ref, ['use']);
	
	  return React.createElement(ThemeRoot, Object.assign({ theme: use }, rest));
	};
	
	exports.Theme = Theme;
	Theme.displayName = 'Theme';


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopAppBar = exports.TopAppBarTitle = exports.TopAppBarActionItem = exports.TopAppBarNavigationIcon = exports.TopAppBarSection = exports.TopAppBarRow = exports.TopAppBarRoot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _mdc = __webpack_require__(211);
	
	var _Icon = __webpack_require__(7);
	
	var _Base = __webpack_require__(5);
	
	var _MDCFoundation = __webpack_require__(19);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopAppBarRoot = exports.TopAppBarRoot = (0, _Base.simpleTag)({
	  displayName: 'TopAppBarRoot',
	  tag: 'header',
	  classNames: function classNames(props) {
	    return ['mdc-top-app-bar', {
	      'mdc-top-app-bar--fixed': props.fixed,
	      'mdc-top-app-bar--prominent': props.prominent,
	      'mdc-top-app-bar--short': props.short || props.shortCollapsed,
	      'mdc-top-app-bar--short-collapsed': props.shortCollapsed,
	      'mdc-top-app-bar--dense': props.dense
	    }];
	  },
	  consumeProps: ['fixed', 'prominent', 'short', 'shortCollapsed', 'dense']
	});
	
	/** A row for the app bar. */
	var TopAppBarRow = exports.TopAppBarRow = (0, _Base.simpleTag)({
	  displayName: 'TopAppBarRow',
	  classNames: 'mdc-top-app-bar__row'
	});
	
	/** A section for the app bar. */
	var TopAppBarSection = exports.TopAppBarSection = function (_simpleTag) {
	  _inherits(TopAppBarSection, _simpleTag);
	
	  function TopAppBarSection() {
	    _classCallCheck(this, TopAppBarSection);
	
	    return _possibleConstructorReturn(this, (TopAppBarSection.__proto__ || Object.getPrototypeOf(TopAppBarSection)).apply(this, arguments));
	  }
	
	  _createClass(TopAppBarSection, [{
	    key: 'render',
	    value: function render() {
	      return _get(TopAppBarSection.prototype.__proto__ || Object.getPrototypeOf(TopAppBarSection.prototype), 'render', this).call(this);
	    }
	  }]);
	
	  return TopAppBarSection;
	}((0, _Base.simpleTag)({
	  tag: 'section',
	  classNames: function classNames(props) {
	    return ['mdc-top-app-bar__section', {
	      'mdc-top-app-bar__section--align-Start': props.alignStart,
	      'mdc-top-app-bar__section--align-end': props.alignEnd
	    }];
	  },
	  consumeProps: ['alignStart', 'alignEnd']
	}));
	
	/** A navigation icon for the top app bar. This is an instance of the Icon component. */
	
	
	Object.defineProperty(TopAppBarSection, 'displayName', {
	  enumerable: true,
	  writable: true,
	  value: 'TopAppBarSection'
	});
	var TopAppBarNavigationIcon = exports.TopAppBarNavigationIcon = (0, _Base.simpleTag)({
	  displayName: 'TopAppBarNavigationIcon',
	  classNames: 'mdc-top-app-bar__navigation-icon',
	  tag: _Icon.Icon
	});
	
	/** Action items for the top app bar. This is an instance of the Icon component.*/
	var TopAppBarActionItem = exports.TopAppBarActionItem = (0, _Base.simpleTag)({
	  displayName: 'TopAppBarActionItem',
	  classNames: 'mdc-top-app-bar__action-item',
	  tag: _Icon.Icon
	});
	
	/** A title for the top app bar. */
	var TopAppBarTitle = exports.TopAppBarTitle = (0, _Base.simpleTag)({
	  displayName: 'TopAppBarTitle',
	  classNames: 'mdc-top-app-bar__title'
	});
	
	/** A TopAppBar component */
	var TopAppBar = exports.TopAppBar = function (_withFoundation) {
	  _inherits(TopAppBar, _withFoundation);
	
	  function TopAppBar() {
	    _classCallCheck(this, TopAppBar);
	
	    return _possibleConstructorReturn(this, (TopAppBar.__proto__ || Object.getPrototypeOf(TopAppBar)).apply(this, arguments));
	  }
	
	  _createClass(TopAppBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onNav = _props.onNav,
	          apiRef = _props.apiRef,
	          rest = _objectWithoutProperties(_props, ['onNav', 'apiRef']);
	
	      var root_ = this.foundationRefs.root_;
	
	      return React.createElement(TopAppBarRoot, Object.assign({}, rest, { elementRef: root_, className: this.classes }));
	    }
	  }]);
	
	  return TopAppBar;
	}((0, _MDCFoundation.withFoundation)({
	  constructor: _mdc.MDCTopAppBar,
	  adapter: {}
	}));
	
	Object.defineProperty(TopAppBar, 'displayName', {
	  enumerable: true,
	  writable: true,
	  value: 'TopAppBar'
	});


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(43);
	
	/**
	 * Parses inline style.
	 *
	 * Example: 'color:red' => { color: 'red' }
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	module.exports = function parseInlineStyle(style, iterator) {
	  if (!style || typeof style !== 'string') return null;
	
	  // make sure to wrap declarations in placeholder
	  var declarations = parse('p{' + style + '}').stylesheet.rules[0].declarations;
	  var declaration, property, value;
	
	  var output = null;
	  var hasIterator = typeof iterator === 'function';
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	};


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isPlainObject = _interopDefault(__webpack_require__(54));
	var Stylis = _interopDefault(__webpack_require__(72));
	var _insertRulePlugin = _interopDefault(__webpack_require__(71));
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var hoist = _interopDefault(__webpack_require__(112));
	var reactIs = __webpack_require__(62);
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate$2(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	var hyphenate_1 = hyphenate$2;
	
	var hyphenate = hyphenate_1;
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	var hyphenateStyleName_1 = hyphenateStyleName;
	
	// 
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      return [].concat(ruleSet, flatten(chunk, executionContext));
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
	    }
	
	    /* Handle objects */
	    return ruleSet.concat(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	  }, []);
	};
	
	// 
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return typeof target === 'function' && typeof target.styledComponentId === 'string';
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  return interpolations.reduce(function (array, interp, i) {
	    return array.concat(interp, strings[i + 1]);
	  }, [strings[0]]);
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var css = (function (styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (!Array.isArray(styles) && (typeof styles === 'undefined' ? 'undefined' : _typeof(styles)) === 'object') {
	    return flatten(interleave([], [styles].concat(interpolations)));
	  }
	  return flatten(interleave(styles, interpolations));
	});
	
	var stream = {}
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/Shea/Sites/ACC-Sites/catalog/catalog2019-20/public"}).SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof false === 'boolean' && false || ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new Error();
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	/* eslint-disable flowtype/object-type-delimiter */
	/* eslint-disable react/prop-types */
	
	/* this error is used for makeStyleTag */
	var parentNodeUnmountedErr =  false ? '\nTrying to insert a new style tag, but the given Node is unmounted!\n- Are you using a custom target that isn\'t mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n'.trim() : '';
	
	/* this error is used for tags */
	var throwCloneTagErr = function throwCloneTagErr() {
	  throw new Error( false ? '\nThe clone method cannot be used on the client!\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n'.trim() : '');
	};
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new Error(parentNodeUnmountedErr);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    var marker = markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	    return marker;
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    styleTag: el,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    css: css,
	    toHTML: wrapAsHtmlTag(css, names),
	    toElement: wrapAsElement(css, names),
	    clone: throwCloneTagErr
	  };
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	  var makeTextNode = function makeTextNode(id) {
	    return document.createTextNode(makeTextMarker(id));
	  };
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    var marker = markers[id] = makeTextNode(id);
	    el.appendChild(marker);
	    names[id] = Object.create(null);
	    return marker;
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    styleTag: el,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    css: css,
	    toHTML: wrapAsHtmlTag(css, names),
	    toElement: wrapAsElement(css, names),
	    clone: throwCloneTagErr
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    styleTag: null,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    css: css,
	    toHTML: wrapAsHtmlTag(css, names),
	    toElement: wrapAsElement(css, names),
	    clone: clone
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, names, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0; i < extracted.length; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0; _i < els.length; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    this.id = sheetRunningId += 1;
	    this.sealed = false;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var names = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      isStreamed = !!el.getAttribute(SC_STREAM_ATTR) || isStreamed;
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(/\s+/);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	        names.push(name);
	      }
	
	      /* extract all components and their CSS */
	      extracted = extracted.concat(extractComps(el.textContent));
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, names, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	    this.sealed = true;
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !this.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      this.sealed = false;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    /* add deferred rules for component */
	    var injectRules = cssRules;
	    var deferredRules = this.deferred[id];
	    if (deferredRules !== undefined) {
	      injectRules = deferredRules.concat(injectRules);
	      delete this.deferred[id];
	    }
	
	    var tag = this.getTagForId(id);
	    tag.insertRules(id, injectRules, name);
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    delete this.deferred[id];
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	// 
	/* this error is used for makeStyleTag */
	var targetPropErr =  false ? '\nThe StyleSheetManager expects a valid target or sheet prop!\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n'.trim() : '';
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new Error(targetPropErr);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	/* eslint-disable no-underscore-dangle */
	/* this error is used for makeStyleTag */
	var sheetClosedErr =  false ? '\nCan\'t collect styles once you\'ve consumed a ServerStyleSheet\'s styles!\nServerStyleSheet is a one off instance for each server-side render cycle.\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n'.trim() : '';
	
	var streamBrowserErr =  false ? 'Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.' : '';
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new Error(sheetClosedErr);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new Error(streamBrowserErr);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	    var ourStream = new stream.Readable();
	    // $FlowFixMe
	    ourStream._read = function () {};
	
	    readableStream.on('data', function (chunk) {
	      var tags = instance.tags;
	
	      var html = '';
	
	      /* retrieve html for each new style tag */
	      for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	        var tag = tags[instanceTagIndex];
	        html += tag.toHTML(streamAttr);
	      }
	
	      /* force our StyleSheets to emit entirely new tags */
	      instance.sealAllTags();
	      /* prepend style html to chunk */
	      ourStream.push(html + chunk);
	    });
	
	    readableStream.on('end', function () {
	      _this.complete();
	      ourStream.push(null);
	    });
	
	    readableStream.on('error', function (err) {
	      _this.complete();
	      ourStream.emit('error', err);
	    });
	
	    return ourStream;
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	/* eslint-disable no-undef */
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 **/
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = (function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	});
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _ThemeProvider$childC;
	var _ThemeProvider$contex;
	
	// 
	/* globals React$Element */
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (false) {
	        throw new Error(process.env.NODE_ENV !== 'production' ? '[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!' : '');
	      }
	      return mergedTheme;
	    }
	    if (!isPlainObject(theme)) {
	      throw new Error( false ? '[ThemeProvider] Please make your theme prop a plain object' : '');
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = PropTypes.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	// 
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
	  var identifiers = {};
	
	  /* We depend on components having unique IDs */
	  var generateId = function generateId(_displayName, parentComponentId) {
	    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	    var componentId = void 0;
	
	    /**
	     * only fall back to hashing the component injection order if
	     * a proper displayName isn't provided by the babel plugin
	     */
	    if (!_displayName) {
	      var nr = (identifiers[displayName] || 0) + 1;
	      identifiers[displayName] = nr;
	
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	    } else {
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
	    }
	
	    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	  };
	
	  var BaseStyledComponent = function (_Component) {
	    inherits(BaseStyledComponent, _Component);
	
	    function BaseStyledComponent() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, BaseStyledComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	        theme: null,
	        generatedClassName: ''
	      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	      var attrs = this.constructor.attrs;
	
	      var context = _extends({}, props, { theme: theme });
	      if (attrs === undefined) {
	        return context;
	      }
	
	      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	        var attr = attrs[key];
	        // eslint-disable-next-line no-param-reassign
	        acc[key] = typeof attr === 'function' ? attr(context) : attr;
	        return acc;
	      }, {});
	
	      return _extends({}, context, this.attrs);
	    };
	
	    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	      var _constructor = this.constructor,
	          attrs = _constructor.attrs,
	          componentStyle = _constructor.componentStyle,
	          warnTooManyClasses = _constructor.warnTooManyClasses;
	
	      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	      // staticaly styled-components don't need to build an execution context object,
	      // and shouldn't be increasing the number of class names
	      if (componentStyle.isStatic && attrs === undefined) {
	        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	      } else {
	        var executionContext = this.buildExecutionContext(theme, props);
	        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	        if (false) {
	          warnTooManyClasses(className);
	        }
	
	        return className;
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var componentStyle = this.constructor.componentStyle;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	
	      // If this is a staticaly-styled component, we don't need to the theme
	      // to generate or build styles.
	      if (componentStyle.isStatic) {
	        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	        this.setState({ generatedClassName: generatedClassName });
	        // If there is a theme in the context, subscribe to the event emitter. This
	        // is necessary due to pure components blocking context updates, this circumvents
	        // that by updating when an event is emitted
	      } else if (styledContext !== undefined) {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          // This will be called once immediately
	          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	        });
	      } else {
	        // eslint-disable-next-line react/prop-types
	        var theme = this.props.theme || {};
	        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	        this.setState({ theme: theme, generatedClassName: _generatedClassName });
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      // If this is a statically-styled component, we don't need to listen to
	      // props changes to update styles
	      var componentStyle = this.constructor.componentStyle;
	
	      if (componentStyle.isStatic) {
	        return;
	      }
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
	        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	        return { theme: theme, generatedClassName: generatedClassName };
	      });
	    };
	
	    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.unsubscribeFromContext();
	    };
	
	    BaseStyledComponent.prototype.render = function render() {
	      var _this4 = this;
	
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var generatedClassName = this.state.generatedClassName;
	      var _constructor2 = this.constructor,
	          styledComponentId = _constructor2.styledComponentId,
	          target = _constructor2.target;
	
	
	      var isTargetTag = isTag(target);
	
	      var className = [
	      // eslint-disable-next-line react/prop-types
	      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	      var baseProps = _extends({}, this.attrs, {
	        className: className
	      });
	
	      if (isStyledComponent(target)) {
	        baseProps.innerRef = innerRef;
	      } else {
	        baseProps.ref = innerRef;
	      }
	
	      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
	        // Don't pass through non HTML tags through to HTML elements
	        // always omit innerRef
	        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
	          // eslint-disable-next-line no-param-reassign
	          acc[propName] = _this4.props[propName];
	        }
	
	        return acc;
	      }, baseProps);
	
	      return React.createElement(target, propsForElement);
	    };
	
	    return BaseStyledComponent;
	  }(React.Component);
	
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _StyledComponent$cont;
	
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = PropTypes.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) hoist(StyledComponent, target);
	
	    // we do this after hoisting to ensure we're overwriting existing
	    // rules when wrapping another styled component class
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.target = target;
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	});
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      var value = attrs[key];
	      if (typeof value === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        var css = stringifyRules(flatCSS, '.' + name);
	        styleSheet.inject(this.componentId, css, name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	});
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	var _styled = (function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	});
	
	// 
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = (function (nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	});
	
	// 
	var _injectGlobal = (function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	});
	
	// 
	var _constructWithOptions = (function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new Error( false ? 'Cannot create styled-component for component: ' + String(tag) : '');
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || {}, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	});
	
	// 
	/* globals ReactClass */
	
	var wrapWithTheme = function wrapWithTheme(Component$$1) {
	  var _WithTheme$contextTyp;
	
	  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
	  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component$$1, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.displayName = 'WithTheme(' + componentName + ')';
	  WithTheme.styledComponentId = 'withTheme';
	  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = PropTypes.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);
	
	
	  return hoist(WithTheme, Component$$1);
	};
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Import singletons */
	/* Import singleton constructors */
	/* Import components */
	/* Import Higher Order Components */
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports['default'] = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = wrapWithTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)(module)))

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)(module)))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 169 /* <at>i */
		var CHARSET = 163 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								code = body.charCodeAt(caret)
	
								switch (code) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first + second) {
									case NULL: {
										break
									}
									case IMPORT:
									case CHARSET: {
										flat += chars + body.charAt(caret)
										break
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON)
											break
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					return out.charCodeAt(8) === DASH ? webkit + out + out : out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
	
			switch (out) {
				case void 0:
				case false:
				case true:
				case null:
				case content: {
					break
				}
				default: {
					return out
				}
			}
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					switch (plugin.constructor) {
						case Array: {
							for (var i = 0, length = plugin.length; i < length; ++i) {
								use(plugin[i])
							}
							break
						}
						case Function: {
							plugins[plugged++] = plugin
							break
						}
						case Boolean: {
							unkwn = !!plugin|0
						}
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)(module)))

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: radial-gradient(ellipse at center, #1a5276, #11354c);\n  padding: 4em 0;\n  minheight: 10rem;\n  color: white;\n  display: \'block\';\n  width: 100%;\n'], ['\n  background: radial-gradient(ellipse at center, #1a5276, #11354c);\n  padding: 4em 0;\n  minheight: 10rem;\n  color: white;\n  display: \'block\';\n  width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  margin: 0;\n  font-weight: 800;\n\n  .children {\n    font-weight: 400;\n  }\n\n  li {\n    line-height: 1.3rem;\n    margin-bottom: 1rem;\n  }\n\n  a {\n    color: white;\n    border-bottom: 1px solid transparent;\n  }\n\n  a:hover,\n  a:focus {\n    color: white;\n    border-bottom: 1px dashed rgba(255, 255, 255, 0.29);\n  }\n'], ['\n  list-style: none;\n  margin: 0;\n  font-weight: 800;\n\n  .children {\n    font-weight: 400;\n  }\n\n  li {\n    line-height: 1.3rem;\n    margin-bottom: 1rem;\n  }\n\n  a {\n    color: white;\n    border-bottom: 1px solid transparent;\n  }\n\n  a:hover,\n  a:focus {\n    color: white;\n    border-bottom: 1px dashed rgba(255, 255, 255, 0.29);\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 0.5rem;\n  & span {\n    display: block;\n  }\n'], ['\n  margin-top: 0.5rem;\n  & span {\n    display: block;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  border-bottom: 1px solid rgba(255, 255, 255, 0.29);\n'], ['\n  border-bottom: 1px solid rgba(255, 255, 255, 0.29);\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  a,\n  a:hover,\n  a:focus {\n    color: white;\n  }\n'], ['\n  a,\n  a:hover,\n  a:focus {\n    color: white;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 150px;\n  height: 100px;\n  margin-top: 1rem;\n'], ['\n  display: block;\n  width: 150px;\n  height: 100px;\n  margin-top: 1rem;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  text-decoration: underline;\n  color: #fff;\n'], ['\n  text-decoration: underline;\n  color: #fff;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamor = __webpack_require__(203);
	
	var _htmlReactParser = __webpack_require__(29);
	
	var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);
	
	var _Grid = __webpack_require__(27);
	
	var _Icon = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _trimpath = __webpack_require__(28);
	
	var _trimpath2 = _interopRequireDefault(_trimpath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var listStyle = (0, _glamor.css)({
	  listStyle: 'none',
	  minWidth: '10rem',
	  marginLeft: 0,
	  alignSelf: 'flex-start',
	  color: 'white',
	  marginTop: '1.5rem',
	  paddingLeft: '1rem',
	  paddingRight: '1rem',
	  borderLeft: '1px dashed hsla(0,0%,78%,.5)',
	  '& a': { color: 'white', textDecoration: 'none' },
	  '& a:hover': { textDecoration: 'underline' }
	});
	
	var StyledFooter = _styledComponents2.default.footer(_templateObject);
	
	var footer__logo = (0, _glamor.css)({
	  width: '18em',
	  fontSize: '12px',
	  lineHeight: '.2em',
	  marginTop: 0,
	  textAlign: 'center'
	});
	
	var FooterList = _styledComponents2.default.ul(_templateObject2);
	
	var Address = _styledComponents2.default.p(_templateObject3);
	
	var FooterTitle = _styledComponents2.default.h2(_templateObject4);
	
	var FooterText = _styledComponents2.default.div(_templateObject5);
	
	var TLED = _styledComponents2.default.svg(_templateObject6);
	
	var Report = _styledComponents2.default.a(_templateObject7);
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    StyledFooter,
	    null,
	    _react2.default.createElement(
	      _Grid.Grid,
	      { style: { maxWidth: '960px' } },
	      _react2.default.createElement(
	        _Grid.GridCell,
	        { span: '6', phone: '4', tablet: '8' },
	        _react2.default.createElement(
	          FooterList,
	          null,
	          props.listItems.map(function (item, index) {
	            if (item.wordpress_children) {
	              return _react2.default.createElement(
	                'li',
	                { key: 'footerMenu_' + item.url + '_' + index },
	                _react2.default.createElement(
	                  'a',
	                  { href: (0, _trimpath2.default)(item.url) },
	                  item.title
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'children' },
	                  item.wordpress_children.map(function (child) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: child.url },
	                      _react2.default.createElement(
	                        'a',
	                        { href: (0, _trimpath2.default)(child.url) },
	                        child.title
	                      )
	                    );
	                  })
	                )
	              );
	            }
	            return _react2.default.createElement(
	              'li',
	              { key: 'footerMenu_' + item.url + '_' + index },
	              _react2.default.createElement(
	                'a',
	                { href: (0, _trimpath2.default)(item.url) },
	                item.title
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Grid.GridCell,
	        { span: '6', phone: '4', tablet: '8' },
	        _react2.default.createElement(
	          FooterTitle,
	          null,
	          props.text.edges[0].node.title
	        ),
	        _react2.default.createElement(
	          FooterText,
	          null,
	          (0, _htmlReactParser2.default)(props.text.edges[0].node.content)
	        )
	      ),
	      _react2.default.createElement(
	        _Grid.GridCell,
	        { span: '6' },
	        _react2.default.createElement(
	          TLED,
	          { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 415.3 228.7' },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Teaching and Learning Excellence Division Logo'
	          ),
	          _react2.default.createElement(
	            'g',
	            { fill: 'white' },
	            _react2.default.createElement('path', { d: 'M145.7 133.6c-18.7-15.4-37.3-30.8-56-46.2 1.8-10 3.5-20 5.3-30.1 29.9-7.5 59.7-14.9 89.6-22.4 0 .1.1.1.1.2C161.8 50.4 139 65.6 116 81c10 17.5 20 35 29.9 52.5-.1 0-.1.1-.2.1z' }),
	            _react2.default.createElement('path', { d: 'M30.1 135.5c1.9-4.1 3.9-8.2 5.9-12.3 7.8-16.1 15.6-32.2 23.3-48.3.2-.4.3-.7.5-1.2-14.1-9.3-28.3-18.6-42.4-27.9 0-.1.1-.2.1-.3 21.3 4.3 42.7 8.6 64.2 13-.9 7.4-1.9 14.7-2.8 22-11.1 12.6-22.2 25.2-33.2 37.8-5.1 5.8-10.3 11.6-15.4 17.4l-.2-.2z' }),
	            _react2.default.createElement('path', { d: 'M146.8 142.5c-.4-.1-.8-.2-1.2-.4-18.3-9-36.5-18-54.8-27.1-2-1-3.8-1.3-6.1-.7-12.2 3-24.5 5.8-36.8 8.7-.3.1-.5.1-.9 0 14.3-8.9 28.5-17.8 42.8-26.7 2.9 2.4 5.8 4.7 8.7 7 15.8 12.9 31.6 25.7 47.4 38.6.4.1.7.4.9.6z' }),
	            _react2.default.createElement('path', { d: 'M87.6 11.7c9.6 9.2 19.1 18.3 28.7 27.5-11.1 2.8-22 5.6-33.1 8.4 1.4-12 2.9-23.8 4.4-35.9z' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { fill: 'white' },
	            _react2.default.createElement('path', { d: 'M243.4 130.8h-25.7c.7-.8 1.4-1.5 2-2.2 1.7-1.8 2.2-3.9 1.3-6.3-2.1-5.6-4.1-11.1-6.2-16.7-1-2.7-2-5.4-3.1-8.1h-32.8l-3.6 8.7c-1.7 4-3.4 8-5 12-.6 1.7-1 3.5-1.3 5.3-.3 2.3.8 4.1 2.4 5.7.5.5 1 .9 1.6 1.5h-20.9v-.2c4.4-3 6.4-7.7 8.3-12.4 8.5-21.3 17-42.7 25.4-64.1.7-1.9 1.2-4 1.5-6 .5-2.6-.8-4.5-2.9-6.1h20.2c1.3 3.4 2.6 6.9 3.9 10.4 8 21.2 15.9 42.5 24 63.7 2.4 5.8 5.6 10.9 10.9 14.8zm-61.1-42.3h26.2c-4.2-11.4-8.3-22.7-12.5-34.3-4.6 11.6-9.1 22.9-13.7 34.3z' }),
	            _react2.default.createElement('path', { d: 'M383.9 43.1v14.1c-.3-.1-.5-.2-.7-.3-6.8-3.4-13.9-5.9-21.6-5.9-9.5.1-17.9 3.1-24.4 10.3-4.1 4.5-6.4 9.8-7.4 15.7-1.4 8.4-.8 16.6 2.4 24.5 5.2 13 16.7 20.2 31 20.1 8.5-.1 16.1-2.7 23.5-6.6 1.5-.8 3-1.6 4.8-2.6-2.3 5.5-4.5 10.8-6.6 16-13.9 4.9-27.9 6-41.9.7-15.8-6-25.3-17.3-28.4-34-5.1-26.9 13.4-47 31.1-52.8 8.9-3 18-3.7 27.3-1.8 3.5.7 7 1.5 10.5 2.3 0 .1.2.2.4.3zM305.2 42.9v14.3c-.6-.3-1.2-.5-1.7-.8-5.2-2.6-10.5-4.6-16.3-5.3-16-1.8-29.7 6-34.7 20.3-1.9 5.4-2.2 10.9-1.9 16.6.4 6.5 1.8 12.7 5.2 18.3 6 9.6 14.7 14.6 25.9 15.3 7 .5 13.6-1.1 19.9-3.8 3.6-1.6 7.1-3.3 10.7-5-2.1 5.1-4.2 10.3-6.3 15.6-4.6 1.7-9.4 3-14.3 3.7-12.5 1.8-24.3-.3-35.2-6.5-9.1-5.1-15.5-12.8-18.8-22.6-6.1-18.2-2.8-34.6 10.4-48.7 7.4-7.9 16.6-12.4 27.2-14.1 10.3-1.6 20.1-.1 29.9 2.7z' }),
	            _react2.default.createElement(
	              'g',
	              { stroke: 'white' },
	              _react2.default.createElement('path', { d: 'M203.4 168.2c-2.6-4.1-2.5-7.3.5-9 2.8-1.7 6.6-.8 8 1.8 1.7 3.1.3 5.7-4.4 8 .8.8 1.5 1.6 2.3 2.4.8.8 1.6 1.6 2.5 2.6.9-1.7 1.7-3.2 2.6-4.8.6.3 1.3.6 2.1 1-1 1.9-2 3.6-3.2 5.7 1.2 1.1 2.6 2.2 4 3.4-.8.7-1.4 1.1-2.1 1.6-1.1-1.2-2.2-2.3-3.3-3.5-.6.5-1.1.9-1.5 1.3-2.6 2-5.4 2.6-8.6 1.6-2.1-.7-3.5-2.2-3.9-4.4-.4-2.3.2-4.3 2.1-5.8.9-.8 1.9-1.3 2.9-1.9zm7.5 7.5c-2.1-1.9-4.1-3.7-6.2-5.7-.6.3-1.5.8-2.2 1.4-1.2 1-1.8 2.3-1.5 3.9.4 1.7 1.5 2.7 3.1 3.1 2.7.6 4.8-.6 6.8-2.7zm-4.7-8c1.1-.8 2.3-1.4 3.2-2.3 1-1 1-2.6.2-3.7-.7-1.1-2.2-1.6-3.6-1.1-1.3.4-2.1 1.6-2.1 3 0 1.6 1.1 2.7 2.3 4.1z' }),
	              _react2.default.createElement('path', { d: 'M348.4 205.7c0-6.5 4.7-11.3 11.2-11.3 6.3 0 10.9 4.8 10.9 11.3 0 6.5-4.8 11.3-11.3 11.2-6.2 0-10.8-4.8-10.8-11.2zm2.6-.3c0 6.1 5.1 10.3 10.5 9 3.3-.8 5.4-3 6.2-6.2.9-3.5.2-6.8-2.5-9.3-2.6-2.4-5.8-2.9-9-1.5-3.7 1.5-5.1 4.5-5.2 8z' }),
	              _react2.default.createElement('path', { d: 'M359.9 162.8v17.6h-2.3V159h2.3c4.3 5.5 8.8 11.2 13.4 17.1V159h2.4v21.5h-2c-4.5-5.9-9-11.7-13.8-17.7zM186.4 212.1v-17.2h2.3v21.5h-2c-4.5-5.8-9-11.5-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.9 11.2 13.5 17.2zM392 194.9h2.4v21.5h-2c-4.5-5.7-9-11.5-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.8 11.3 13.4 17.1v-17.1zM142 162.8v17.6h-2.3v-21.5h2.3c4.4 5.6 8.8 11.2 13.4 17.1v-17.1h2.4v21.5h-2c-4.5-5.8-9-11.5-13.8-17.6zM340.7 180.4h-2c-4.5-5.8-9.1-11.6-13.7-17.5v17.5h-2.4v-21.5h2.3c4.4 5.6 8.8 11.3 13.4 17.1v-17.1h2.4v21.5z' }),
	              _react2.default.createElement('path', { d: 'M251.2 194.7c3.4.1 6.8 0 10.2.5 5.1.7 8.7 5.1 8.8 10.1.2 5.6-3.5 10.2-8.8 10.9-3.3.4-6.8.1-10.2.1v-21.6zm2.4 19.3c2.2 0 4.3.1 6.4 0 3.6-.2 6.5-2.8 7.3-6.4.9-3.6-.6-7.3-3.6-9.2-3.2-2-6.7-1.2-10.1-1.4v17z' }),
	              _react2.default.createElement('path', { d: 'M307.8 172.1h-6.2v8.3h-2.4v-21.7c3.9.1 7.7 0 11.6.4 3.3.3 5.3 2.7 5.5 5.6.2 3.5-1.3 5.6-4.8 6.7-.3.1-.5.2-.8.3 2.2 2.9 4.3 5.7 6.5 8.7h-3.1c-2.1-2.8-4.2-5.6-6.3-8.3zm-6.1-2.5c2.8 0 5.5.2 8.2 0 2.4-.2 4-2.1 4-4.2s-1.5-3.9-3.8-4.1c-2.8-.2-5.6-.1-8.4-.1v8.4z' }),
	              _react2.default.createElement('path', { d: 'M181.4 176.5v-5.4H175v-2.2h8.8v8.7c-4.9 4.4-12.6 4.4-16.7 0-4.1-4.3-3.9-12.1.3-16.3 4.1-4 11.4-4.1 15.6-.1-.5.6-1 1.2-1.5 1.9-2.4-2.1-5.1-2.9-8.2-2.3-2 .3-3.5 1.4-4.7 3-2.8 3.6-2.4 9.4.8 12.5 2.9 3.1 8.1 3.2 12 .2z' }),
	              _react2.default.createElement('path', { d: 'M400.7 161.3l-1.5 1.8c-5-4.1-10.4-2.5-12.8.5-2.8 3.5-2.7 9.4.3 12.6 3.1 3.3 8.4 3.4 12.3.3v-5.4h-6.5v-2.2h8.8v8.6c-4.4 4.4-12.4 4.5-16.6.3-4.3-4.4-4.1-12.3.3-16.6 4.2-3.9 11.8-3.9 15.7.1z' }),
	              _react2.default.createElement('path', { d: 'M37.4 194.9v2.2H24.3v7.3H36v2.2H24.2v7.6h13.3v2.2H21.7v-21.5h15.7z' }),
	              _react2.default.createElement('path', { d: 'M90.7 204.4h11.8v2.1H90.8v7.6h13.3v2.2H88.3v-21.4h15.6v2.1H90.8c-.1 2.5-.1 4.9-.1 7.4z' }),
	              _react2.default.createElement('path', { d: 'M151.7 206.5v7.6H165v2.3h-15.8v-21.5h15.6v2.2h-13.1v7.2h11.8v2.2h-11.8z' }),
	              _react2.default.createElement('path', { d: 'M233.5 204.3v2.2h-11.8v7.6H235v2.2h-15.8v-21.5h15.6v2.2h-13.1v7.2c3.9.1 7.8.1 11.8.1zM252.4 180.4V159H268v2.1h-13.1v7.3h11.7v2.2h-11.7v7.6h13.3v2.2h-15.8z' }),
	              _react2.default.createElement('path', { d: 'M52 158.9v2.2H38.9v7.3h11.7v2.2H38.8v7.6h13.3v2.2H36.3v-21.5H52z' }),
	              _react2.default.createElement('path', { d: 'M277.2 174.7c-.8 1.9-1.7 3.7-2.5 5.7h-2.6c3.3-7.3 6.6-14.5 9.9-21.8h2.4c3.3 7.2 6.6 14.5 9.9 21.8h-2.7c-.8-1.8-1.7-3.7-2.5-5.7h-11.9zm10.8-2.3c-1.6-3.6-3.2-7.1-4.9-10.9-1.7 3.8-3.3 7.3-4.9 10.9h9.8zM65.9 158.6h2.4c3.3 7.2 6.5 14.4 9.9 21.8h-2.7c-.8-1.8-1.7-3.7-2.5-5.6H61.3c-.8 1.9-1.7 3.8-2.6 5.7h-2.6c3.3-7.4 6.5-14.6 9.8-21.9zm6.1 13.8c-1.6-3.6-3.2-7.1-4.9-10.9-1.7 3.8-3.3 7.3-4.9 10.9H72z' }),
	              _react2.default.createElement('path', { d: 'M120.5 170.7H108v9.6h-2.4v-21.5h2.3v9.4h12.5v-9.4h2.5v21.5h-2.3c-.1-3.1-.1-6.3-.1-9.6z' }),
	              _react2.default.createElement('path', { d: 'M317.6 213.2c.6-.7 1.1-1.3 1.6-1.9 1.9 1.7 4.1 2.9 6.6 3 1.5.1 2.9-.1 4.1-1 2-1.5 1.9-4.3-.4-5.4-1.4-.7-2.9-1-4.4-1.4-1.1-.4-2.3-.7-3.4-1.1-1.9-.8-3.1-2.2-3.2-4.5-.1-2.5.9-4.3 3-5.4 3.1-1.6 6.2-1.2 9.2.1.8.4 1.6.9 2.5 1.5-.5.7-1 1.4-1.5 2-2.3-1.7-4.7-2.7-7.5-2.2-1.3.3-2.4.9-3 2.1-.6 1.4-.2 3.1 1.3 3.8 1.3.7 2.8 1 4.3 1.5 1.2.4 2.5.7 3.7 1.2 2 .9 3.2 2.3 3.3 4.6.1 2.5-.9 4.4-3.1 5.5-4.1 1.9-8 1-11.7-1.4-.4-.2-.8-.6-1.4-1z' }),
	              _react2.default.createElement('path', { d: 'M57.8 194.8h3c-2.7 3.6-5.3 7-8 10.6 2.7 3.6 5.4 7.2 8.2 10.9h-3c-2.2-2.9-4.5-6-6.8-9.1-2.3 3.1-4.6 6.2-6.9 9.2h-2.9c2.8-3.7 5.5-7.3 8.3-11-2.6-3.5-5.2-6.9-7.9-10.5h3c2.1 2.8 4.3 5.7 6.5 8.7 2.2-2.9 4.4-5.8 6.5-8.8zM99 175.5l1.5 1.5c-2.9 4.5-10.7 5.3-15.4 1.7-5-3.9-5.6-12.1-1.2-16.9 4.3-4.7 12.1-4.6 16.5.1-.5.6-1.1 1.2-1.7 1.8-2.3-2.2-4.9-3.4-8.1-2.9-1.9.3-3.5 1.2-4.8 2.7-3.1 3.6-2.9 9.2.2 12.6 2.6 2.7 8 4.2 13-.6zM81.7 211.5c.5.5 1 1 1.5 1.4-1.9 3.1-6.9 4.7-11.3 3.7-4.3-1-7.7-4.9-8.2-9.6-.5-5.2 2-9.8 6.4-11.8 4.3-2 9.7-.9 13 2.6-.5.6-1.1 1.2-1.7 1.8-2.3-2.3-5-3.4-8.2-2.9-2 .3-3.7 1.3-4.9 2.9-2.9 3.6-2.6 9.2.6 12.5 2.6 2.8 8 4.1 12.8-.6z' }),
	              _react2.default.createElement('path', { d: 'M214.3 197.8c-.6.6-1.1 1.2-1.7 1.8-4.9-4.6-10.1-3.2-12.7-.5-3.3 3.4-3.3 9.3-.2 12.8 2.8 3.1 8.3 4.2 13.1-.5.5.6.9 1.2 1.4 1.8-3.5 4.5-11 5.1-15.6 1.2-4.8-4.2-5.1-12.2-.6-16.9 4.2-4.4 11.9-4.3 16.3.3zM295.4 216.6h-2.3c-3.1-7.2-6.2-14.5-9.3-21.8h2.8c2.5 6 5 12.1 7.7 18.5 2.6-6.3 5.1-12.4 7.7-18.5h2.7c-3.1 7.4-6.2 14.6-9.3 21.8z' }),
	              _react2.default.createElement('path', { d: 'M23.7 180.4h-2.5v-19.3h-7.3v-2.2h17v2.2h-7.2v19.3z' }),
	              _react2.default.createElement('path', { d: 'M232.5 158.9h2.4v19.3h12.2v2.2h-14.6v-21.5z' }),
	              _react2.default.createElement('path', { d: 'M124.2 214.1v2.3h-14.6v-21.5h2.4v19.2h12.2zM144.1 214.1v2.3h-14.6v-21.5h2.4v19.2h12.2z' }),
	              _react2.default.createElement('path', { d: 'M348 158.9h2.3v21.5H348v-21.5zM276.4 194.9h2.3v21.5h-2.3v-21.5zM312.1 216.4h-2.3v-21.5h2.3v21.5zM340 194.9h2.3v21.5H340v-21.5zM132.3 180.4H130v-21.5h2.3v21.5z' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Address,
	          null,
	          'Austin Community College District',
	          _react2.default.createElement('br', null),
	          '5930 Middle Fiskville Rd.',
	          _react2.default.createElement('br', null),
	          'Austin, Texas 78752',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: 'tel' },
	            '512-223-4ACC (4222)'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            Report,
	            {
	              href: 'https://fs7.formsite.com/accids/8fvbxzfirh/index.html',
	              target: '_blank',
	              rel: 'noopener noreferrer'
	            },
	            'Report issues and errors found in the ACC Catalog'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	
	// <div className={footer__container}>
	//     <div>
	//       <ul className={listStyle}>
	//         <li><Link to="http://www.austincc.edu/discover">About ACC</Link></li>
	//         <li><Link to="http://www.austincc.edu/police">Campus Police</Link></li>
	//         <li><Link to="http://www.austincc.edu/emergency-notifications">Emergency Information</Link></li>
	//       </ul>
	//     </div>
	//     <div>
	//       <ul className={listStyle}>
	//         <li><Link to="http://www.austincc.edu/calendars/Linkcademic-calendar">Academic Calendar</Link></li>
	//         <li ><Link to="http://www.austincc.edu/degrees-and-certificates/explore-educational-choices/Linkreas-of-study/programs-a-z">Academic &amp; Career Programs</Link></li>
	//       </ul>
	//     </div>
	//     <div>
	//       <ul className={listStyle}>
	//         <li><Link to="http://www.austincc.edu/Linkpply-and-register/Linkdmission-steps">Admissions</Link></li>
	//         <li><Link to="http://www.austincc.edu/locations/campuses">Campus Locations</Link></li>
	//       </ul>
	//     </div>
	//     <div >
	//       <div>
	//
	//       </div>
	//       <div>
	//
	//       </div>
	//     </div>
	//   </div>
	
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamor = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var get_started__container = (0, _glamor.css)({
	  background: 'radial-gradient(at center center, rgb(91, 44, 111), rgb(61, 30, 74))',
	  height: '13em',
	  paddingBottom: '3em'
	});
	var get_started__title = (0, _glamor.css)({
	  color: 'white',
	  textAlign: 'center',
	  paddingTop: '1em',
	  textTransform: 'uppercase',
	  fontWeight: 700,
	  display: 'block',
	  letterSpacing: '1px',
	  fontSize: '3.35em',
	  marginTop: 0,
	  textShadow: '2px 2px 0 #3D1E4A'
	});
	var button_group = (0, _glamor.css)({
	  display: 'flex',
	  justifyContent: 'center',
	  alignItems: 'flex-start'
	
	});
	var button = (0, _glamor.css)({
	  backgroundColor: '#5b2c6f',
	  letterSpacing: '0.5px',
	  textAlign: 'center',
	  color: 'white',
	  border: '1px solid #BDBDBD',
	  transition: 'background 200ms',
	  fontWeight: '400',
	  padding: '0 2rem',
	  borderRadius: '2px',
	  fontFamily: "'Montserrat', sans-serif",
	  textDecoration: 'none',
	  textTransform: 'uppercase',
	  margin: '0em 1em 2em 1em',
	  boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
	  height: '54px',
	  display: 'inline-flex',
	  justifyContent: 'center',
	  alignItems: 'center',
	  ':hover': { boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)', backgroundColor: 'white', color: 'rgb(61, 30, 74)' }
	});
	var GetStarted = function GetStarted() {
	  return _react2.default.createElement(
	    'div',
	    { className: get_started__container },
	    _react2.default.createElement(
	      'h3',
	      { className: get_started__title },
	      'Get Started'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: button_group },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://austincc.elluciancrmrecruit.com/Admissions/Pages/createaccount.aspx?f=02858ff2-646e-45b6-a474-16e71e2445d0&o=be123df8-a9b8-4a76-993b-6e7223cda83a',
	          className: button },
	        'Apply Now'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://austincc.elluciancrmrecruit.com/Admissions/Pages/prospectinquiry.aspx?f=c85fc4a9-caad-4b56-8280-91905eed6a7a&o=87a85a1b-89ce-480f-b3dc-82b37657599f',
	          className: button },
	        'Request Info'
	      )
	    )
	  );
	};
	exports.default = GetStarted;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  font-weight: 400;\n"], ["\n  font-size: 1rem;\n  font-weight: 400;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: #ffd521;\n  color: black;\n  padding: 5px;\n  position: absolute;\n  left: 0;\n  top: -999em;\n  right: 0;\n  z-index: 999;\n  border-bottom: 1px solid rgba(0,0,0,0.5);\n\n  &:focus {\n    top: 0;\n    color: #05243a;\n  }\n"], ["\n  background: #ffd521;\n  color: black;\n  padding: 5px;\n  position: absolute;\n  left: 0;\n  top: -999em;\n  right: 0;\n  z-index: 999;\n  border-bottom: 1px solid rgba(0,0,0,0.5);\n\n  &:focus {\n    top: 0;\n    color: #05243a;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: white;\n}\n::-moz-placeholder { /* Firefox 19+ */\n  color: white;\n}\n:-ms-input-placeholder { /* IE 10+ */\n  color: white;\n}\n:-moz-placeholder { /* Firefox 18- */\n  color: white;\n}\n"], ["\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: white;\n}\n::-moz-placeholder { /* Firefox 19+ */\n  color: white;\n}\n:-ms-input-placeholder { /* IE 10+ */\n  color: white;\n}\n:-moz-placeholder { /* Firefox 18- */\n  color: white;\n}\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TopAppBar = __webpack_require__(744);
	
	var _Icon = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SiteTitle = _styledComponents2.default.h1(_templateObject);
	
	var SkipToMain = _styledComponents2.default.a(_templateObject2);
	
	var letter = {
	  fill: "#fff"
	};
	
	var TitleBar = function TitleBar(props) {
	  return _react2.default.createElement(
	    _TopAppBar.TopAppBar,
	    { className: "app__top-app-bar", style: { backgroundColor: '#4d4d4d', position: 'static' } },
	    _react2.default.createElement(
	      SkipToMain,
	      { href: "#main" },
	      "Skip to Main Content"
	    ),
	    _react2.default.createElement(
	      _TopAppBar.TopAppBarRow,
	      null,
	      _react2.default.createElement(
	        _TopAppBar.TopAppBarSection,
	        { alignStart: true },
	        _react2.default.createElement(
	          "a",
	          { href: "http://www.austincc.edu" },
	          _react2.default.createElement(
	            "svg",
	            {
	              version: "1.1",
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 288 100",
	              style: {
	                width: "90px",
	                position: "relative",
	                top: "-2px"
	              }
	            },
	            _react2.default.createElement(
	              "title",
	              null,
	              "Austin Community College"
	            ),
	            _react2.default.createElement(
	              "g",
	              { className: "star" },
	              _react2.default.createElement("path", {
	                style: { fill: "#009B7C" },
	                d: "M52.8,32.6L56,8.1l19.3,18.8"
	              }),
	              _react2.default.createElement("path", {
	                style: { fill: "#007AC2" },
	                d: "M57.4,59.8l3.5-20.6l61.5-15.4L75.3,55.5l20.6,36.1"
	              }),
	              _react2.default.createElement("path", {
	                style: { fill: "#EF3E42" },
	                d: "M37,50.4L7.6,31.1l44.3,9l-1.9,15L16.4,93.2"
	              }),
	              _react2.default.createElement("path", {
	                style: { fill: "#FFD520" },
	                d: "M28,84.3l29.3-18.6l39.5,32.1L56.1,77.7"
	              })
	            ),
	            _react2.default.createElement(
	              "g",
	              { className: "text small" },
	              _react2.default.createElement("path", {
	                style: letter,
	                d: "M118.9,66.6c-1.9,4.6-3.8,9.1-5.7,13.7c-0.4,0.8-0.6,1.7-0.8,2.6c-0.4,2,0,3.8,1.6,5.3c0.2,0.2,0.6,0.4,0.6,0.9c-4.6,0-9.2,0-14.1,0c4.4-3.9,5.8-9,7.8-13.9c5.2-12.9,10.3-25.9,15.4-38.9c0.1-0.3,0.2-0.5,0.3-0.8c0.8-2.5,1.4-5-1.6-7.2c5,0,9.5,0,14.1,0c0.5,0.4,0.6,1.1,0.8,1.7c6,15.9,12,31.8,18,47.7c1.5,4.1,3.6,7.9,7,10.7c0.1,0.1,0.3,0.2,0.2,0.6c-5.6,0-11.2,0-17,0c0.2-0.8,0.9-1.2,1.3-1.7c0.9-1.1,1.3-2.3,0.8-3.8c-1.3-4-2.9-7.9-4.4-11.8c-0.6-1.7-1.3-3.4-2-5.2C133.8,66.6,126.4,66.6,118.9,66.6z M138.8,60.1c-2.8-7.6-5.5-15-8.2-22.5c-0.1,0-0.3,0-0.4,0c-3,7.4-5.9,14.9-9,22.5C127.3,60.1,132.9,60.1,138.8,60.1z"
	              }),
	              _react2.default.createElement("path", {
	                style: letter,
	                d: "M205.1,29.2c0,3.2,0,6.4,0,9.8c-0.9-0.4-1.6-0.7-2.3-1c-3.9-1.9-7.9-3.1-12.3-3.2c-11.5-0.3-20,6.6-22.1,16.7c-1.3,6.4-0.9,12.8,1.9,18.9c4.1,8.9,13.2,13.5,22.8,12.5c5.5-0.6,10.4-2.7,15.2-5.2c0.5-0.3,0.9-0.7,1.8-0.6c-1.4,3.6-2.8,7.1-4.3,10.7c-3.1,1.2-6.3,2-9.5,2.5c-8.2,1.2-16.1,0-23.5-3.9c-8.7-4.6-13.8-12-15.3-21.6c-2.1-13,2.4-23.6,12.8-31.6c4.9-3.8,10.7-5.7,16.9-6.2c5.5-0.5,10.9,0.2,16.2,1.7C204,28.7,204.5,28.8,205.1,29.2z"
	              }),
	              _react2.default.createElement("path", {
	                style: letter,
	                d: "M259.3,29.2c0,3.2,0,6.4,0,9.8c-0.9-0.4-1.6-0.7-2.3-1c-3.9-1.9-7.9-3.1-12.3-3.2c-11.5-0.3-20,6.6-22.1,16.7c-1.3,6.4-0.9,12.8,1.9,18.9c4.1,8.9,13.2,13.5,22.8,12.5c5.5-0.6,10.4-2.7,15.2-5.2c0.5-0.3,0.9-0.7,1.8-0.6c-1.4,3.6-2.8,7.1-4.3,10.7c-3.1,1.2-6.3,2-9.5,2.5c-8.2,1.2-16.1,0-23.5-3.9c-8.7-4.6-13.8-12-15.3-21.6c-2.1-13,2.4-23.6,12.8-31.6c4.9-3.8,10.7-5.7,16.9-6.2c5.5-0.5,10.9,0.2,16.2,1.7C258.2,28.7,258.7,28.8,259.3,29.2z"
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _TopAppBar.TopAppBarTitle,
	          { style: { fontWeight: "normal" } },
	          _react2.default.createElement(
	            "a",
	            { href: "/", style: { color: "white" } },
	            props.title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _TopAppBar.TopAppBarSection,
	        { alignEnd: true },
	        _react2.default.createElement(
	          "form",
	          {
	            id: "searchForm",
	            className: "searchForm expanded",
	            action: "/search/",
	            method: "get"
	          },
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "searchFormInput", className: "show-for-sr" },
	            "Search Input"
	          ),
	          _react2.default.createElement(Input, {
	            type: "text",
	            name: "q",
	            id: "searchFormInput",
	            placeholder: "search"
	          }),
	          _react2.default.createElement(
	            "button",
	            { type: "submit" },
	            _react2.default.createElement(
	              "span",
	              null,
	              "Search"
	            ),
	            _react2.default.createElement(
	              "svg",
	              { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
	              _react2.default.createElement("path", {
	                fill: "",
	                d: "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = TitleBar;
	
	
	var Input = _styledComponents2.default.input(_templateObject3);
	module.exports = exports["default"];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(59);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Provider = __webpack_require__(10);
	
	var _TitleBar = __webpack_require__(223);
	
	var _TitleBar2 = _interopRequireDefault(_TitleBar);
	
	var _GetStarted = __webpack_require__(221);
	
	var _GetStarted2 = _interopRequireDefault(_GetStarted);
	
	var _Footer = __webpack_require__(220);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Theme = __webpack_require__(116);
	
	__webpack_require__(315);
	
	__webpack_require__(313);
	
	__webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _Provider.RMWCProvider,
	    { listItemDefaultRipple: true },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ name: 'description', content: 'This catalog is in effect for new students entering ACC in the 2018-2019 academic year and for any ACC student returning in the 2018-2019 academic year whose catalog has expired. It was prepared from existing policies and information obtained from the appropriate ACC officials.' }, { name: 'keywords', content: 'Austin Community College, ACC, Catalog' }]
	    }),
	    _react2.default.createElement(_TitleBar2.default, { title: data.site.siteMetadata.title }),
	    children(),
	    _react2.default.createElement(_GetStarted2.default, null),
	    _react2.default.createElement(_Footer2.default, { listItems: data.FootertMenu.items, text: data.about })
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	'use strict';
	
	function trimpath(url) {
	  // const prefix = 'https://devinstruction.austincc.edu/catalog'
	  var prefix = 'https://devinstruction.austincc.edu/catalog2018-19';
	
	  return url.substr(prefix.length);
	}
	
	module.exports = trimpath;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-437521fa76a1364f8382.js